import { defineComponent as Nt, ref as $e, onMounted as ft, watch as C0, openBlock as pe, createElementBlock as ve, createElementVNode as X, createTextVNode as ot, createCommentVNode as bt, computed as sr, toDisplayString as Se, normalizeClass as gt, normalizeStyle as Ha, getCurrentScope as Ku, onScopeDispose as Xu, unref as Zu, watchEffect as Ju, getCurrentInstance as eo, reactive as to, Fragment as fs, renderList as ro, createBlock as r0, resolveComponent as no } from "vue";
var re = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function so(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Ua = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(re, function() {
    var r = 1e3, n = 6e4, s = 36e5, a = "millisecond", u = "second", o = "minute", f = "hour", c = "day", l = "week", x = "month", d = "quarter", p = "year", h = "date", m = "Invalid Date", E = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function($) {
      var P = ["th", "st", "nd", "rd"], w = $ % 100;
      return "[" + $ + (P[(w - 20) % 10] || P[w] || P[0]) + "]";
    } }, A = function($, P, w) {
      var Q = String($);
      return !Q || Q.length >= P ? $ : "" + Array(P + 1 - Q.length).join(w) + $;
    }, g = { s: A, z: function($) {
      var P = -$.utcOffset(), w = Math.abs(P), Q = Math.floor(w / 60), z = w % 60;
      return (P <= 0 ? "+" : "-") + A(Q, 2, "0") + ":" + A(z, 2, "0");
    }, m: function $(P, w) {
      if (P.date() < w.date()) return -$(w, P);
      var Q = 12 * (w.year() - P.year()) + (w.month() - P.month()), z = P.clone().add(Q, x), j = w - z < 0, K = P.clone().add(Q + (j ? -1 : 1), x);
      return +(-(Q + (w - z) / (j ? z - K : K - z)) || 0);
    }, a: function($) {
      return $ < 0 ? Math.ceil($) || 0 : Math.floor($);
    }, p: function($) {
      return { M: x, y: p, w: l, d: c, D: h, h: f, m: o, s: u, ms: a, Q: d }[$] || String($ || "").toLowerCase().replace(/s$/, "");
    }, u: function($) {
      return $ === void 0;
    } }, N = "en", I = {};
    I[N] = b;
    var B = "$isDayjsObject", y = function($) {
      return $ instanceof M || !(!$ || !$[B]);
    }, Y = function $(P, w, Q) {
      var z;
      if (!P) return N;
      if (typeof P == "string") {
        var j = P.toLowerCase();
        I[j] && (z = j), w && (I[j] = w, z = j);
        var K = P.split("-");
        if (!z && K.length > 1) return $(K[0]);
      } else {
        var R = P.name;
        I[R] = P, z = R;
      }
      return !Q && z && (N = z), z || !Q && N;
    }, S = function($, P) {
      if (y($)) return $.clone();
      var w = typeof P == "object" ? P : {};
      return w.date = $, w.args = arguments, new M(w);
    }, v = g;
    v.l = Y, v.i = y, v.w = function($, P) {
      return S($, { locale: P.$L, utc: P.$u, x: P.$x, $offset: P.$offset });
    };
    var M = function() {
      function $(w) {
        this.$L = Y(w.locale, null, !0), this.parse(w), this.$x = this.$x || w.x || {}, this[B] = !0;
      }
      var P = $.prototype;
      return P.parse = function(w) {
        this.$d = function(Q) {
          var z = Q.date, j = Q.utc;
          if (z === null) return /* @__PURE__ */ new Date(NaN);
          if (v.u(z)) return /* @__PURE__ */ new Date();
          if (z instanceof Date) return new Date(z);
          if (typeof z == "string" && !/Z$/i.test(z)) {
            var K = z.match(E);
            if (K) {
              var R = K[2] - 1 || 0, k = (K[7] || "0").substring(0, 3);
              return j ? new Date(Date.UTC(K[1], R, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, k)) : new Date(K[1], R, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, k);
            }
          }
          return new Date(z);
        }(w), this.init();
      }, P.init = function() {
        var w = this.$d;
        this.$y = w.getFullYear(), this.$M = w.getMonth(), this.$D = w.getDate(), this.$W = w.getDay(), this.$H = w.getHours(), this.$m = w.getMinutes(), this.$s = w.getSeconds(), this.$ms = w.getMilliseconds();
      }, P.$utils = function() {
        return v;
      }, P.isValid = function() {
        return this.$d.toString() !== m;
      }, P.isSame = function(w, Q) {
        var z = S(w);
        return this.startOf(Q) <= z && z <= this.endOf(Q);
      }, P.isAfter = function(w, Q) {
        return S(w) < this.startOf(Q);
      }, P.isBefore = function(w, Q) {
        return this.endOf(Q) < S(w);
      }, P.$g = function(w, Q, z) {
        return v.u(w) ? this[Q] : this.set(z, w);
      }, P.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, P.valueOf = function() {
        return this.$d.getTime();
      }, P.startOf = function(w, Q) {
        var z = this, j = !!v.u(Q) || Q, K = v.p(w), R = function(Ne, de) {
          var Ie = v.w(z.$u ? Date.UTC(z.$y, de, Ne) : new Date(z.$y, de, Ne), z);
          return j ? Ie : Ie.endOf(c);
        }, k = function(Ne, de) {
          return v.w(z.toDate()[Ne].apply(z.toDate("s"), (j ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(de)), z);
        }, q = this.$W, H = this.$M, se = this.$D, ie = "set" + (this.$u ? "UTC" : "");
        switch (K) {
          case p:
            return j ? R(1, 0) : R(31, 11);
          case x:
            return j ? R(1, H) : R(0, H + 1);
          case l:
            var fe = this.$locale().weekStart || 0, te = (q < fe ? q + 7 : q) - fe;
            return R(j ? se - te : se + (6 - te), H);
          case c:
          case h:
            return k(ie + "Hours", 0);
          case f:
            return k(ie + "Minutes", 1);
          case o:
            return k(ie + "Seconds", 2);
          case u:
            return k(ie + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, P.endOf = function(w) {
        return this.startOf(w, !1);
      }, P.$set = function(w, Q) {
        var z, j = v.p(w), K = "set" + (this.$u ? "UTC" : ""), R = (z = {}, z[c] = K + "Date", z[h] = K + "Date", z[x] = K + "Month", z[p] = K + "FullYear", z[f] = K + "Hours", z[o] = K + "Minutes", z[u] = K + "Seconds", z[a] = K + "Milliseconds", z)[j], k = j === c ? this.$D + (Q - this.$W) : Q;
        if (j === x || j === p) {
          var q = this.clone().set(h, 1);
          q.$d[R](k), q.init(), this.$d = q.set(h, Math.min(this.$D, q.daysInMonth())).$d;
        } else R && this.$d[R](k);
        return this.init(), this;
      }, P.set = function(w, Q) {
        return this.clone().$set(w, Q);
      }, P.get = function(w) {
        return this[v.p(w)]();
      }, P.add = function(w, Q) {
        var z, j = this;
        w = Number(w);
        var K = v.p(Q), R = function(H) {
          var se = S(j);
          return v.w(se.date(se.date() + Math.round(H * w)), j);
        };
        if (K === x) return this.set(x, this.$M + w);
        if (K === p) return this.set(p, this.$y + w);
        if (K === c) return R(1);
        if (K === l) return R(7);
        var k = (z = {}, z[o] = n, z[f] = s, z[u] = r, z)[K] || 1, q = this.$d.getTime() + w * k;
        return v.w(q, this);
      }, P.subtract = function(w, Q) {
        return this.add(-1 * w, Q);
      }, P.format = function(w) {
        var Q = this, z = this.$locale();
        if (!this.isValid()) return z.invalidDate || m;
        var j = w || "YYYY-MM-DDTHH:mm:ssZ", K = v.z(this), R = this.$H, k = this.$m, q = this.$M, H = z.weekdays, se = z.months, ie = z.meridiem, fe = function(de, Ie, ye, xe) {
          return de && (de[Ie] || de(Q, j)) || ye[Ie].slice(0, xe);
        }, te = function(de) {
          return v.s(R % 12 || 12, de, "0");
        }, Ne = ie || function(de, Ie, ye) {
          var xe = de < 12 ? "AM" : "PM";
          return ye ? xe.toLowerCase() : xe;
        };
        return j.replace(D, function(de, Ie) {
          return Ie || function(ye) {
            switch (ye) {
              case "YY":
                return String(Q.$y).slice(-2);
              case "YYYY":
                return v.s(Q.$y, 4, "0");
              case "M":
                return q + 1;
              case "MM":
                return v.s(q + 1, 2, "0");
              case "MMM":
                return fe(z.monthsShort, q, se, 3);
              case "MMMM":
                return fe(se, q);
              case "D":
                return Q.$D;
              case "DD":
                return v.s(Q.$D, 2, "0");
              case "d":
                return String(Q.$W);
              case "dd":
                return fe(z.weekdaysMin, Q.$W, H, 2);
              case "ddd":
                return fe(z.weekdaysShort, Q.$W, H, 3);
              case "dddd":
                return H[Q.$W];
              case "H":
                return String(R);
              case "HH":
                return v.s(R, 2, "0");
              case "h":
                return te(1);
              case "hh":
                return te(2);
              case "a":
                return Ne(R, k, !0);
              case "A":
                return Ne(R, k, !1);
              case "m":
                return String(k);
              case "mm":
                return v.s(k, 2, "0");
              case "s":
                return String(Q.$s);
              case "ss":
                return v.s(Q.$s, 2, "0");
              case "SSS":
                return v.s(Q.$ms, 3, "0");
              case "Z":
                return K;
            }
            return null;
          }(de) || K.replace(":", "");
        });
      }, P.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, P.diff = function(w, Q, z) {
        var j, K = this, R = v.p(Q), k = S(w), q = (k.utcOffset() - this.utcOffset()) * n, H = this - k, se = function() {
          return v.m(K, k);
        };
        switch (R) {
          case p:
            j = se() / 12;
            break;
          case x:
            j = se();
            break;
          case d:
            j = se() / 3;
            break;
          case l:
            j = (H - q) / 6048e5;
            break;
          case c:
            j = (H - q) / 864e5;
            break;
          case f:
            j = H / s;
            break;
          case o:
            j = H / n;
            break;
          case u:
            j = H / r;
            break;
          default:
            j = H;
        }
        return z ? j : v.a(j);
      }, P.daysInMonth = function() {
        return this.endOf(x).$D;
      }, P.$locale = function() {
        return I[this.$L];
      }, P.locale = function(w, Q) {
        if (!w) return this.$L;
        var z = this.clone(), j = Y(w, Q, !0);
        return j && (z.$L = j), z;
      }, P.clone = function() {
        return v.w(this.$d, this);
      }, P.toDate = function() {
        return new Date(this.valueOf());
      }, P.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, P.toISOString = function() {
        return this.$d.toISOString();
      }, P.toString = function() {
        return this.$d.toUTCString();
      }, $;
    }(), U = M.prototype;
    return S.prototype = U, [["$ms", a], ["$s", u], ["$m", o], ["$H", f], ["$W", c], ["$M", x], ["$y", p], ["$D", h]].forEach(function($) {
      U[$[1]] = function(P) {
        return this.$g(P, $[0], $[1]);
      };
    }), S.extend = function($, P) {
      return $.$i || ($(P, M, S), $.$i = !0), S;
    }, S.locale = Y, S.isDayjs = y, S.unix = function($) {
      return S(1e3 * $);
    }, S.en = I[N], S.Ls = I, S.p = {}, S;
  });
})(Ua);
var ao = Ua.exports;
const Me = /* @__PURE__ */ Mt(ao);
var qa = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(re, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d/, a = /\d\d/, u = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, f = {}, c = function(E) {
      return (E = +E) + (E > 68 ? 1900 : 2e3);
    }, l = function(E) {
      return function(D) {
        this[E] = +D;
      };
    }, x = [/[+-]\d\d:?(\d\d)?|Z/, function(E) {
      (this.zone || (this.zone = {})).offset = function(D) {
        if (!D || D === "Z") return 0;
        var b = D.match(/([+-]|\d\d)/g), A = 60 * b[1] + (+b[2] || 0);
        return A === 0 ? 0 : b[0] === "+" ? -A : A;
      }(E);
    }], d = function(E) {
      var D = f[E];
      return D && (D.indexOf ? D : D.s.concat(D.f));
    }, p = function(E, D) {
      var b, A = f.meridiem;
      if (A) {
        for (var g = 1; g <= 24; g += 1) if (E.indexOf(A(g, 0, D)) > -1) {
          b = g > 12;
          break;
        }
      } else b = E === (D ? "pm" : "PM");
      return b;
    }, h = { A: [o, function(E) {
      this.afternoon = p(E, !1);
    }], a: [o, function(E) {
      this.afternoon = p(E, !0);
    }], Q: [s, function(E) {
      this.month = 3 * (E - 1) + 1;
    }], S: [s, function(E) {
      this.milliseconds = 100 * +E;
    }], SS: [a, function(E) {
      this.milliseconds = 10 * +E;
    }], SSS: [/\d{3}/, function(E) {
      this.milliseconds = +E;
    }], s: [u, l("seconds")], ss: [u, l("seconds")], m: [u, l("minutes")], mm: [u, l("minutes")], H: [u, l("hours")], h: [u, l("hours")], HH: [u, l("hours")], hh: [u, l("hours")], D: [u, l("day")], DD: [a, l("day")], Do: [o, function(E) {
      var D = f.ordinal, b = E.match(/\d+/);
      if (this.day = b[0], D) for (var A = 1; A <= 31; A += 1) D(A).replace(/\[|\]/g, "") === E && (this.day = A);
    }], w: [u, l("week")], ww: [a, l("week")], M: [u, l("month")], MM: [a, l("month")], MMM: [o, function(E) {
      var D = d("months"), b = (d("monthsShort") || D.map(function(A) {
        return A.slice(0, 3);
      })).indexOf(E) + 1;
      if (b < 1) throw new Error();
      this.month = b % 12 || b;
    }], MMMM: [o, function(E) {
      var D = d("months").indexOf(E) + 1;
      if (D < 1) throw new Error();
      this.month = D % 12 || D;
    }], Y: [/[+-]?\d+/, l("year")], YY: [a, function(E) {
      this.year = c(E);
    }], YYYY: [/\d{4}/, l("year")], Z: x, ZZ: x };
    function m(E) {
      var D, b;
      D = E, b = f && f.formats;
      for (var A = (E = D.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(S, v, M) {
        var U = M && M.toUpperCase();
        return v || b[M] || r[M] || b[U].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function($, P, w) {
          return P || w.slice(1);
        });
      })).match(n), g = A.length, N = 0; N < g; N += 1) {
        var I = A[N], B = h[I], y = B && B[0], Y = B && B[1];
        A[N] = Y ? { regex: y, parser: Y } : I.replace(/^\[|\]$/g, "");
      }
      return function(S) {
        for (var v = {}, M = 0, U = 0; M < g; M += 1) {
          var $ = A[M];
          if (typeof $ == "string") U += $.length;
          else {
            var P = $.regex, w = $.parser, Q = S.slice(U), z = P.exec(Q)[0];
            w.call(v, z), S = S.replace(z, "");
          }
        }
        return function(j) {
          var K = j.afternoon;
          if (K !== void 0) {
            var R = j.hours;
            K ? R < 12 && (j.hours += 12) : R === 12 && (j.hours = 0), delete j.afternoon;
          }
        }(v), v;
      };
    }
    return function(E, D, b) {
      b.p.customParseFormat = !0, E && E.parseTwoDigitYear && (c = E.parseTwoDigitYear);
      var A = D.prototype, g = A.parse;
      A.parse = function(N) {
        var I = N.date, B = N.utc, y = N.args;
        this.$u = B;
        var Y = y[1];
        if (typeof Y == "string") {
          var S = y[2] === !0, v = y[3] === !0, M = S || v, U = y[2];
          v && (U = y[2]), f = this.$locale(), !S && U && (f = b.Ls[U]), this.$d = function(Q, z, j, K) {
            try {
              if (["x", "X"].indexOf(z) > -1) return new Date((z === "X" ? 1e3 : 1) * Q);
              var R = m(z)(Q), k = R.year, q = R.month, H = R.day, se = R.hours, ie = R.minutes, fe = R.seconds, te = R.milliseconds, Ne = R.zone, de = R.week, Ie = /* @__PURE__ */ new Date(), ye = H || (k || q ? 1 : Ie.getDate()), xe = k || Ie.getFullYear(), Te = 0;
              k && !q || (Te = q > 0 ? q - 1 : Ie.getMonth());
              var Xe, Ze = se || 0, nt = ie || 0, Je = fe || 0, xt = te || 0;
              return Ne ? new Date(Date.UTC(xe, Te, ye, Ze, nt, Je, xt + 60 * Ne.offset * 1e3)) : j ? new Date(Date.UTC(xe, Te, ye, Ze, nt, Je, xt)) : (Xe = new Date(xe, Te, ye, Ze, nt, Je, xt), de && (Xe = K(Xe).week(de).toDate()), Xe);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(I, Y, B, b), this.init(), U && U !== !0 && (this.$L = this.locale(U).$L), M && I != this.format(Y) && (this.$d = /* @__PURE__ */ new Date("")), f = {};
        } else if (Y instanceof Array) for (var $ = Y.length, P = 1; P <= $; P += 1) {
          y[1] = Y[P - 1];
          var w = b.apply(this, y);
          if (w.isValid()) {
            this.$d = w.$d, this.$L = w.$L, this.init();
            break;
          }
          P === $ && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else g.call(this, N);
      };
    };
  });
})(qa);
var io = qa.exports;
const uo = /* @__PURE__ */ Mt(io);
var Ya = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(re, function() {
    var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(a, u, o) {
      var f = u.prototype;
      o.utc = function(m) {
        var E = { date: m, utc: !0, args: arguments };
        return new u(E);
      }, f.utc = function(m) {
        var E = o(this.toDate(), { locale: this.$L, utc: !0 });
        return m ? E.add(this.utcOffset(), r) : E;
      }, f.local = function() {
        return o(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = f.parse;
      f.parse = function(m) {
        m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), c.call(this, m);
      };
      var l = f.init;
      f.init = function() {
        if (this.$u) {
          var m = this.$d;
          this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
        } else l.call(this);
      };
      var x = f.utcOffset;
      f.utcOffset = function(m, E) {
        var D = this.$utils().u;
        if (D(m)) return this.$u ? 0 : D(this.$offset) ? x.call(this) : this.$offset;
        if (typeof m == "string" && (m = function(N) {
          N === void 0 && (N = "");
          var I = N.match(n);
          if (!I) return null;
          var B = ("" + I[0]).match(s) || ["-", 0, 0], y = B[0], Y = 60 * +B[1] + +B[2];
          return Y === 0 ? 0 : y === "+" ? Y : -Y;
        }(m), m === null)) return this;
        var b = Math.abs(m) <= 16 ? 60 * m : m, A = this;
        if (E) return A.$offset = b, A.$u = m === 0, A;
        if (m !== 0) {
          var g = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (A = this.local().add(b + g, r)).$offset = b, A.$x.$localOffset = g;
        } else A = this.utc();
        return A;
      };
      var d = f.format;
      f.format = function(m) {
        var E = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, E);
      }, f.valueOf = function() {
        var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * m;
      }, f.isUTC = function() {
        return !!this.$u;
      }, f.toISOString = function() {
        return this.toDate().toISOString();
      }, f.toString = function() {
        return this.toDate().toUTCString();
      };
      var p = f.toDate;
      f.toDate = function(m) {
        return m === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
      };
      var h = f.diff;
      f.diff = function(m, E, D) {
        if (m && this.$u === m.$u) return h.call(this, m, E, D);
        var b = this.local(), A = o(m).local();
        return h.call(b, A, E, D);
      };
    };
  });
})(Ya);
var oo = Ya.exports;
const $a = /* @__PURE__ */ Mt(oo);
var Wa = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(re, function() {
    var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
    return function(s, a, u) {
      var o, f = function(d, p, h) {
        h === void 0 && (h = {});
        var m = new Date(d), E = function(D, b) {
          b === void 0 && (b = {});
          var A = b.timeZoneName || "short", g = D + "|" + A, N = n[g];
          return N || (N = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: D, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: A }), n[g] = N), N;
        }(p, h);
        return E.formatToParts(m);
      }, c = function(d, p) {
        for (var h = f(d, p), m = [], E = 0; E < h.length; E += 1) {
          var D = h[E], b = D.type, A = D.value, g = r[b];
          g >= 0 && (m[g] = parseInt(A, 10));
        }
        var N = m[3], I = N === 24 ? 0 : N, B = m[0] + "-" + m[1] + "-" + m[2] + " " + I + ":" + m[4] + ":" + m[5] + ":000", y = +d;
        return (u.utc(B).valueOf() - (y -= y % 1e3)) / 6e4;
      }, l = a.prototype;
      l.tz = function(d, p) {
        d === void 0 && (d = o);
        var h, m = this.utcOffset(), E = this.toDate(), D = E.toLocaleString("en-US", { timeZone: d }), b = Math.round((E - new Date(D)) / 1e3 / 60), A = 15 * -Math.round(E.getTimezoneOffset() / 15) - b;
        if (!Number(A)) h = this.utcOffset(0, p);
        else if (h = u(D, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(A, !0), p) {
          var g = h.utcOffset();
          h = h.add(m - g, "minute");
        }
        return h.$x.$timezone = d, h;
      }, l.offsetName = function(d) {
        var p = this.$x.$timezone || u.tz.guess(), h = f(this.valueOf(), p, { timeZoneName: d }).find(function(m) {
          return m.type.toLowerCase() === "timezonename";
        });
        return h && h.value;
      };
      var x = l.startOf;
      l.startOf = function(d, p) {
        if (!this.$x || !this.$x.$timezone) return x.call(this, d, p);
        var h = u(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return x.call(h, d, p).tz(this.$x.$timezone, !0);
      }, u.tz = function(d, p, h) {
        var m = h && p, E = h || p || o, D = c(+u(), E);
        if (typeof d != "string") return u(d).tz(E);
        var b = function(I, B, y) {
          var Y = I - 60 * B * 1e3, S = c(Y, y);
          if (B === S) return [Y, B];
          var v = c(Y -= 60 * (S - B) * 1e3, y);
          return S === v ? [Y, S] : [I - 60 * Math.min(S, v) * 1e3, Math.max(S, v)];
        }(u.utc(d, m).valueOf(), D, E), A = b[0], g = b[1], N = u(A).utcOffset(g);
        return N.$x.$timezone = E, N;
      }, u.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, u.tz.setDefault = function(d) {
        o = d;
      };
    };
  });
})(Wa);
var co = Wa.exports;
const za = /* @__PURE__ */ Mt(co);
var ce;
(function(e) {
  e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
})(ce || (ce = {}));
function lo(e) {
  return e.type === ce.Tag || e.type === ce.Script || e.type === ce.Style;
}
const fo = ce.Root, ho = ce.Text, Eo = ce.Directive, xo = ce.Comment, mo = ce.Script, po = ce.Style, bo = ce.Tag, To = ce.CDATA, Ao = ce.Doctype;
class Ga {
  constructor() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(t) {
    this.parent = t;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(t) {
    this.prev = t;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(t) {
    this.next = t;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(t = !1) {
    return ir(this, t);
  }
}
class D0 extends Ga {
  /**
   * @param data The content of the data node
   */
  constructor(t) {
    super(), this.data = t;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(t) {
    this.data = t;
  }
}
class ar extends D0 {
  constructor() {
    super(...arguments), this.type = ce.Text;
  }
  get nodeType() {
    return 3;
  }
}
class S0 extends D0 {
  constructor() {
    super(...arguments), this.type = ce.Comment;
  }
  get nodeType() {
    return 8;
  }
}
class N0 extends D0 {
  constructor(t, r) {
    super(r), this.name = t, this.type = ce.Directive;
  }
  get nodeType() {
    return 1;
  }
}
class I0 extends Ga {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(t) {
    super(), this.children = t;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var t;
    return (t = this.children[0]) !== null && t !== void 0 ? t : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(t) {
    this.children = t;
  }
}
class Va extends I0 {
  constructor() {
    super(...arguments), this.type = ce.CDATA;
  }
  get nodeType() {
    return 4;
  }
}
class Ct extends I0 {
  constructor() {
    super(...arguments), this.type = ce.Root;
  }
  get nodeType() {
    return 9;
  }
}
class v0 extends I0 {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(t, r, n = [], s = t === "script" ? ce.Script : t === "style" ? ce.Style : ce.Tag) {
    super(n), this.name = t, this.attribs = r, this.type = s;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(t) {
    this.name = t;
  }
  get attributes() {
    return Object.keys(this.attribs).map((t) => {
      var r, n;
      return {
        name: t,
        value: this.attribs[t],
        namespace: (r = this["x-attribsNamespace"]) === null || r === void 0 ? void 0 : r[t],
        prefix: (n = this["x-attribsPrefix"]) === null || n === void 0 ? void 0 : n[t]
      };
    });
  }
}
function ee(e) {
  return lo(e);
}
function qr(e) {
  return e.type === ce.CDATA;
}
function Ke(e) {
  return e.type === ce.Text;
}
function Yr(e) {
  return e.type === ce.Comment;
}
function n0(e) {
  return e.type === ce.Directive;
}
function dt(e) {
  return e.type === ce.Root;
}
function ge(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
function ir(e, t = !1) {
  let r;
  if (Ke(e))
    r = new ar(e.data);
  else if (Yr(e))
    r = new S0(e.data);
  else if (ee(e)) {
    const n = t ? un(e.children) : [], s = new v0(e.name, { ...e.attribs }, n);
    n.forEach((a) => a.parent = s), e.namespace != null && (s.namespace = e.namespace), e["x-attribsNamespace"] && (s["x-attribsNamespace"] = { ...e["x-attribsNamespace"] }), e["x-attribsPrefix"] && (s["x-attribsPrefix"] = { ...e["x-attribsPrefix"] }), r = s;
  } else if (qr(e)) {
    const n = t ? un(e.children) : [], s = new Va(n);
    n.forEach((a) => a.parent = s), r = s;
  } else if (dt(e)) {
    const n = t ? un(e.children) : [], s = new Ct(n);
    n.forEach((a) => a.parent = s), e["x-mode"] && (s["x-mode"] = e["x-mode"]), r = s;
  } else if (n0(e)) {
    const n = new N0(e.name, e.data);
    e["x-name"] != null && (n["x-name"] = e["x-name"], n["x-publicId"] = e["x-publicId"], n["x-systemId"] = e["x-systemId"]), r = n;
  } else
    throw new Error(`Not implemented yet: ${e.type}`);
  return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
}
function un(e) {
  const t = e.map((r) => ir(r, !0));
  for (let r = 1; r < t.length; r++)
    t[r].prev = t[r - 1], t[r - 1].next = t[r];
  return t;
}
const ds = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class _o {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(t, r, n) {
    this.dom = [], this.root = new Ct(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof r == "function" && (n = r, r = ds), typeof t == "object" && (r = t, t = void 0), this.callback = t ?? null, this.options = r ?? ds, this.elementCB = n ?? null;
  }
  onparserinit(t) {
    this.parser = t;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new Ct(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(t) {
    this.handleCallback(t);
  }
  onclosetag() {
    this.lastNode = null;
    const t = this.tagStack.pop();
    this.options.withEndIndices && (t.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(t);
  }
  onopentag(t, r) {
    const n = this.options.xmlMode ? ce.Tag : void 0, s = new v0(t, r, void 0, n);
    this.addNode(s), this.tagStack.push(s);
  }
  ontext(t) {
    const { lastNode: r } = this;
    if (r && r.type === ce.Text)
      r.data += t, this.options.withEndIndices && (r.endIndex = this.parser.endIndex);
    else {
      const n = new ar(t);
      this.addNode(n), this.lastNode = n;
    }
  }
  oncomment(t) {
    if (this.lastNode && this.lastNode.type === ce.Comment) {
      this.lastNode.data += t;
      return;
    }
    const r = new S0(t);
    this.addNode(r), this.lastNode = r;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const t = new ar(""), r = new Va([t]);
    this.addNode(r), t.parent = r, this.lastNode = t;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(t, r) {
    const n = new N0(t, r);
    this.addNode(n);
  }
  handleCallback(t) {
    if (typeof this.callback == "function")
      this.callback(t, this.dom);
    else if (t)
      throw t;
  }
  addNode(t) {
    const r = this.tagStack[this.tagStack.length - 1], n = r.children[r.children.length - 1];
    this.options.withStartIndices && (t.startIndex = this.parser.startIndex), this.options.withEndIndices && (t.endIndex = this.parser.endIndex), r.children.push(t), n && (t.prev = n, n.next = t), t.parent = r, this.lastNode = null;
  }
}
const B0 = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), Qa = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var on;
const go = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), s0 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (on = String.fromCodePoint) !== null && on !== void 0 ? on : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function Co(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = go.get(e)) !== null && t !== void 0 ? t : e;
}
var _e;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(_e || (_e = {}));
const Do = 32;
var ct;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(ct || (ct = {}));
function a0(e) {
  return e >= _e.ZERO && e <= _e.NINE;
}
function So(e) {
  return e >= _e.UPPER_A && e <= _e.UPPER_F || e >= _e.LOWER_A && e <= _e.LOWER_F;
}
function No(e) {
  return e >= _e.UPPER_A && e <= _e.UPPER_Z || e >= _e.LOWER_A && e <= _e.LOWER_Z || a0(e);
}
function Io(e) {
  return e === _e.EQUALS || No(e);
}
var Ae;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Ae || (Ae = {}));
var Ye;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Ye || (Ye = {}));
class O0 {
  constructor(t, r, n) {
    this.decodeTree = t, this.emitCodePoint = r, this.errors = n, this.state = Ae.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Ye.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = Ae.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, r) {
    switch (this.state) {
      case Ae.EntityStart:
        return t.charCodeAt(r) === _e.NUM ? (this.state = Ae.NumericStart, this.consumed += 1, this.stateNumericStart(t, r + 1)) : (this.state = Ae.NamedEntity, this.stateNamedEntity(t, r));
      case Ae.NumericStart:
        return this.stateNumericStart(t, r);
      case Ae.NumericDecimal:
        return this.stateNumericDecimal(t, r);
      case Ae.NumericHex:
        return this.stateNumericHex(t, r);
      case Ae.NamedEntity:
        return this.stateNamedEntity(t, r);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, r) {
    return r >= t.length ? -1 : (t.charCodeAt(r) | Do) === _e.LOWER_X ? (this.state = Ae.NumericHex, this.consumed += 1, this.stateNumericHex(t, r + 1)) : (this.state = Ae.NumericDecimal, this.stateNumericDecimal(t, r));
  }
  addToNumericResult(t, r, n, s) {
    if (r !== n) {
      const a = n - r;
      this.result = this.result * Math.pow(s, a) + parseInt(t.substr(r, a), s), this.consumed += a;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, r) {
    const n = r;
    for (; r < t.length; ) {
      const s = t.charCodeAt(r);
      if (a0(s) || So(s))
        r += 1;
      else
        return this.addToNumericResult(t, n, r, 16), this.emitNumericEntity(s, 3);
    }
    return this.addToNumericResult(t, n, r, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, r) {
    const n = r;
    for (; r < t.length; ) {
      const s = t.charCodeAt(r);
      if (a0(s))
        r += 1;
      else
        return this.addToNumericResult(t, n, r, 10), this.emitNumericEntity(s, 2);
    }
    return this.addToNumericResult(t, n, r, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, r) {
    var n;
    if (this.consumed <= r)
      return (n = this.errors) === null || n === void 0 || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === _e.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Ye.Strict)
      return 0;
    return this.emitCodePoint(Co(this.result), this.consumed), this.errors && (t !== _e.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, r) {
    const { decodeTree: n } = this;
    let s = n[this.treeIndex], a = (s & ct.VALUE_LENGTH) >> 14;
    for (; r < t.length; r++, this.excess++) {
      const u = t.charCodeAt(r);
      if (this.treeIndex = vo(n, s, this.treeIndex + Math.max(1, a), u), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Ye.Attribute && // We shouldn't have consumed any characters after the entity,
        (a === 0 || // And there should be no invalid characters.
        Io(u)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (s = n[this.treeIndex], a = (s & ct.VALUE_LENGTH) >> 14, a !== 0) {
        if (u === _e.SEMI)
          return this.emitNamedEntityData(this.treeIndex, a, this.consumed + this.excess);
        this.decodeMode !== Ye.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: r, decodeTree: n } = this, s = (n[r] & ct.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(r, s, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, r, n) {
    const { decodeTree: s } = this;
    return this.emitCodePoint(r === 1 ? s[t] & ~ct.VALUE_LENGTH : s[t + 1], n), r === 3 && this.emitCodePoint(s[t + 2], n), n;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case Ae.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Ye.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case Ae.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ae.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ae.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ae.EntityStart:
        return 0;
    }
  }
}
function ja(e) {
  let t = "";
  const r = new O0(e, (n) => t += s0(n));
  return function(s, a) {
    let u = 0, o = 0;
    for (; (o = s.indexOf("&", o)) >= 0; ) {
      t += s.slice(u, o), r.startEntity(a);
      const c = r.write(
        s,
        // Skip the "&"
        o + 1
      );
      if (c < 0) {
        u = o + r.end();
        break;
      }
      u = o + c, o = c === 0 ? u + 1 : u;
    }
    const f = t + s.slice(u);
    return t = "", f;
  };
}
function vo(e, t, r, n) {
  const s = (t & ct.BRANCH_LENGTH) >> 7, a = t & ct.JUMP_TABLE;
  if (s === 0)
    return a !== 0 && n === a ? r : -1;
  if (a) {
    const f = n - a;
    return f < 0 || f >= s ? -1 : e[r + f] - 1;
  }
  let u = r, o = u + s - 1;
  for (; u <= o; ) {
    const f = u + o >>> 1, c = e[f];
    if (c < n)
      u = f + 1;
    else if (c > n)
      o = f - 1;
    else
      return e[f + s];
  }
  return -1;
}
ja(B0);
ja(Qa);
const hs = /["&'<>$\x80-\uFFFF]/g, Bo = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]), Oo = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (e, t) => e.codePointAt(t) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (e, t) => (e.charCodeAt(t) & 64512) === 55296 ? (e.charCodeAt(t) - 55296) * 1024 + e.charCodeAt(t + 1) - 56320 + 65536 : e.charCodeAt(t)
  )
);
function Ka(e) {
  let t = "", r = 0, n;
  for (; (n = hs.exec(e)) !== null; ) {
    const s = n.index, a = e.charCodeAt(s), u = Bo.get(a);
    u !== void 0 ? (t += e.substring(r, s) + u, r = s + 1) : (t += `${e.substring(r, s)}&#x${Oo(e, s).toString(16)};`, r = hs.lastIndex += +((a & 64512) === 55296));
  }
  return t + e.substr(r);
}
function Xa(e, t) {
  return function(n) {
    let s, a = 0, u = "";
    for (; s = e.exec(n); )
      a !== s.index && (u += n.substring(a, s.index)), u += t.get(s[0].charCodeAt(0)), a = s.index + 1;
    return u + n.substring(a);
  };
}
const Za = Xa(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), Ja = Xa(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), yo = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), Ro = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), Lo = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function Fo(e) {
  return e.replace(/"/g, "&quot;");
}
function Po(e, t) {
  var r;
  if (!e)
    return;
  const n = ((r = t.encodeEntities) !== null && r !== void 0 ? r : t.decodeEntities) === !1 ? Fo : t.xmlMode || t.encodeEntities !== "utf8" ? Ka : Za;
  return Object.keys(e).map((s) => {
    var a, u;
    const o = (a = e[s]) !== null && a !== void 0 ? a : "";
    return t.xmlMode === "foreign" && (s = (u = Ro.get(s)) !== null && u !== void 0 ? u : s), !t.emptyAttrs && !t.xmlMode && o === "" ? s : `${s}="${n(o)}"`;
  }).join(" ");
}
const Es = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function $r(e, t = {}) {
  const r = "length" in e ? e : [e];
  let n = "";
  for (let s = 0; s < r.length; s++)
    n += ko(r[s], t);
  return n;
}
function ko(e, t) {
  switch (e.type) {
    case fo:
      return $r(e.children, t);
    case Ao:
    case Eo:
      return Uo(e);
    case xo:
      return $o(e);
    case To:
      return Yo(e);
    case mo:
    case po:
    case bo:
      return Ho(e, t);
    case ho:
      return qo(e, t);
  }
}
const wo = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), Mo = /* @__PURE__ */ new Set(["svg", "math"]);
function Ho(e, t) {
  var r;
  t.xmlMode === "foreign" && (e.name = (r = yo.get(e.name)) !== null && r !== void 0 ? r : e.name, e.parent && wo.has(e.parent.name) && (t = { ...t, xmlMode: !1 })), !t.xmlMode && Mo.has(e.name) && (t = { ...t, xmlMode: "foreign" });
  let n = `<${e.name}`;
  const s = Po(e.attribs, t);
  return s && (n += ` ${s}`), e.children.length === 0 && (t.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    t.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    t.selfClosingTags && Es.has(e.name)
  )) ? (t.xmlMode || (n += " "), n += "/>") : (n += ">", e.children.length > 0 && (n += $r(e.children, t)), (t.xmlMode || !Es.has(e.name)) && (n += `</${e.name}>`)), n;
}
function Uo(e) {
  return `<${e.data}>`;
}
function qo(e, t) {
  var r;
  let n = e.data || "";
  return ((r = t.encodeEntities) !== null && r !== void 0 ? r : t.decodeEntities) !== !1 && !(!t.xmlMode && e.parent && Lo.has(e.parent.name)) && (n = t.xmlMode || t.encodeEntities !== "utf8" ? Ka(n) : Ja(n)), n;
}
function Yo(e) {
  return `<![CDATA[${e.children[0].data}]]>`;
}
function $o(e) {
  return `<!--${e.data}-->`;
}
function ei(e, t) {
  return $r(e, t);
}
function Wo(e, t) {
  return ge(e) ? e.children.map((r) => ei(r, t)).join("") : "";
}
function Cr(e) {
  return Array.isArray(e) ? e.map(Cr).join("") : ee(e) ? e.name === "br" ? `
` : Cr(e.children) : qr(e) ? Cr(e.children) : Ke(e) ? e.data : "";
}
function kt(e) {
  return Array.isArray(e) ? e.map(kt).join("") : ge(e) && !Yr(e) ? kt(e.children) : Ke(e) ? e.data : "";
}
function vr(e) {
  return Array.isArray(e) ? e.map(vr).join("") : ge(e) && (e.type === ce.Tag || qr(e)) ? vr(e.children) : Ke(e) ? e.data : "";
}
function Wr(e) {
  return ge(e) ? e.children : [];
}
function ti(e) {
  return e.parent || null;
}
function ri(e) {
  const t = ti(e);
  if (t != null)
    return Wr(t);
  const r = [e];
  let { prev: n, next: s } = e;
  for (; n != null; )
    r.unshift(n), { prev: n } = n;
  for (; s != null; )
    r.push(s), { next: s } = s;
  return r;
}
function zo(e, t) {
  var r;
  return (r = e.attribs) === null || r === void 0 ? void 0 : r[t];
}
function Go(e, t) {
  return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, t) && e.attribs[t] != null;
}
function Vo(e) {
  return e.name;
}
function y0(e) {
  let { next: t } = e;
  for (; t !== null && !ee(t); )
    ({ next: t } = t);
  return t;
}
function R0(e) {
  let { prev: t } = e;
  for (; t !== null && !ee(t); )
    ({ prev: t } = t);
  return t;
}
function It(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    const t = e.parent.children, r = t.lastIndexOf(e);
    r >= 0 && t.splice(r, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
function Qo(e, t) {
  const r = t.prev = e.prev;
  r && (r.next = t);
  const n = t.next = e.next;
  n && (n.prev = t);
  const s = t.parent = e.parent;
  if (s) {
    const a = s.children;
    a[a.lastIndexOf(e)] = t, e.parent = null;
  }
}
function jo(e, t) {
  if (It(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    const r = e.children[e.children.length - 2];
    r.next = t, t.prev = r;
  } else
    t.prev = null;
}
function Ko(e, t) {
  It(t);
  const { parent: r } = e, n = e.next;
  if (t.next = n, t.prev = e, e.next = t, t.parent = r, n) {
    if (n.prev = t, r) {
      const s = r.children;
      s.splice(s.lastIndexOf(n), 0, t);
    }
  } else r && r.children.push(t);
}
function Xo(e, t) {
  if (It(t), t.parent = e, t.prev = null, e.children.unshift(t) !== 1) {
    const r = e.children[1];
    r.prev = t, t.next = r;
  } else
    t.next = null;
}
function Zo(e, t) {
  It(t);
  const { parent: r } = e;
  if (r) {
    const n = r.children;
    n.splice(n.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
}
function zr(e, t, r = !0, n = 1 / 0) {
  return L0(e, Array.isArray(t) ? t : [t], r, n);
}
function L0(e, t, r, n) {
  const s = [], a = [t], u = [0];
  for (; ; ) {
    if (u[0] >= a[0].length) {
      if (u.length === 1)
        return s;
      a.shift(), u.shift();
      continue;
    }
    const o = a[0][u[0]++];
    if (e(o) && (s.push(o), --n <= 0))
      return s;
    r && ge(o) && o.children.length > 0 && (u.unshift(0), a.unshift(o.children));
  }
}
function Jo(e, t) {
  return t.find(e);
}
function F0(e, t, r = !0) {
  let n = null;
  for (let s = 0; s < t.length && !n; s++) {
    const a = t[s];
    if (ee(a))
      e(a) ? n = a : r && a.children.length > 0 && (n = F0(e, a.children, !0));
    else continue;
  }
  return n;
}
function ni(e, t) {
  return t.some((r) => ee(r) && (e(r) || ni(e, r.children)));
}
function ec(e, t) {
  const r = [], n = [t], s = [0];
  for (; ; ) {
    if (s[0] >= n[0].length) {
      if (n.length === 1)
        return r;
      n.shift(), s.shift();
      continue;
    }
    const a = n[0][s[0]++];
    ee(a) && (e(a) && r.push(a), a.children.length > 0 && (s.unshift(0), n.unshift(a.children)));
  }
}
const Br = {
  tag_name(e) {
    return typeof e == "function" ? (t) => ee(t) && e(t.name) : e === "*" ? ee : (t) => ee(t) && t.name === e;
  },
  tag_type(e) {
    return typeof e == "function" ? (t) => e(t.type) : (t) => t.type === e;
  },
  tag_contains(e) {
    return typeof e == "function" ? (t) => Ke(t) && e(t.data) : (t) => Ke(t) && t.data === e;
  }
};
function si(e, t) {
  return typeof t == "function" ? (r) => ee(r) && t(r.attribs[e]) : (r) => ee(r) && r.attribs[e] === t;
}
function tc(e, t) {
  return (r) => e(r) || t(r);
}
function ai(e) {
  const t = Object.keys(e).map((r) => {
    const n = e[r];
    return Object.prototype.hasOwnProperty.call(Br, r) ? Br[r](n) : si(r, n);
  });
  return t.length === 0 ? null : t.reduce(tc);
}
function rc(e, t) {
  const r = ai(e);
  return r ? r(t) : !0;
}
function nc(e, t, r, n = 1 / 0) {
  const s = ai(e);
  return s ? zr(s, t, r, n) : [];
}
function sc(e, t, r = !0) {
  return Array.isArray(t) || (t = [t]), F0(si("id", e), t, r);
}
function Ht(e, t, r = !0, n = 1 / 0) {
  return zr(Br.tag_name(e), t, r, n);
}
function ac(e, t, r = !0, n = 1 / 0) {
  return zr(Br.tag_type(e), t, r, n);
}
function ic(e) {
  let t = e.length;
  for (; --t >= 0; ) {
    const r = e[t];
    if (t > 0 && e.lastIndexOf(r, t - 1) >= 0) {
      e.splice(t, 1);
      continue;
    }
    for (let n = r.parent; n; n = n.parent)
      if (e.includes(n)) {
        e.splice(t, 1);
        break;
      }
  }
  return e;
}
var qe;
(function(e) {
  e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
})(qe || (qe = {}));
function ii(e, t) {
  const r = [], n = [];
  if (e === t)
    return 0;
  let s = ge(e) ? e : e.parent;
  for (; s; )
    r.unshift(s), s = s.parent;
  for (s = ge(t) ? t : t.parent; s; )
    n.unshift(s), s = s.parent;
  const a = Math.min(r.length, n.length);
  let u = 0;
  for (; u < a && r[u] === n[u]; )
    u++;
  if (u === 0)
    return qe.DISCONNECTED;
  const o = r[u - 1], f = o.children, c = r[u], l = n[u];
  return f.indexOf(c) > f.indexOf(l) ? o === t ? qe.FOLLOWING | qe.CONTAINED_BY : qe.FOLLOWING : o === e ? qe.PRECEDING | qe.CONTAINS : qe.PRECEDING;
}
function Ut(e) {
  return e = e.filter((t, r, n) => !n.includes(t, r + 1)), e.sort((t, r) => {
    const n = ii(t, r);
    return n & qe.PRECEDING ? -1 : n & qe.FOLLOWING ? 1 : 0;
  }), e;
}
function uc(e) {
  const t = Or(dc, e);
  return t ? t.name === "feed" ? oc(t) : cc(t) : null;
}
function oc(e) {
  var t;
  const r = e.children, n = {
    type: "atom",
    items: Ht("entry", r).map((u) => {
      var o;
      const { children: f } = u, c = { media: ui(f) };
      Le(c, "id", "id", f), Le(c, "title", "title", f);
      const l = (o = Or("link", f)) === null || o === void 0 ? void 0 : o.attribs.href;
      l && (c.link = l);
      const x = lt("summary", f) || lt("content", f);
      x && (c.description = x);
      const d = lt("updated", f);
      return d && (c.pubDate = new Date(d)), c;
    })
  };
  Le(n, "id", "id", r), Le(n, "title", "title", r);
  const s = (t = Or("link", r)) === null || t === void 0 ? void 0 : t.attribs.href;
  s && (n.link = s), Le(n, "description", "subtitle", r);
  const a = lt("updated", r);
  return a && (n.updated = new Date(a)), Le(n, "author", "email", r, !0), n;
}
function cc(e) {
  var t, r;
  const n = (r = (t = Or("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && r !== void 0 ? r : [], s = {
    type: e.name.substr(0, 3),
    id: "",
    items: Ht("item", e.children).map((u) => {
      const { children: o } = u, f = { media: ui(o) };
      Le(f, "id", "guid", o), Le(f, "title", "title", o), Le(f, "link", "link", o), Le(f, "description", "description", o);
      const c = lt("pubDate", o) || lt("dc:date", o);
      return c && (f.pubDate = new Date(c)), f;
    })
  };
  Le(s, "title", "title", n), Le(s, "link", "link", n), Le(s, "description", "description", n);
  const a = lt("lastBuildDate", n);
  return a && (s.updated = new Date(a)), Le(s, "author", "managingEditor", n, !0), s;
}
const lc = ["url", "type", "lang"], fc = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function ui(e) {
  return Ht("media:content", e).map((t) => {
    const { attribs: r } = t, n = {
      medium: r.medium,
      isDefault: !!r.isDefault
    };
    for (const s of lc)
      r[s] && (n[s] = r[s]);
    for (const s of fc)
      r[s] && (n[s] = parseInt(r[s], 10));
    return r.expression && (n.expression = r.expression), n;
  });
}
function Or(e, t) {
  return Ht(e, t, !0, 1)[0];
}
function lt(e, t, r = !1) {
  return kt(Ht(e, t, r, 1)).trim();
}
function Le(e, t, r, n, s = !1) {
  const a = lt(r, n, s);
  a && (e[t] = a);
}
function dc(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
const Gr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return qe;
  },
  append: Ko,
  appendChild: jo,
  compareDocumentPosition: ii,
  existsOne: ni,
  filter: zr,
  find: L0,
  findAll: ec,
  findOne: F0,
  findOneChild: Jo,
  getAttributeValue: zo,
  getChildren: Wr,
  getElementById: sc,
  getElements: nc,
  getElementsByTagName: Ht,
  getElementsByTagType: ac,
  getFeed: uc,
  getInnerHTML: Wo,
  getName: Vo,
  getOuterHTML: ei,
  getParent: ti,
  getSiblings: ri,
  getText: Cr,
  hasAttrib: Go,
  hasChildren: ge,
  innerText: vr,
  isCDATA: qr,
  isComment: Yr,
  isDocument: dt,
  isTag: ee,
  isText: Ke,
  nextElementSibling: y0,
  prepend: Zo,
  prependChild: Xo,
  prevElementSibling: R0,
  removeElement: It,
  removeSubsets: ic,
  replaceElement: Qo,
  testElement: rc,
  textContent: kt,
  uniqueSort: Ut
}, Symbol.toStringTag, { value: "Module" })), hc = {
  _useHtmlParser2: !1
};
function i0(e, t) {
  if (!e)
    return t ?? hc;
  const r = {
    _useHtmlParser2: !!e.xmlMode,
    ...t,
    ...e
  };
  return e.xml ? (r._useHtmlParser2 = !0, r.xmlMode = !0, e.xml !== !0 && Object.assign(r, e.xml)) : e.xmlMode && (r._useHtmlParser2 = !0), r;
}
function oi(e, t, r) {
  return e ? e(t ?? e._root.children, null, void 0, r).toString() : "";
}
function Ec(e, t) {
  return typeof e == "object" && e != null && !("length" in e) && !("type" in e);
}
function xc(e, t) {
  const r = Ec(e) ? (t = e, void 0) : e, n = {
    ...this === null || this === void 0 ? void 0 : this._options,
    ...i0(t)
  };
  return oi(this, r, n);
}
function mc(e) {
  const t = { ...this._options, xmlMode: !0 };
  return oi(this, e, t);
}
function ur(e) {
  const t = e ?? (this ? this.root() : []);
  let r = "";
  for (let n = 0; n < t.length; n++)
    r += kt(t[n]);
  return r;
}
function pc(e, t, r = typeof t == "boolean" ? t : !1) {
  if (!e || typeof e != "string")
    return null;
  typeof t == "boolean" && (r = t);
  const n = this.load(e, this._options, !1);
  return r || n("script").remove(), [...n.root()[0].children];
}
function bc() {
  return this(this._root);
}
function ci(e, t) {
  if (t === e)
    return !1;
  let r = t;
  for (; r && r !== r.parent; )
    if (r = r.parent, r === e)
      return !0;
  return !1;
}
function Tc(e) {
  return this.root().extract(e);
}
function Ac(e, t) {
  if (!xs(e) || !xs(t))
    return;
  let r = e.length;
  const n = +t.length;
  for (let s = 0; s < n; s++)
    e[r++] = t[s];
  return e.length = r, e;
}
function xs(e) {
  if (Array.isArray(e))
    return !0;
  if (typeof e != "object" || e === null || !("length" in e) || typeof e.length != "number" || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!(t in e))
      return !1;
  return !0;
}
const _c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contains: ci,
  extract: Tc,
  html: xc,
  merge: Ac,
  parseHTML: pc,
  root: bc,
  text: ur,
  xml: mc
}, Symbol.toStringTag, { value: "Module" }));
function rt(e) {
  return e.cheerio != null;
}
function gc(e) {
  return e.replace(/[._-](\w|$)/g, (t, r) => r.toUpperCase());
}
function Cc(e) {
  return e.replace(/[A-Z]/g, "-$&").toLowerCase();
}
function Ee(e, t) {
  const r = e.length;
  for (let n = 0; n < r; n++)
    t(e[n], n);
  return e;
}
var pt;
(function(e) {
  e[e.LowerA = 97] = "LowerA", e[e.LowerZ = 122] = "LowerZ", e[e.UpperA = 65] = "UpperA", e[e.UpperZ = 90] = "UpperZ", e[e.Exclamation = 33] = "Exclamation";
})(pt || (pt = {}));
function u0(e) {
  const t = e.indexOf("<");
  if (t < 0 || t > e.length - 3)
    return !1;
  const r = e.charCodeAt(t + 1);
  return (r >= pt.LowerA && r <= pt.LowerZ || r >= pt.UpperA && r <= pt.UpperZ || r === pt.Exclamation) && e.includes(">", t + 2);
}
const or = Object.prototype.hasOwnProperty, cr = /\s+/, o0 = "data-", P0 = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, Dc = /^{[^]*}$|^\[[^]*]$/;
function yr(e, t, r) {
  var n;
  if (!(!e || !ee(e))) {
    if ((n = e.attribs) !== null && n !== void 0 || (e.attribs = {}), !t)
      return e.attribs;
    if (or.call(e.attribs, t))
      return !r && P0.test(t) ? t : e.attribs[t];
    if (e.name === "option" && t === "value")
      return ur(e.children);
    if (e.name === "input" && (e.attribs.type === "radio" || e.attribs.type === "checkbox") && t === "value")
      return "on";
  }
}
function Pt(e, t, r) {
  r === null ? fi(e, t) : e.attribs[t] = `${r}`;
}
function Sc(e, t) {
  if (typeof e == "object" || t !== void 0) {
    if (typeof t == "function") {
      if (typeof e != "string")
        throw new Error("Bad combination of arguments.");
      return Ee(this, (r, n) => {
        ee(r) && Pt(r, e, t.call(r, n, r.attribs[e]));
      });
    }
    return Ee(this, (r) => {
      if (ee(r))
        if (typeof e == "object")
          for (const n of Object.keys(e)) {
            const s = e[n];
            Pt(r, n, s);
          }
        else
          Pt(r, e, t);
    });
  }
  return arguments.length > 1 ? this : yr(this[0], e, this.options.xmlMode);
}
function ms(e, t, r) {
  return t in e ? (
    // @ts-expect-error TS doesn't like us accessing the value directly here.
    e[t]
  ) : !r && P0.test(t) ? yr(e, t, !1) !== void 0 : yr(e, t, r);
}
function cn(e, t, r, n) {
  t in e ? e[t] = r : Pt(e, t, !n && P0.test(t) ? r ? "" : null : `${r}`);
}
function Nc(e, t) {
  var r;
  if (typeof e == "string" && t === void 0) {
    const n = this[0];
    if (!n || !ee(n))
      return;
    switch (e) {
      case "style": {
        const s = this.css(), a = Object.keys(s);
        for (let u = 0; u < a.length; u++)
          s[u] = a[u];
        return s.length = a.length, s;
      }
      case "tagName":
      case "nodeName":
        return n.name.toUpperCase();
      case "href":
      case "src": {
        const s = (r = n.attribs) === null || r === void 0 ? void 0 : r[e];
        return typeof URL < "u" && (e === "href" && (n.tagName === "a" || n.tagName === "link") || e === "src" && (n.tagName === "img" || n.tagName === "iframe" || n.tagName === "audio" || n.tagName === "video" || n.tagName === "source")) && s !== void 0 && this.options.baseURI ? new URL(s, this.options.baseURI).href : s;
      }
      case "innerText":
        return vr(n);
      case "textContent":
        return kt(n);
      case "outerHTML":
        return this.clone().wrap("<container />").parent().html();
      case "innerHTML":
        return this.html();
      default:
        return ms(n, e, this.options.xmlMode);
    }
  }
  if (typeof e == "object" || t !== void 0) {
    if (typeof t == "function") {
      if (typeof e == "object")
        throw new TypeError("Bad combination of arguments.");
      return Ee(this, (n, s) => {
        ee(n) && cn(n, e, t.call(n, s, ms(n, e, this.options.xmlMode)), this.options.xmlMode);
      });
    }
    return Ee(this, (n) => {
      if (ee(n))
        if (typeof e == "object")
          for (const s of Object.keys(e)) {
            const a = e[s];
            cn(n, s, a, this.options.xmlMode);
          }
        else
          cn(n, e, t, this.options.xmlMode);
    });
  }
}
function ps(e, t, r) {
  var n;
  (n = e.data) !== null && n !== void 0 || (e.data = {}), typeof t == "object" ? Object.assign(e.data, t) : typeof t == "string" && r !== void 0 && (e.data[t] = r);
}
function Ic(e) {
  for (const t of Object.keys(e.attribs)) {
    if (!t.startsWith(o0))
      continue;
    const r = gc(t.slice(o0.length));
    or.call(e.data, r) || (e.data[r] = li(e.attribs[t]));
  }
  return e.data;
}
function vc(e, t) {
  const r = o0 + Cc(t), n = e.data;
  if (or.call(n, t))
    return n[t];
  if (or.call(e.attribs, r))
    return n[t] = li(e.attribs[r]);
}
function li(e) {
  if (e === "null")
    return null;
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  const t = Number(e);
  if (e === String(t))
    return t;
  if (Dc.test(e))
    try {
      return JSON.parse(e);
    } catch {
    }
  return e;
}
function Bc(e, t) {
  var r;
  const n = this[0];
  if (!n || !ee(n))
    return;
  const s = n;
  return (r = s.data) !== null && r !== void 0 || (s.data = {}), e == null ? Ic(s) : typeof e == "object" || t !== void 0 ? (Ee(this, (a) => {
    ee(a) && (typeof e == "object" ? ps(a, e) : ps(a, e, t));
  }), this) : vc(s, e);
}
function Oc(e) {
  const t = arguments.length === 0, r = this[0];
  if (!r || !ee(r))
    return t ? void 0 : this;
  switch (r.name) {
    case "textarea":
      return this.text(e);
    case "select": {
      const n = this.find("option:selected");
      if (!t) {
        if (this.attr("multiple") == null && typeof e == "object")
          return this;
        this.find("option").removeAttr("selected");
        const s = typeof e == "object" ? e : [e];
        for (const a of s)
          this.find(`option[value="${a}"]`).attr("selected", "");
        return this;
      }
      return this.attr("multiple") ? n.toArray().map((s) => ur(s.children)) : n.attr("value");
    }
    case "input":
    case "option":
      return t ? this.attr("value") : this.attr("value", e);
  }
}
function fi(e, t) {
  !e.attribs || !or.call(e.attribs, t) || delete e.attribs[t];
}
function Rr(e) {
  return e ? e.trim().split(cr) : [];
}
function yc(e) {
  const t = Rr(e);
  for (const r of t)
    Ee(this, (n) => {
      ee(n) && fi(n, r);
    });
  return this;
}
function Rc(e) {
  return this.toArray().some((t) => {
    const r = ee(t) && t.attribs.class;
    let n = -1;
    if (r && e.length > 0)
      for (; (n = r.indexOf(e, n + 1)) > -1; ) {
        const s = n + e.length;
        if ((n === 0 || cr.test(r[n - 1])) && (s === r.length || cr.test(r[s])))
          return !0;
      }
    return !1;
  });
}
function di(e) {
  if (typeof e == "function")
    return Ee(this, (n, s) => {
      if (ee(n)) {
        const a = n.attribs.class || "";
        di.call([n], e.call(n, s, a));
      }
    });
  if (!e || typeof e != "string")
    return this;
  const t = e.split(cr), r = this.length;
  for (let n = 0; n < r; n++) {
    const s = this[n];
    if (!ee(s))
      continue;
    const a = yr(s, "class", !1);
    if (a) {
      let u = ` ${a} `;
      for (const o of t) {
        const f = `${o} `;
        u.includes(` ${f}`) || (u += f);
      }
      Pt(s, "class", u.trim());
    } else
      Pt(s, "class", t.join(" ").trim());
  }
  return this;
}
function hi(e) {
  if (typeof e == "function")
    return Ee(this, (s, a) => {
      ee(s) && hi.call([s], e.call(s, a, s.attribs.class || ""));
    });
  const t = Rr(e), r = t.length, n = arguments.length === 0;
  return Ee(this, (s) => {
    if (ee(s))
      if (n)
        s.attribs.class = "";
      else {
        const a = Rr(s.attribs.class);
        let u = !1;
        for (let o = 0; o < r; o++) {
          const f = a.indexOf(t[o]);
          f >= 0 && (a.splice(f, 1), u = !0, o--);
        }
        u && (s.attribs.class = a.join(" "));
      }
  });
}
function Ei(e, t) {
  if (typeof e == "function")
    return Ee(this, (u, o) => {
      ee(u) && Ei.call([u], e.call(u, o, u.attribs.class || "", t), t);
    });
  if (!e || typeof e != "string")
    return this;
  const r = e.split(cr), n = r.length, s = typeof t == "boolean" ? t ? 1 : -1 : 0, a = this.length;
  for (let u = 0; u < a; u++) {
    const o = this[u];
    if (!ee(o))
      continue;
    const f = Rr(o.attribs.class);
    for (let c = 0; c < n; c++) {
      const l = f.indexOf(r[c]);
      s >= 0 && l < 0 ? f.push(r[c]) : s <= 0 && l >= 0 && f.splice(l, 1);
    }
    o.attribs.class = f.join(" ");
  }
  return this;
}
const Lc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addClass: di,
  attr: Sc,
  data: Bc,
  hasClass: Rc,
  prop: Nc,
  removeAttr: yc,
  removeClass: hi,
  toggleClass: Ei,
  val: Oc
}, Symbol.toStringTag, { value: "Module" }));
var Z;
(function(e) {
  e.Attribute = "attribute", e.Pseudo = "pseudo", e.PseudoElement = "pseudo-element", e.Tag = "tag", e.Universal = "universal", e.Adjacent = "adjacent", e.Child = "child", e.Descendant = "descendant", e.Parent = "parent", e.Sibling = "sibling", e.ColumnCombinator = "column-combinator";
})(Z || (Z = {}));
var be;
(function(e) {
  e.Any = "any", e.Element = "element", e.End = "end", e.Equals = "equals", e.Exists = "exists", e.Hyphen = "hyphen", e.Not = "not", e.Start = "start";
})(be || (be = {}));
const bs = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, Fc = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, Pc = /* @__PURE__ */ new Map([
  [126, be.Element],
  [94, be.Start],
  [36, be.End],
  [42, be.Any],
  [33, be.Not],
  [124, be.Hyphen]
]), kc = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function Zt(e) {
  switch (e.type) {
    case Z.Adjacent:
    case Z.Child:
    case Z.Descendant:
    case Z.Parent:
    case Z.Sibling:
    case Z.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const wc = /* @__PURE__ */ new Set(["contains", "icontains"]);
function Mc(e, t, r) {
  const n = parseInt(t, 16) - 65536;
  return n !== n || r ? t : n < 0 ? (
    // BMP codepoint
    String.fromCharCode(n + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(n >> 10 | 55296, n & 1023 | 56320)
  );
}
function Gt(e) {
  return e.replace(Fc, Mc);
}
function ln(e) {
  return e === 39 || e === 34;
}
function Ts(e) {
  return e === 32 || e === 9 || e === 10 || e === 12 || e === 13;
}
function Vr(e) {
  const t = [], r = xi(t, `${e}`, 0);
  if (r < e.length)
    throw new Error(`Unmatched selector: ${e.slice(r)}`);
  return t;
}
function xi(e, t, r) {
  let n = [];
  function s(d) {
    const p = t.slice(r + d).match(bs);
    if (!p)
      throw new Error(`Expected name, found ${t.slice(r)}`);
    const [h] = p;
    return r += d + h.length, Gt(h);
  }
  function a(d) {
    for (r += d; r < t.length && Ts(t.charCodeAt(r)); )
      r++;
  }
  function u() {
    r += 1;
    const d = r;
    let p = 1;
    for (; p > 0 && r < t.length; r++)
      t.charCodeAt(r) === 40 && !o(r) ? p++ : t.charCodeAt(r) === 41 && !o(r) && p--;
    if (p)
      throw new Error("Parenthesis not matched");
    return Gt(t.slice(d, r - 1));
  }
  function o(d) {
    let p = 0;
    for (; t.charCodeAt(--d) === 92; )
      p++;
    return (p & 1) === 1;
  }
  function f() {
    if (n.length > 0 && Zt(n[n.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function c(d) {
    if (n.length > 0 && n[n.length - 1].type === Z.Descendant) {
      n[n.length - 1].type = d;
      return;
    }
    f(), n.push({ type: d });
  }
  function l(d, p) {
    n.push({
      type: Z.Attribute,
      name: d,
      action: p,
      value: s(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function x() {
    if (n.length && n[n.length - 1].type === Z.Descendant && n.pop(), n.length === 0)
      throw new Error("Empty sub-selector");
    e.push(n);
  }
  if (a(0), t.length === r)
    return r;
  e: for (; r < t.length; ) {
    const d = t.charCodeAt(r);
    switch (d) {
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        (n.length === 0 || n[0].type !== Z.Descendant) && (f(), n.push({ type: Z.Descendant })), a(1);
        break;
      }
      case 62: {
        c(Z.Child), a(1);
        break;
      }
      case 60: {
        c(Z.Parent), a(1);
        break;
      }
      case 126: {
        c(Z.Sibling), a(1);
        break;
      }
      case 43: {
        c(Z.Adjacent), a(1);
        break;
      }
      case 46: {
        l("class", be.Element);
        break;
      }
      case 35: {
        l("id", be.Equals);
        break;
      }
      case 91: {
        a(1);
        let p, h = null;
        t.charCodeAt(r) === 124 ? p = s(1) : t.startsWith("*|", r) ? (h = "*", p = s(2)) : (p = s(0), t.charCodeAt(r) === 124 && t.charCodeAt(r + 1) !== 61 && (h = p, p = s(1))), a(0);
        let m = be.Exists;
        const E = Pc.get(t.charCodeAt(r));
        if (E) {
          if (m = E, t.charCodeAt(r + 1) !== 61)
            throw new Error("Expected `=`");
          a(2);
        } else t.charCodeAt(r) === 61 && (m = be.Equals, a(1));
        let D = "", b = null;
        if (m !== "exists") {
          if (ln(t.charCodeAt(r))) {
            const N = t.charCodeAt(r);
            let I = r + 1;
            for (; I < t.length && (t.charCodeAt(I) !== N || o(I)); )
              I += 1;
            if (t.charCodeAt(I) !== N)
              throw new Error("Attribute value didn't end");
            D = Gt(t.slice(r + 1, I)), r = I + 1;
          } else {
            const N = r;
            for (; r < t.length && (!Ts(t.charCodeAt(r)) && t.charCodeAt(r) !== 93 || o(r)); )
              r += 1;
            D = Gt(t.slice(N, r));
          }
          a(0);
          const g = t.charCodeAt(r) | 32;
          g === 115 ? (b = !1, a(1)) : g === 105 && (b = !0, a(1));
        }
        if (t.charCodeAt(r) !== 93)
          throw new Error("Attribute selector didn't terminate");
        r += 1;
        const A = {
          type: Z.Attribute,
          name: p,
          action: m,
          value: D,
          namespace: h,
          ignoreCase: b
        };
        n.push(A);
        break;
      }
      case 58: {
        if (t.charCodeAt(r + 1) === 58) {
          n.push({
            type: Z.PseudoElement,
            name: s(2).toLowerCase(),
            data: t.charCodeAt(r) === 40 ? u() : null
          });
          continue;
        }
        const p = s(1).toLowerCase();
        let h = null;
        if (t.charCodeAt(r) === 40)
          if (kc.has(p)) {
            if (ln(t.charCodeAt(r + 1)))
              throw new Error(`Pseudo-selector ${p} cannot be quoted`);
            if (h = [], r = xi(h, t, r + 1), t.charCodeAt(r) !== 41)
              throw new Error(`Missing closing parenthesis in :${p} (${t})`);
            r += 1;
          } else {
            if (h = u(), wc.has(p)) {
              const m = h.charCodeAt(0);
              m === h.charCodeAt(h.length - 1) && ln(m) && (h = h.slice(1, -1));
            }
            h = Gt(h);
          }
        n.push({ type: Z.Pseudo, name: p, data: h });
        break;
      }
      case 44: {
        x(), n = [], a(1);
        break;
      }
      default: {
        if (t.startsWith("/*", r)) {
          const m = t.indexOf("*/", r + 2);
          if (m < 0)
            throw new Error("Comment was not terminated");
          r = m + 2, n.length === 0 && a(0);
          break;
        }
        let p = null, h;
        if (d === 42)
          r += 1, h = "*";
        else if (d === 124) {
          if (h = "", t.charCodeAt(r + 1) === 124) {
            c(Z.ColumnCombinator), a(2);
            break;
          }
        } else if (bs.test(t.slice(r)))
          h = s(0);
        else
          break e;
        t.charCodeAt(r) === 124 && t.charCodeAt(r + 1) !== 124 && (p = h, t.charCodeAt(r + 1) === 42 ? (h = "*", r += 2) : h = s(1)), n.push(h === "*" ? { type: Z.Universal, namespace: p } : { type: Z.Tag, name: h, namespace: p });
      }
    }
  }
  return x(), r;
}
var Lr = {
  trueFunc: function() {
    return !0;
  },
  falseFunc: function() {
    return !1;
  }
};
const ae = /* @__PURE__ */ Mt(Lr), mi = /* @__PURE__ */ new Map([
  [Z.Universal, 50],
  [Z.Tag, 30],
  [Z.Attribute, 1],
  [Z.Pseudo, 0]
]);
function k0(e) {
  return !mi.has(e.type);
}
const Hc = /* @__PURE__ */ new Map([
  [be.Exists, 10],
  [be.Equals, 8],
  [be.Not, 7],
  [be.Start, 6],
  [be.End, 6],
  [be.Any, 5]
]);
function Uc(e) {
  const t = e.map(pi);
  for (let r = 1; r < e.length; r++) {
    const n = t[r];
    if (!(n < 0))
      for (let s = r - 1; s >= 0 && n < t[s]; s--) {
        const a = e[s + 1];
        e[s + 1] = e[s], e[s] = a, t[s + 1] = t[s], t[s] = n;
      }
  }
}
function pi(e) {
  var t, r;
  let n = (t = mi.get(e.type)) !== null && t !== void 0 ? t : -1;
  return e.type === Z.Attribute ? (n = (r = Hc.get(e.action)) !== null && r !== void 0 ? r : 4, e.action === be.Equals && e.name === "id" && (n = 9), e.ignoreCase && (n >>= 1)) : e.type === Z.Pseudo && (e.data ? e.name === "has" || e.name === "contains" ? n = 0 : Array.isArray(e.data) ? (n = Math.min(...e.data.map((s) => Math.min(...s.map(pi)))), n < 0 && (n = 0)) : n = 2 : n = 3), n;
}
const qc = /[-[\]{}()*+?.,\\^$|#\s]/g;
function As(e) {
  return e.replace(qc, "\\$&");
}
const Yc = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function mt(e, t) {
  return typeof e.ignoreCase == "boolean" ? e.ignoreCase : e.ignoreCase === "quirks" ? !!t.quirksMode : !t.xmlMode && Yc.has(e.name);
}
const $c = {
  equals(e, t, r) {
    const { adapter: n } = r, { name: s } = t;
    let { value: a } = t;
    return mt(t, r) ? (a = a.toLowerCase(), (u) => {
      const o = n.getAttributeValue(u, s);
      return o != null && o.length === a.length && o.toLowerCase() === a && e(u);
    }) : (u) => n.getAttributeValue(u, s) === a && e(u);
  },
  hyphen(e, t, r) {
    const { adapter: n } = r, { name: s } = t;
    let { value: a } = t;
    const u = a.length;
    return mt(t, r) ? (a = a.toLowerCase(), function(f) {
      const c = n.getAttributeValue(f, s);
      return c != null && (c.length === u || c.charAt(u) === "-") && c.substr(0, u).toLowerCase() === a && e(f);
    }) : function(f) {
      const c = n.getAttributeValue(f, s);
      return c != null && (c.length === u || c.charAt(u) === "-") && c.substr(0, u) === a && e(f);
    };
  },
  element(e, t, r) {
    const { adapter: n } = r, { name: s, value: a } = t;
    if (/\s/.test(a))
      return ae.falseFunc;
    const u = new RegExp(`(?:^|\\s)${As(a)}(?:$|\\s)`, mt(t, r) ? "i" : "");
    return function(f) {
      const c = n.getAttributeValue(f, s);
      return c != null && c.length >= a.length && u.test(c) && e(f);
    };
  },
  exists(e, { name: t }, { adapter: r }) {
    return (n) => r.hasAttrib(n, t) && e(n);
  },
  start(e, t, r) {
    const { adapter: n } = r, { name: s } = t;
    let { value: a } = t;
    const u = a.length;
    return u === 0 ? ae.falseFunc : mt(t, r) ? (a = a.toLowerCase(), (o) => {
      const f = n.getAttributeValue(o, s);
      return f != null && f.length >= u && f.substr(0, u).toLowerCase() === a && e(o);
    }) : (o) => {
      var f;
      return !!(!((f = n.getAttributeValue(o, s)) === null || f === void 0) && f.startsWith(a)) && e(o);
    };
  },
  end(e, t, r) {
    const { adapter: n } = r, { name: s } = t;
    let { value: a } = t;
    const u = -a.length;
    return u === 0 ? ae.falseFunc : mt(t, r) ? (a = a.toLowerCase(), (o) => {
      var f;
      return ((f = n.getAttributeValue(o, s)) === null || f === void 0 ? void 0 : f.substr(u).toLowerCase()) === a && e(o);
    }) : (o) => {
      var f;
      return !!(!((f = n.getAttributeValue(o, s)) === null || f === void 0) && f.endsWith(a)) && e(o);
    };
  },
  any(e, t, r) {
    const { adapter: n } = r, { name: s, value: a } = t;
    if (a === "")
      return ae.falseFunc;
    if (mt(t, r)) {
      const u = new RegExp(As(a), "i");
      return function(f) {
        const c = n.getAttributeValue(f, s);
        return c != null && c.length >= a.length && u.test(c) && e(f);
      };
    }
    return (u) => {
      var o;
      return !!(!((o = n.getAttributeValue(u, s)) === null || o === void 0) && o.includes(a)) && e(u);
    };
  },
  not(e, t, r) {
    const { adapter: n } = r, { name: s } = t;
    let { value: a } = t;
    return a === "" ? (u) => !!n.getAttributeValue(u, s) && e(u) : mt(t, r) ? (a = a.toLowerCase(), (u) => {
      const o = n.getAttributeValue(u, s);
      return (o == null || o.length !== a.length || o.toLowerCase() !== a) && e(u);
    }) : (u) => n.getAttributeValue(u, s) !== a && e(u);
  }
}, Wc = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), _s = 48, zc = 57;
function Gc(e) {
  if (e = e.trim().toLowerCase(), e === "even")
    return [2, 0];
  if (e === "odd")
    return [2, 1];
  let t = 0, r = 0, n = a(), s = u();
  if (t < e.length && e.charAt(t) === "n" && (t++, r = n * (s ?? 1), o(), t < e.length ? (n = a(), o(), s = u()) : n = s = 0), s === null || t < e.length)
    throw new Error(`n-th rule couldn't be parsed ('${e}')`);
  return [r, n * s];
  function a() {
    return e.charAt(t) === "-" ? (t++, -1) : (e.charAt(t) === "+" && t++, 1);
  }
  function u() {
    const f = t;
    let c = 0;
    for (; t < e.length && e.charCodeAt(t) >= _s && e.charCodeAt(t) <= zc; )
      c = c * 10 + (e.charCodeAt(t) - _s), t++;
    return t === f ? null : c;
  }
  function o() {
    for (; t < e.length && Wc.has(e.charCodeAt(t)); )
      t++;
  }
}
function Vc(e) {
  const t = e[0], r = e[1] - 1;
  if (r < 0 && t <= 0)
    return ae.falseFunc;
  if (t === -1)
    return (a) => a <= r;
  if (t === 0)
    return (a) => a === r;
  if (t === 1)
    return r < 0 ? ae.trueFunc : (a) => a >= r;
  const n = Math.abs(t), s = (r % n + n) % n;
  return t > 1 ? (a) => a >= r && a % n === s : (a) => a <= r && a % n === s;
}
function Tr(e) {
  return Vc(Gc(e));
}
function Ar(e, t) {
  return (r) => {
    const n = t.getParent(r);
    return n != null && t.isTag(n) && e(r);
  };
}
const c0 = {
  contains(e, t, { adapter: r }) {
    return function(s) {
      return e(s) && r.getText(s).includes(t);
    };
  },
  icontains(e, t, { adapter: r }) {
    const n = t.toLowerCase();
    return function(a) {
      return e(a) && r.getText(a).toLowerCase().includes(n);
    };
  },
  // Location specific methods
  "nth-child"(e, t, { adapter: r, equals: n }) {
    const s = Tr(t);
    return s === ae.falseFunc ? ae.falseFunc : s === ae.trueFunc ? Ar(e, r) : function(u) {
      const o = r.getSiblings(u);
      let f = 0;
      for (let c = 0; c < o.length && !n(u, o[c]); c++)
        r.isTag(o[c]) && f++;
      return s(f) && e(u);
    };
  },
  "nth-last-child"(e, t, { adapter: r, equals: n }) {
    const s = Tr(t);
    return s === ae.falseFunc ? ae.falseFunc : s === ae.trueFunc ? Ar(e, r) : function(u) {
      const o = r.getSiblings(u);
      let f = 0;
      for (let c = o.length - 1; c >= 0 && !n(u, o[c]); c--)
        r.isTag(o[c]) && f++;
      return s(f) && e(u);
    };
  },
  "nth-of-type"(e, t, { adapter: r, equals: n }) {
    const s = Tr(t);
    return s === ae.falseFunc ? ae.falseFunc : s === ae.trueFunc ? Ar(e, r) : function(u) {
      const o = r.getSiblings(u);
      let f = 0;
      for (let c = 0; c < o.length; c++) {
        const l = o[c];
        if (n(u, l))
          break;
        r.isTag(l) && r.getName(l) === r.getName(u) && f++;
      }
      return s(f) && e(u);
    };
  },
  "nth-last-of-type"(e, t, { adapter: r, equals: n }) {
    const s = Tr(t);
    return s === ae.falseFunc ? ae.falseFunc : s === ae.trueFunc ? Ar(e, r) : function(u) {
      const o = r.getSiblings(u);
      let f = 0;
      for (let c = o.length - 1; c >= 0; c--) {
        const l = o[c];
        if (n(u, l))
          break;
        r.isTag(l) && r.getName(l) === r.getName(u) && f++;
      }
      return s(f) && e(u);
    };
  },
  // TODO determine the actual root element
  root(e, t, { adapter: r }) {
    return (n) => {
      const s = r.getParent(n);
      return (s == null || !r.isTag(s)) && e(n);
    };
  },
  scope(e, t, r, n) {
    const { equals: s } = r;
    return !n || n.length === 0 ? c0.root(e, t, r) : n.length === 1 ? (a) => s(n[0], a) && e(a) : (a) => n.includes(a) && e(a);
  },
  hover: fn("isHovered"),
  visited: fn("isVisited"),
  active: fn("isActive")
};
function fn(e) {
  return function(r, n, { adapter: s }) {
    const a = s[e];
    return typeof a != "function" ? ae.falseFunc : function(o) {
      return a(o) && r(o);
    };
  };
}
const gs = {
  empty(e, { adapter: t }) {
    return !t.getChildren(e).some((r) => (
      // FIXME: `getText` call is potentially expensive.
      t.isTag(r) || t.getText(r) !== ""
    ));
  },
  "first-child"(e, { adapter: t, equals: r }) {
    if (t.prevElementSibling)
      return t.prevElementSibling(e) == null;
    const n = t.getSiblings(e).find((s) => t.isTag(s));
    return n != null && r(e, n);
  },
  "last-child"(e, { adapter: t, equals: r }) {
    const n = t.getSiblings(e);
    for (let s = n.length - 1; s >= 0; s--) {
      if (r(e, n[s]))
        return !0;
      if (t.isTag(n[s]))
        break;
    }
    return !1;
  },
  "first-of-type"(e, { adapter: t, equals: r }) {
    const n = t.getSiblings(e), s = t.getName(e);
    for (let a = 0; a < n.length; a++) {
      const u = n[a];
      if (r(e, u))
        return !0;
      if (t.isTag(u) && t.getName(u) === s)
        break;
    }
    return !1;
  },
  "last-of-type"(e, { adapter: t, equals: r }) {
    const n = t.getSiblings(e), s = t.getName(e);
    for (let a = n.length - 1; a >= 0; a--) {
      const u = n[a];
      if (r(e, u))
        return !0;
      if (t.isTag(u) && t.getName(u) === s)
        break;
    }
    return !1;
  },
  "only-of-type"(e, { adapter: t, equals: r }) {
    const n = t.getName(e);
    return t.getSiblings(e).every((s) => r(e, s) || !t.isTag(s) || t.getName(s) !== n);
  },
  "only-child"(e, { adapter: t, equals: r }) {
    return t.getSiblings(e).every((n) => r(e, n) || !t.isTag(n));
  }
};
function Cs(e, t, r, n) {
  if (r === null) {
    if (e.length > n)
      throw new Error(`Pseudo-class :${t} requires an argument`);
  } else if (e.length === n)
    throw new Error(`Pseudo-class :${t} doesn't have any arguments`);
}
const Qc = {
  // Links
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  // Forms
  // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
  disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  // JQuery extensions
  // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
}, bi = {};
function jc(e, t) {
  return e === ae.falseFunc ? ae.falseFunc : (r) => t.isTag(r) && e(r);
}
function Ti(e, t) {
  const r = t.getSiblings(e);
  if (r.length <= 1)
    return [];
  const n = r.indexOf(e);
  return n < 0 || n === r.length - 1 ? [] : r.slice(n + 1).filter(t.isTag);
}
function l0(e) {
  return {
    xmlMode: !!e.xmlMode,
    lowerCaseAttributeNames: !!e.lowerCaseAttributeNames,
    lowerCaseTags: !!e.lowerCaseTags,
    quirksMode: !!e.quirksMode,
    cacheResults: !!e.cacheResults,
    pseudos: e.pseudos,
    adapter: e.adapter,
    equals: e.equals
  };
}
const dn = (e, t, r, n, s) => {
  const a = s(t, l0(r), n);
  return a === ae.trueFunc ? e : a === ae.falseFunc ? ae.falseFunc : (u) => a(u) && e(u);
}, hn = {
  is: dn,
  /**
   * `:matches` and `:where` are aliases for `:is`.
   */
  matches: dn,
  where: dn,
  not(e, t, r, n, s) {
    const a = s(t, l0(r), n);
    return a === ae.falseFunc ? e : a === ae.trueFunc ? ae.falseFunc : (u) => !a(u) && e(u);
  },
  has(e, t, r, n, s) {
    const { adapter: a } = r, u = l0(r);
    u.relativeSelector = !0;
    const o = t.some((l) => l.some(k0)) ? (
      // Used as a placeholder. Will be replaced with the actual element.
      [bi]
    ) : void 0, f = s(t, u, o);
    if (f === ae.falseFunc)
      return ae.falseFunc;
    const c = jc(f, a);
    if (o && f !== ae.trueFunc) {
      const { shouldTestNextSiblings: l = !1 } = f;
      return (x) => {
        if (!e(x))
          return !1;
        o[0] = x;
        const d = a.getChildren(x), p = l ? [...d, ...Ti(x, a)] : d;
        return a.existsOne(c, p);
      };
    }
    return (l) => e(l) && a.existsOne(c, a.getChildren(l));
  }
};
function Kc(e, t, r, n, s) {
  var a;
  const { name: u, data: o } = t;
  if (Array.isArray(o)) {
    if (!(u in hn))
      throw new Error(`Unknown pseudo-class :${u}(${o})`);
    return hn[u](e, o, r, n, s);
  }
  const f = (a = r.pseudos) === null || a === void 0 ? void 0 : a[u], c = typeof f == "string" ? f : Qc[u];
  if (typeof c == "string") {
    if (o != null)
      throw new Error(`Pseudo ${u} doesn't have any arguments`);
    const l = Vr(c);
    return hn.is(e, l, r, n, s);
  }
  if (typeof f == "function")
    return Cs(f, u, o, 1), (l) => f(l, o) && e(l);
  if (u in c0)
    return c0[u](e, o, r, n);
  if (u in gs) {
    const l = gs[u];
    return Cs(l, u, o, 2), (x) => l(x, r, o) && e(x);
  }
  throw new Error(`Unknown pseudo-class :${u}`);
}
function En(e, t) {
  const r = t.getParent(e);
  return r && t.isTag(r) ? r : null;
}
function Xc(e, t, r, n, s) {
  const { adapter: a, equals: u } = r;
  switch (t.type) {
    case Z.PseudoElement:
      throw new Error("Pseudo-elements are not supported by css-select");
    case Z.ColumnCombinator:
      throw new Error("Column combinators are not yet supported by css-select");
    case Z.Attribute: {
      if (t.namespace != null)
        throw new Error("Namespaced attributes are not yet supported by css-select");
      return (!r.xmlMode || r.lowerCaseAttributeNames) && (t.name = t.name.toLowerCase()), $c[t.action](e, t, r);
    }
    case Z.Pseudo:
      return Kc(e, t, r, n, s);
    case Z.Tag: {
      if (t.namespace != null)
        throw new Error("Namespaced tag names are not yet supported by css-select");
      let { name: o } = t;
      return (!r.xmlMode || r.lowerCaseTags) && (o = o.toLowerCase()), function(c) {
        return a.getName(c) === o && e(c);
      };
    }
    case Z.Descendant: {
      if (r.cacheResults === !1 || typeof WeakSet > "u")
        return function(c) {
          let l = c;
          for (; l = En(l, a); )
            if (e(l))
              return !0;
          return !1;
        };
      const o = /* @__PURE__ */ new WeakSet();
      return function(c) {
        let l = c;
        for (; l = En(l, a); )
          if (!o.has(l)) {
            if (a.isTag(l) && e(l))
              return !0;
            o.add(l);
          }
        return !1;
      };
    }
    case "_flexibleDescendant":
      return function(f) {
        let c = f;
        do
          if (e(c))
            return !0;
        while (c = En(c, a));
        return !1;
      };
    case Z.Parent:
      return function(f) {
        return a.getChildren(f).some((c) => a.isTag(c) && e(c));
      };
    case Z.Child:
      return function(f) {
        const c = a.getParent(f);
        return c != null && a.isTag(c) && e(c);
      };
    case Z.Sibling:
      return function(f) {
        const c = a.getSiblings(f);
        for (let l = 0; l < c.length; l++) {
          const x = c[l];
          if (u(f, x))
            break;
          if (a.isTag(x) && e(x))
            return !0;
        }
        return !1;
      };
    case Z.Adjacent:
      return a.prevElementSibling ? function(f) {
        const c = a.prevElementSibling(f);
        return c != null && e(c);
      } : function(f) {
        const c = a.getSiblings(f);
        let l;
        for (let x = 0; x < c.length; x++) {
          const d = c[x];
          if (u(f, d))
            break;
          a.isTag(d) && (l = d);
        }
        return !!l && e(l);
      };
    case Z.Universal: {
      if (t.namespace != null && t.namespace !== "*")
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      return e;
    }
  }
}
function Ai(e) {
  return e.type === Z.Pseudo && (e.name === "scope" || Array.isArray(e.data) && e.data.some((t) => t.some(Ai)));
}
const Zc = { type: Z.Descendant }, Jc = {
  type: "_flexibleDescendant"
}, el = {
  type: Z.Pseudo,
  name: "scope",
  data: null
};
function tl(e, { adapter: t }, r) {
  const n = !!r?.every((s) => {
    const a = t.isTag(s) && t.getParent(s);
    return s === bi || a && t.isTag(a);
  });
  for (const s of e) {
    if (!(s.length > 0 && k0(s[0]) && s[0].type !== Z.Descendant)) if (n && !s.some(Ai))
      s.unshift(Zc);
    else
      continue;
    s.unshift(el);
  }
}
function _i(e, t, r) {
  var n;
  e.forEach(Uc), r = (n = t.context) !== null && n !== void 0 ? n : r;
  const s = Array.isArray(r), a = r && (Array.isArray(r) ? r : [r]);
  if (t.relativeSelector !== !1)
    tl(e, t, a);
  else if (e.some((f) => f.length > 0 && k0(f[0])))
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  let u = !1;
  const o = e.map((f) => {
    if (f.length >= 2) {
      const [c, l] = f;
      c.type !== Z.Pseudo || c.name !== "scope" || (s && l.type === Z.Descendant ? f[1] = Jc : (l.type === Z.Adjacent || l.type === Z.Sibling) && (u = !0));
    }
    return rl(f, t, a);
  }).reduce(nl, ae.falseFunc);
  return o.shouldTestNextSiblings = u, o;
}
function rl(e, t, r) {
  var n;
  return e.reduce((s, a) => s === ae.falseFunc ? ae.falseFunc : Xc(s, a, t, r, _i), (n = t.rootFunc) !== null && n !== void 0 ? n : ae.trueFunc);
}
function nl(e, t) {
  return t === ae.falseFunc || e === ae.trueFunc ? e : e === ae.falseFunc || t === ae.trueFunc ? t : function(n) {
    return e(n) || t(n);
  };
}
const gi = (e, t) => e === t, sl = {
  adapter: Gr,
  equals: gi
};
function al(e) {
  var t, r, n, s;
  const a = e ?? sl;
  return (t = a.adapter) !== null && t !== void 0 || (a.adapter = Gr), (r = a.equals) !== null && r !== void 0 || (a.equals = (s = (n = a.adapter) === null || n === void 0 ? void 0 : n.equals) !== null && s !== void 0 ? s : gi), a;
}
function il(e) {
  return function(r, n, s) {
    const a = al(n);
    return e(r, a, s);
  };
}
const w0 = il(_i);
function Ci(e, t, r = !1) {
  return r && (e = ul(e, t)), Array.isArray(e) ? t.removeSubsets(e) : t.getChildren(e);
}
function ul(e, t) {
  const r = Array.isArray(e) ? e.slice(0) : [e], n = r.length;
  for (let s = 0; s < n; s++) {
    const a = Ti(r[s], t);
    r.push(...a);
  }
  return r;
}
const ol = /* @__PURE__ */ new Set([
  "first",
  "last",
  "eq",
  "gt",
  "nth",
  "lt",
  "even",
  "odd"
]);
function Fr(e) {
  return e.type !== "pseudo" ? !1 : ol.has(e.name) ? !0 : e.name === "not" && Array.isArray(e.data) ? e.data.some((t) => t.some(Fr)) : !1;
}
function cl(e, t, r) {
  const n = t != null ? parseInt(t, 10) : NaN;
  switch (e) {
    case "first":
      return 1;
    case "nth":
    case "eq":
      return isFinite(n) ? n >= 0 ? n + 1 : 1 / 0 : 0;
    case "lt":
      return isFinite(n) ? n >= 0 ? Math.min(n, r) : 1 / 0 : 0;
    case "gt":
      return isFinite(n) ? 1 / 0 : 0;
    case "odd":
      return 2 * r;
    case "even":
      return 2 * r - 1;
    case "last":
    case "not":
      return 1 / 0;
  }
}
function ll(e) {
  for (; e.parent; )
    e = e.parent;
  return e;
}
function M0(e) {
  const t = [], r = [];
  for (const n of e)
    n.some(Fr) ? t.push(n) : r.push(n);
  return [r, t];
}
const fl = {
  type: Z.Universal,
  namespace: null
}, dl = {
  type: Z.Pseudo,
  name: "scope",
  data: null
};
function Di(e, t, r = {}) {
  return Si([e], t, r);
}
function Si(e, t, r = {}) {
  if (typeof t == "function")
    return e.some(t);
  const [n, s] = M0(Vr(t));
  return n.length > 0 && e.some(w0(n, r)) || s.some((a) => vi(a, e, r).length > 0);
}
function hl(e, t, r, n) {
  const s = typeof r == "string" ? parseInt(r, 10) : NaN;
  switch (e) {
    case "first":
    case "lt":
      return t;
    case "last":
      return t.length > 0 ? [t[t.length - 1]] : t;
    case "nth":
    case "eq":
      return isFinite(s) && Math.abs(s) < t.length ? [s < 0 ? t[t.length + s] : t[s]] : [];
    case "gt":
      return isFinite(s) ? t.slice(s + 1) : [];
    case "even":
      return t.filter((a, u) => u % 2 === 0);
    case "odd":
      return t.filter((a, u) => u % 2 === 1);
    case "not": {
      const a = new Set(Ii(r, t, n));
      return t.filter((u) => !a.has(u));
    }
  }
}
function Ni(e, t, r = {}) {
  return Ii(Vr(e), t, r);
}
function Ii(e, t, r) {
  if (t.length === 0)
    return [];
  const [n, s] = M0(e);
  let a;
  if (n.length) {
    const u = d0(t, n, r);
    if (s.length === 0)
      return u;
    u.length && (a = new Set(u));
  }
  for (let u = 0; u < s.length && a?.size !== t.length; u++) {
    const o = s[u];
    if ((a ? t.filter((l) => ee(l) && !a.has(l)) : t).length === 0)
      break;
    const c = vi(o, t, r);
    if (c.length)
      if (a)
        c.forEach((l) => a.add(l));
      else {
        if (u === s.length - 1)
          return c;
        a = new Set(c);
      }
  }
  return typeof a < "u" ? a.size === t.length ? t : (
    // Filter elements to preserve order
    t.filter((u) => a.has(u))
  ) : [];
}
function vi(e, t, r) {
  var n;
  if (e.some(Zt)) {
    const s = (n = r.root) !== null && n !== void 0 ? n : ll(t[0]), a = { ...r, context: t, relativeSelector: !1 };
    return e.push(dl), Pr(s, e, a, !0, t.length);
  }
  return Pr(t, e, r, !1, t.length);
}
function El(e, t, r = {}, n = 1 / 0) {
  if (typeof e == "function")
    return Bi(t, e);
  const [s, a] = M0(Vr(e)), u = a.map((o) => Pr(t, o, r, !0, n));
  return s.length && u.push(f0(t, s, r, n)), u.length === 0 ? [] : u.length === 1 ? u[0] : Ut(u.reduce((o, f) => [...o, ...f]));
}
function Pr(e, t, r, n, s) {
  const a = t.findIndex(Fr), u = t.slice(0, a), o = t[a], f = t.length - 1 === a ? s : 1 / 0, c = cl(o.name, o.data, f);
  if (c === 0)
    return [];
  const x = (u.length === 0 && !Array.isArray(e) ? Wr(e).filter(ee) : u.length === 0 ? (Array.isArray(e) ? e : [e]).filter(ee) : n || u.some(Zt) ? f0(e, [u], r, c) : d0(e, [u], r)).slice(0, c);
  let d = hl(o.name, x, o.data, r);
  if (d.length === 0 || t.length === a + 1)
    return d;
  const p = t.slice(a + 1), h = p.some(Zt);
  if (h) {
    if (Zt(p[0])) {
      const { type: m } = p[0];
      (m === Z.Sibling || m === Z.Adjacent) && (d = Ci(d, Gr, !0)), p.unshift(fl);
    }
    r = {
      ...r,
      // Avoid absolutizing the selector
      relativeSelector: !1,
      /*
       * Add a custom root func, to make sure traversals don't match elements
       * that aren't a part of the considered tree.
       */
      rootFunc: (m) => d.includes(m)
    };
  } else r.rootFunc && r.rootFunc !== Lr.trueFunc && (r = { ...r, rootFunc: Lr.trueFunc });
  return p.some(Fr) ? Pr(d, p, r, !1, s) : h ? (
    // Query existing elements to resolve traversal.
    f0(d, [p], r, s)
  ) : (
    // If we don't have any more traversals, simply filter elements.
    d0(d, [p], r)
  );
}
function f0(e, t, r, n) {
  const s = w0(t, r, e);
  return Bi(e, s, n);
}
function Bi(e, t, r = 1 / 0) {
  const n = Ci(e, Gr, t.shouldTestNextSiblings);
  return L0((s) => ee(s) && t(s), n, !0, r);
}
function d0(e, t, r) {
  const n = (Array.isArray(e) ? e : [e]).filter(ee);
  if (n.length === 0)
    return n;
  const s = w0(t, r);
  return s === Lr.trueFunc ? n : n.filter(s);
}
const xl = /^\s*[+~]/;
function ml(e) {
  if (!e)
    return this._make([]);
  if (typeof e != "string") {
    const t = rt(e) ? e.toArray() : [e], r = this.toArray();
    return this._make(t.filter((n) => r.some((s) => ci(s, n))));
  }
  return this._findBySelector(e, Number.POSITIVE_INFINITY);
}
function pl(e, t) {
  var r;
  const n = this.toArray(), s = xl.test(e) ? n : this.children().toArray(), a = {
    context: n,
    root: (r = this._root) === null || r === void 0 ? void 0 : r[0],
    // Pass options that are recognized by `cheerio-select`
    xmlMode: this.options.xmlMode,
    lowerCaseTags: this.options.lowerCaseTags,
    lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
    pseudos: this.options.pseudos,
    quirksMode: this.options.quirksMode
  };
  return this._make(El(e, s, a, t));
}
function H0(e) {
  return function(t, ...r) {
    return function(n) {
      var s;
      let a = e(t, this);
      return n && (a = Y0(a, n, this.options.xmlMode, (s = this._root) === null || s === void 0 ? void 0 : s[0])), this._make(
        // Post processing is only necessary if there is more than one element.
        this.length > 1 && a.length > 1 ? r.reduce((u, o) => o(u), a) : a
      );
    };
  };
}
const dr = H0((e, t) => {
  let r = [];
  for (let n = 0; n < t.length; n++) {
    const s = e(t[n]);
    s.length > 0 && (r = r.concat(s));
  }
  return r;
}), U0 = H0((e, t) => {
  const r = [];
  for (let n = 0; n < t.length; n++) {
    const s = e(t[n]);
    s !== null && r.push(s);
  }
  return r;
});
function q0(e, ...t) {
  let r = null;
  const n = H0((s, a) => {
    const u = [];
    return Ee(a, (o) => {
      for (let f; (f = s(o)) && !r?.(f, u.length); o = f)
        u.push(f);
    }), u;
  })(e, ...t);
  return function(s, a) {
    r = typeof s == "string" ? (o) => Di(o, s, this.options) : s ? hr(s) : null;
    const u = n.call(this, a);
    return r = null, u;
  };
}
function qt(e) {
  return e.length > 1 ? Array.from(new Set(e)) : e;
}
const bl = U0(({ parent: e }) => e && !dt(e) ? e : null, qt), Tl = dr((e) => {
  const t = [];
  for (; e.parent && !dt(e.parent); )
    t.push(e.parent), e = e.parent;
  return t;
}, Ut, (e) => e.reverse()), Al = q0(({ parent: e }) => e && !dt(e) ? e : null, Ut, (e) => e.reverse());
function _l(e) {
  var t;
  const r = [];
  if (!e)
    return this._make(r);
  const n = {
    xmlMode: this.options.xmlMode,
    root: (t = this._root) === null || t === void 0 ? void 0 : t[0]
  }, s = typeof e == "string" ? (a) => Di(a, e, n) : hr(e);
  return Ee(this, (a) => {
    for (a && !dt(a) && !ee(a) && (a = a.parent); a && ee(a); ) {
      if (s(a, 0)) {
        r.includes(a) || r.push(a);
        break;
      }
      a = a.parent;
    }
  }), this._make(r);
}
const gl = U0((e) => y0(e)), Cl = dr((e) => {
  const t = [];
  for (; e.next; )
    e = e.next, ee(e) && t.push(e);
  return t;
}, qt), Dl = q0((e) => y0(e), qt), Sl = U0((e) => R0(e)), Nl = dr((e) => {
  const t = [];
  for (; e.prev; )
    e = e.prev, ee(e) && t.push(e);
  return t;
}, qt), Il = q0((e) => R0(e), qt), vl = dr((e) => ri(e).filter((t) => ee(t) && t !== e), Ut), Bl = dr((e) => Wr(e).filter(ee), qt);
function Ol() {
  const e = this.toArray().reduce((t, r) => ge(r) ? t.concat(r.children) : t, []);
  return this._make(e);
}
function yl(e) {
  let t = 0;
  const r = this.length;
  for (; t < r && e.call(this[t], t, this[t]) !== !1; )
    ++t;
  return this;
}
function Rl(e) {
  let t = [];
  for (let r = 0; r < this.length; r++) {
    const n = this[r], s = e.call(n, r, n);
    s != null && (t = t.concat(s));
  }
  return this._make(t);
}
function hr(e) {
  return typeof e == "function" ? (t, r) => e.call(t, r, t) : rt(e) ? (t) => Array.prototype.includes.call(e, t) : function(t) {
    return e === t;
  };
}
function Ll(e) {
  var t;
  return this._make(Y0(this.toArray(), e, this.options.xmlMode, (t = this._root) === null || t === void 0 ? void 0 : t[0]));
}
function Y0(e, t, r, n) {
  return typeof t == "string" ? Ni(t, e, { xmlMode: r, root: n }) : e.filter(hr(t));
}
function Fl(e) {
  const t = this.toArray();
  return typeof e == "string" ? Si(t.filter(ee), e, this.options) : e ? t.some(hr(e)) : !1;
}
function Pl(e) {
  let t = this.toArray();
  if (typeof e == "string") {
    const r = new Set(Ni(e, t, this.options));
    t = t.filter((n) => !r.has(n));
  } else {
    const r = hr(e);
    t = t.filter((n, s) => !r(n, s));
  }
  return this._make(t);
}
function kl(e) {
  return this.filter(typeof e == "string" ? (
    // Using the `:has` selector here short-circuits searches.
    `:has(${e})`
  ) : (t, r) => this._make(r).find(e).length > 0);
}
function wl() {
  return this.length > 1 ? this._make(this[0]) : this;
}
function Ml() {
  return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
function Hl(e) {
  var t;
  return e = +e, e === 0 && this.length <= 1 ? this : (e < 0 && (e = this.length + e), this._make((t = this[e]) !== null && t !== void 0 ? t : []));
}
function Ul(e) {
  return e == null ? this.toArray() : this[e < 0 ? this.length + e : e];
}
function ql() {
  return Array.prototype.slice.call(this);
}
function Yl(e) {
  let t, r;
  return e == null ? (t = this.parent().children(), r = this[0]) : typeof e == "string" ? (t = this._make(e), r = this[0]) : (t = this, r = rt(e) ? e[0] : e), Array.prototype.indexOf.call(t, r);
}
function $l(e, t) {
  return this._make(Array.prototype.slice.call(this, e, t));
}
function Wl() {
  var e;
  return (e = this.prevObject) !== null && e !== void 0 ? e : this._make([]);
}
function zl(e, t) {
  const r = this._make(e, t), n = Ut([...this.get(), ...r.get()]);
  return this._make(n);
}
function Gl(e) {
  return this.prevObject ? this.add(e ? this.prevObject.filter(e) : this.prevObject) : this;
}
const Vl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _findBySelector: pl,
  add: zl,
  addBack: Gl,
  children: Bl,
  closest: _l,
  contents: Ol,
  each: yl,
  end: Wl,
  eq: Hl,
  filter: Ll,
  filterArray: Y0,
  find: ml,
  first: wl,
  get: Ul,
  has: kl,
  index: Yl,
  is: Fl,
  last: Ml,
  map: Rl,
  next: gl,
  nextAll: Cl,
  nextUntil: Dl,
  not: Pl,
  parent: bl,
  parents: Tl,
  parentsUntil: Al,
  prev: Sl,
  prevAll: Nl,
  prevUntil: Il,
  siblings: vl,
  slice: $l,
  toArray: ql
}, Symbol.toStringTag, { value: "Module" }));
function Ql(e) {
  return function(r, n, s, a) {
    if (typeof Buffer < "u" && Buffer.isBuffer(r) && (r = r.toString()), typeof r == "string")
      return e(r, n, s, a);
    const u = r;
    if (!Array.isArray(u) && dt(u))
      return u;
    const o = new Ct([]);
    return Dt(u, o), o;
  };
}
function Dt(e, t) {
  const r = Array.isArray(e) ? e : [e];
  t ? t.children = r : t = null;
  for (let n = 0; n < r.length; n++) {
    const s = r[n];
    s.parent && s.parent.children !== r && It(s), t ? (s.prev = r[n - 1] || null, s.next = r[n + 1] || null) : s.prev = s.next = null, s.parent = t;
  }
  return t;
}
function jl(e, t) {
  if (e == null)
    return [];
  if (typeof e == "string")
    return this._parse(e, this.options, !1, null).children.slice(0);
  if ("length" in e) {
    if (e.length === 1)
      return this._makeDomArray(e[0], t);
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (typeof s == "object") {
        if (s == null)
          continue;
        if (!("length" in s)) {
          r.push(t ? ir(s, !0) : s);
          continue;
        }
      }
      r.push(...this._makeDomArray(s, t));
    }
    return r;
  }
  return [t ? ir(e, !0) : e];
}
function Oi(e) {
  return function(...t) {
    const r = this.length - 1;
    return Ee(this, (n, s) => {
      if (!ge(n))
        return;
      const a = typeof t[0] == "function" ? t[0].call(n, s, this._render(n.children)) : t, u = this._makeDomArray(a, s < r);
      e(u, n.children, n);
    });
  };
}
function ht(e, t, r, n, s) {
  var a, u;
  const o = [
    t,
    r,
    ...n
  ], f = t === 0 ? null : e[t - 1], c = t + r >= e.length ? null : e[t + r];
  for (let l = 0; l < n.length; ++l) {
    const x = n[l], d = x.parent;
    if (d) {
      const h = d.children.indexOf(x);
      h > -1 && (d.children.splice(h, 1), s === d && t > h && o[0]--);
    }
    x.parent = s, x.prev && (x.prev.next = (a = x.next) !== null && a !== void 0 ? a : null), x.next && (x.next.prev = (u = x.prev) !== null && u !== void 0 ? u : null), x.prev = l === 0 ? f : n[l - 1], x.next = l === n.length - 1 ? c : n[l + 1];
  }
  return f && (f.next = n[0]), c && (c.prev = n[n.length - 1]), e.splice(...o);
}
function Kl(e) {
  return (rt(e) ? e : this._make(e)).append(this), this;
}
function Xl(e) {
  return (rt(e) ? e : this._make(e)).prepend(this), this;
}
const Zl = Oi((e, t, r) => {
  ht(t, t.length, 0, e, r);
}), Jl = Oi((e, t, r) => {
  ht(t, 0, 0, e, r);
});
function yi(e) {
  return function(t) {
    const r = this.length - 1, n = this.parents().last();
    for (let s = 0; s < this.length; s++) {
      const a = this[s], u = typeof t == "function" ? t.call(a, s, a) : typeof t == "string" && !u0(t) ? n.find(t).clone() : t, [o] = this._makeDomArray(u, s < r);
      if (!o || !ge(o))
        continue;
      let f = o, c = 0;
      for (; c < f.children.length; ) {
        const l = f.children[c];
        ee(l) ? (f = l, c = 0) : c++;
      }
      e(a, f, [o]);
    }
    return this;
  };
}
const ef = yi((e, t, r) => {
  const { parent: n } = e;
  if (!n)
    return;
  const s = n.children, a = s.indexOf(e);
  Dt([e], t), ht(s, a, 0, r, n);
}), tf = yi((e, t, r) => {
  ge(e) && (Dt(e.children, t), Dt(r, e));
});
function rf(e) {
  return this.parent(e).not("body").each((t, r) => {
    this._make(r).replaceWith(r.children);
  }), this;
}
function nf(e) {
  const t = this[0];
  if (t) {
    const r = this._make(typeof e == "function" ? e.call(t, 0, t) : e).insertBefore(t);
    let n;
    for (let a = 0; a < r.length; a++)
      r[a].type === "tag" && (n = r[a]);
    let s = 0;
    for (; n && s < n.children.length; ) {
      const a = n.children[s];
      a.type === "tag" ? (n = a, s = 0) : s++;
    }
    n && this._make(n).append(this);
  }
  return this;
}
function sf(...e) {
  const t = this.length - 1;
  return Ee(this, (r, n) => {
    if (!ge(r) || !r.parent)
      return;
    const s = r.parent.children, a = s.indexOf(r);
    if (a < 0)
      return;
    const u = typeof e[0] == "function" ? e[0].call(r, n, this._render(r.children)) : e, o = this._makeDomArray(u, n < t);
    ht(s, a + 1, 0, o, r.parent);
  });
}
function af(e) {
  typeof e == "string" && (e = this._make(e)), this.remove();
  const t = [];
  for (const r of this._makeDomArray(e)) {
    const n = this.clone().toArray(), { parent: s } = r;
    if (!s)
      continue;
    const a = s.children, u = a.indexOf(r);
    u < 0 || (ht(a, u + 1, 0, n, s), t.push(...n));
  }
  return this._make(t);
}
function uf(...e) {
  const t = this.length - 1;
  return Ee(this, (r, n) => {
    if (!ge(r) || !r.parent)
      return;
    const s = r.parent.children, a = s.indexOf(r);
    if (a < 0)
      return;
    const u = typeof e[0] == "function" ? e[0].call(r, n, this._render(r.children)) : e, o = this._makeDomArray(u, n < t);
    ht(s, a, 0, o, r.parent);
  });
}
function of(e) {
  const t = this._make(e);
  this.remove();
  const r = [];
  return Ee(t, (n) => {
    const s = this.clone().toArray(), { parent: a } = n;
    if (!a)
      return;
    const u = a.children, o = u.indexOf(n);
    o < 0 || (ht(u, o, 0, s, a), r.push(...s));
  }), this._make(r);
}
function cf(e) {
  const t = e ? this.filter(e) : this;
  return Ee(t, (r) => {
    It(r), r.prev = r.next = r.parent = null;
  }), this;
}
function lf(e) {
  return Ee(this, (t, r) => {
    const { parent: n } = t;
    if (!n)
      return;
    const s = n.children, a = typeof e == "function" ? e.call(t, r, t) : e, u = this._makeDomArray(a);
    Dt(u, null);
    const o = s.indexOf(t);
    ht(s, o, 1, u, n), u.includes(t) || (t.parent = t.prev = t.next = null);
  });
}
function ff() {
  return Ee(this, (e) => {
    if (ge(e)) {
      for (const t of e.children)
        t.next = t.prev = t.parent = null;
      e.children.length = 0;
    }
  });
}
function df(e) {
  if (e === void 0) {
    const t = this[0];
    return !t || !ge(t) ? null : this._render(t.children);
  }
  return Ee(this, (t) => {
    if (!ge(t))
      return;
    for (const n of t.children)
      n.next = n.prev = n.parent = null;
    const r = rt(e) ? e.toArray() : this._parse(`${e}`, this.options, !1, t).children;
    Dt(r, t);
  });
}
function hf() {
  return this._render(this);
}
function Ef(e) {
  return e === void 0 ? ur(this) : typeof e == "function" ? Ee(this, (t, r) => this._make(t).text(e.call(t, r, ur([t])))) : Ee(this, (t) => {
    if (!ge(t))
      return;
    for (const n of t.children)
      n.next = n.prev = n.parent = null;
    const r = new ar(`${e}`);
    Dt(r, t);
  });
}
function xf() {
  const e = Array.prototype.map.call(this.get(), (r) => ir(r, !0)), t = new Ct(e);
  for (const r of e)
    r.parent = t;
  return this._make(e);
}
const mf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _makeDomArray: jl,
  after: sf,
  append: Zl,
  appendTo: Kl,
  before: uf,
  clone: xf,
  empty: ff,
  html: df,
  insertAfter: af,
  insertBefore: of,
  prepend: Jl,
  prependTo: Xl,
  remove: cf,
  replaceWith: lf,
  text: Ef,
  toString: hf,
  unwrap: rf,
  wrap: ef,
  wrapAll: nf,
  wrapInner: tf
}, Symbol.toStringTag, { value: "Module" }));
function pf(e, t) {
  if (e != null && t != null || // When `prop` is a "plain" object
  typeof e == "object" && !Array.isArray(e))
    return Ee(this, (r, n) => {
      ee(r) && Ri(r, e, t, n);
    });
  if (this.length !== 0)
    return Li(this[0], e);
}
function Ri(e, t, r, n) {
  if (typeof t == "string") {
    const s = Li(e), a = typeof r == "function" ? r.call(e, n, s[t]) : r;
    a === "" ? delete s[t] : a != null && (s[t] = a), e.attribs.style = bf(s);
  } else if (typeof t == "object") {
    const s = Object.keys(t);
    for (let a = 0; a < s.length; a++) {
      const u = s[a];
      Ri(e, u, t[u], a);
    }
  }
}
function Li(e, t) {
  if (!e || !ee(e))
    return;
  const r = Tf(e.attribs.style);
  if (typeof t == "string")
    return r[t];
  if (Array.isArray(t)) {
    const n = {};
    for (const s of t)
      r[s] != null && (n[s] = r[s]);
    return n;
  }
  return r;
}
function bf(e) {
  return Object.keys(e).reduce((t, r) => `${t}${t ? " " : ""}${r}: ${e[r]};`, "");
}
function Tf(e) {
  if (e = (e || "").trim(), !e)
    return {};
  const t = {};
  let r;
  for (const n of e.split(";")) {
    const s = n.indexOf(":");
    if (s < 1 || s === n.length - 1) {
      const a = n.trimEnd();
      a.length > 0 && r !== void 0 && (t[r] += `;${a}`);
    } else
      r = n.slice(0, s).trim(), t[r] = n.slice(s + 1).trim();
  }
  return t;
}
const Af = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  css: pf
}, Symbol.toStringTag, { value: "Module" })), Ds = "input,select,textarea,keygen", _f = /%20/g, Ss = /\r?\n/g;
function gf() {
  return this.serializeArray().map((r) => `${encodeURIComponent(r.name)}=${encodeURIComponent(r.value)}`).join("&").replace(_f, "+");
}
function Cf() {
  return this.map((e, t) => {
    const r = this._make(t);
    return ee(t) && t.name === "form" ? r.find(Ds).toArray() : r.filter(Ds).toArray();
  }).filter(
    // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
  ).map((e, t) => {
    var r;
    const n = this._make(t), s = n.attr("name"), a = (r = n.val()) !== null && r !== void 0 ? r : "";
    return Array.isArray(a) ? a.map((u) => (
      /*
       * We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
       * These can occur inside of `<textarea>'s`
       */
      { name: s, value: u.replace(Ss, `\r
`) }
    )) : { name: s, value: a.replace(Ss, `\r
`) };
  }).toArray();
}
const Df = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  serialize: gf,
  serializeArray: Cf
}, Symbol.toStringTag, { value: "Module" }));
function Sf(e) {
  var t;
  return typeof e == "string" ? { selector: e, value: "textContent" } : {
    selector: e.selector,
    value: (t = e.value) !== null && t !== void 0 ? t : "textContent"
  };
}
function Nf(e) {
  const t = {};
  for (const r in e) {
    const n = e[r], s = Array.isArray(n), { selector: a, value: u } = Sf(s ? n[0] : n), o = typeof u == "function" ? u : typeof u == "string" ? (f) => this._make(f).prop(u) : (f) => this._make(f).extract(u);
    if (s)
      t[r] = this._findBySelector(a, Number.POSITIVE_INFINITY).map((f, c) => o(c, r, t)).get();
    else {
      const f = this._findBySelector(a, 1);
      t[r] = f.length > 0 ? o(f[0], r, t) : void 0;
    }
  }
  return t;
}
const If = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  extract: Nf
}, Symbol.toStringTag, { value: "Module" }));
class Er {
  /**
   * Instance of cheerio. Methods are specified in the modules. Usage of this
   * constructor is not recommended. Please use `$.load` instead.
   *
   * @private
   * @param elements - The new selection.
   * @param root - Sets the root node.
   * @param options - Options for the instance.
   */
  constructor(t, r, n) {
    if (this.length = 0, this.options = n, this._root = r, t) {
      for (let s = 0; s < t.length; s++)
        this[s] = t[s];
      this.length = t.length;
    }
  }
}
Er.prototype.cheerio = "[cheerio object]";
Er.prototype.splice = Array.prototype.splice;
Er.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
Object.assign(Er.prototype, Lc, Vl, mf, Af, Df, If);
function vf(e, t) {
  return function r(n, s, a = !0) {
    if (n == null)
      throw new Error("cheerio.load() expects a string");
    const u = i0(s), o = e(n, u, a, null);
    class f extends Er {
      _make(x, d) {
        const p = c(x, d);
        return p.prevObject = this, p;
      }
      _parse(x, d, p, h) {
        return e(x, d, p, h);
      }
      _render(x) {
        return t(x, this.options);
      }
    }
    function c(l, x, d = o, p) {
      if (l && rt(l))
        return l;
      const h = i0(p, u), m = typeof d == "string" ? [e(d, h, !1, null)] : "length" in d ? d : [d], E = rt(m) ? m : new f(m, null, h);
      if (E._root = E, !l)
        return new f(void 0, E, h);
      const D = typeof l == "string" && u0(l) ? (
        // $(<html>)
        e(l, h, !1, null).children
      ) : Bf(l) ? (
        // $(dom)
        [l]
      ) : Array.isArray(l) ? (
        // $([dom])
        l
      ) : void 0, b = new f(D, E, h);
      if (D)
        return b;
      if (typeof l != "string")
        throw new TypeError("Unexpected type of selector");
      let A = l;
      const g = x ? (
        // If we don't have a context, maybe we have a root, from loading
        typeof x == "string" ? u0(x) ? (
          // $('li', '<ul>...</ul>')
          new f([e(x, h, !1, null)], E, h)
        ) : (
          // $('li', 'ul')
          (A = `${x} ${A}`, E)
        ) : rt(x) ? (
          // $('li', $)
          x
        ) : (
          // $('li', node), $('li', [nodes])
          new f(Array.isArray(x) ? x : [x], E, h)
        )
      ) : E;
      return g ? g.find(A) : b;
    }
    return Object.assign(c, _c, {
      load: r,
      // `_root` and `_options` are used in static methods.
      _root: o,
      _options: u,
      // Add `fn` for plugins
      fn: f.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: f.prototype
    }), c;
  };
}
function Bf(e) {
  return !!e.name || e.type === "root" || e.type === "text" || e.type === "comment";
}
const Of = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), he = "�";
var T;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(T || (T = {}));
const Re = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function Fi(e) {
  return e >= 55296 && e <= 57343;
}
function yf(e) {
  return e >= 56320 && e <= 57343;
}
function Rf(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function Pi(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function ki(e) {
  return e >= 64976 && e <= 65007 || Of.has(e);
}
var L;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(L || (L = {}));
const Lf = 65536;
class Ff {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Lf, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, r) {
    const { line: n, col: s, offset: a } = this, u = s + r, o = a + r;
    return {
      code: t,
      startLine: n,
      endLine: n,
      startCol: u,
      endCol: u,
      startOffset: o,
      endOffset: o
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const r = this.html.charCodeAt(this.pos + 1);
      if (yf(r))
        return this.pos++, this._addGap(), Rf(t, r);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, T.EOF;
    return this._err(L.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, r) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = r;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, r) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (r)
      return this.html.startsWith(t, this.pos);
    for (let n = 0; n < t.length; n++)
      if ((this.html.charCodeAt(this.pos + n) | 32) !== t.charCodeAt(n))
        return !1;
    return !0;
  }
  peek(t) {
    const r = this.pos + t;
    if (r >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, T.EOF;
    const n = this.html.charCodeAt(r);
    return n === T.CARRIAGE_RETURN ? T.LINE_FEED : n;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, T.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === T.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, T.LINE_FEED) : t === T.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, Fi(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === T.LINE_FEED || t === T.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    Pi(t) ? this._err(L.controlCharacterInInputStream) : ki(t) && this._err(L.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var oe;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(oe || (oe = {}));
function wi(e, t) {
  for (let r = e.attrs.length - 1; r >= 0; r--)
    if (e.attrs[r].name === t)
      return e.attrs[r].value;
  return null;
}
var W;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(W || (W = {}));
var At;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(At || (At = {}));
var we;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(we || (we = {}));
var O;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(O || (O = {}));
var i;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(i || (i = {}));
const Pf = /* @__PURE__ */ new Map([
  [O.A, i.A],
  [O.ADDRESS, i.ADDRESS],
  [O.ANNOTATION_XML, i.ANNOTATION_XML],
  [O.APPLET, i.APPLET],
  [O.AREA, i.AREA],
  [O.ARTICLE, i.ARTICLE],
  [O.ASIDE, i.ASIDE],
  [O.B, i.B],
  [O.BASE, i.BASE],
  [O.BASEFONT, i.BASEFONT],
  [O.BGSOUND, i.BGSOUND],
  [O.BIG, i.BIG],
  [O.BLOCKQUOTE, i.BLOCKQUOTE],
  [O.BODY, i.BODY],
  [O.BR, i.BR],
  [O.BUTTON, i.BUTTON],
  [O.CAPTION, i.CAPTION],
  [O.CENTER, i.CENTER],
  [O.CODE, i.CODE],
  [O.COL, i.COL],
  [O.COLGROUP, i.COLGROUP],
  [O.DD, i.DD],
  [O.DESC, i.DESC],
  [O.DETAILS, i.DETAILS],
  [O.DIALOG, i.DIALOG],
  [O.DIR, i.DIR],
  [O.DIV, i.DIV],
  [O.DL, i.DL],
  [O.DT, i.DT],
  [O.EM, i.EM],
  [O.EMBED, i.EMBED],
  [O.FIELDSET, i.FIELDSET],
  [O.FIGCAPTION, i.FIGCAPTION],
  [O.FIGURE, i.FIGURE],
  [O.FONT, i.FONT],
  [O.FOOTER, i.FOOTER],
  [O.FOREIGN_OBJECT, i.FOREIGN_OBJECT],
  [O.FORM, i.FORM],
  [O.FRAME, i.FRAME],
  [O.FRAMESET, i.FRAMESET],
  [O.H1, i.H1],
  [O.H2, i.H2],
  [O.H3, i.H3],
  [O.H4, i.H4],
  [O.H5, i.H5],
  [O.H6, i.H6],
  [O.HEAD, i.HEAD],
  [O.HEADER, i.HEADER],
  [O.HGROUP, i.HGROUP],
  [O.HR, i.HR],
  [O.HTML, i.HTML],
  [O.I, i.I],
  [O.IMG, i.IMG],
  [O.IMAGE, i.IMAGE],
  [O.INPUT, i.INPUT],
  [O.IFRAME, i.IFRAME],
  [O.KEYGEN, i.KEYGEN],
  [O.LABEL, i.LABEL],
  [O.LI, i.LI],
  [O.LINK, i.LINK],
  [O.LISTING, i.LISTING],
  [O.MAIN, i.MAIN],
  [O.MALIGNMARK, i.MALIGNMARK],
  [O.MARQUEE, i.MARQUEE],
  [O.MATH, i.MATH],
  [O.MENU, i.MENU],
  [O.META, i.META],
  [O.MGLYPH, i.MGLYPH],
  [O.MI, i.MI],
  [O.MO, i.MO],
  [O.MN, i.MN],
  [O.MS, i.MS],
  [O.MTEXT, i.MTEXT],
  [O.NAV, i.NAV],
  [O.NOBR, i.NOBR],
  [O.NOFRAMES, i.NOFRAMES],
  [O.NOEMBED, i.NOEMBED],
  [O.NOSCRIPT, i.NOSCRIPT],
  [O.OBJECT, i.OBJECT],
  [O.OL, i.OL],
  [O.OPTGROUP, i.OPTGROUP],
  [O.OPTION, i.OPTION],
  [O.P, i.P],
  [O.PARAM, i.PARAM],
  [O.PLAINTEXT, i.PLAINTEXT],
  [O.PRE, i.PRE],
  [O.RB, i.RB],
  [O.RP, i.RP],
  [O.RT, i.RT],
  [O.RTC, i.RTC],
  [O.RUBY, i.RUBY],
  [O.S, i.S],
  [O.SCRIPT, i.SCRIPT],
  [O.SEARCH, i.SEARCH],
  [O.SECTION, i.SECTION],
  [O.SELECT, i.SELECT],
  [O.SOURCE, i.SOURCE],
  [O.SMALL, i.SMALL],
  [O.SPAN, i.SPAN],
  [O.STRIKE, i.STRIKE],
  [O.STRONG, i.STRONG],
  [O.STYLE, i.STYLE],
  [O.SUB, i.SUB],
  [O.SUMMARY, i.SUMMARY],
  [O.SUP, i.SUP],
  [O.TABLE, i.TABLE],
  [O.TBODY, i.TBODY],
  [O.TEMPLATE, i.TEMPLATE],
  [O.TEXTAREA, i.TEXTAREA],
  [O.TFOOT, i.TFOOT],
  [O.TD, i.TD],
  [O.TH, i.TH],
  [O.THEAD, i.THEAD],
  [O.TITLE, i.TITLE],
  [O.TR, i.TR],
  [O.TRACK, i.TRACK],
  [O.TT, i.TT],
  [O.U, i.U],
  [O.UL, i.UL],
  [O.SVG, i.SVG],
  [O.VAR, i.VAR],
  [O.WBR, i.WBR],
  [O.XMP, i.XMP]
]);
function Qr(e) {
  var t;
  return (t = Pf.get(e)) !== null && t !== void 0 ? t : i.UNKNOWN;
}
const V = i, kf = {
  [W.HTML]: /* @__PURE__ */ new Set([
    V.ADDRESS,
    V.APPLET,
    V.AREA,
    V.ARTICLE,
    V.ASIDE,
    V.BASE,
    V.BASEFONT,
    V.BGSOUND,
    V.BLOCKQUOTE,
    V.BODY,
    V.BR,
    V.BUTTON,
    V.CAPTION,
    V.CENTER,
    V.COL,
    V.COLGROUP,
    V.DD,
    V.DETAILS,
    V.DIR,
    V.DIV,
    V.DL,
    V.DT,
    V.EMBED,
    V.FIELDSET,
    V.FIGCAPTION,
    V.FIGURE,
    V.FOOTER,
    V.FORM,
    V.FRAME,
    V.FRAMESET,
    V.H1,
    V.H2,
    V.H3,
    V.H4,
    V.H5,
    V.H6,
    V.HEAD,
    V.HEADER,
    V.HGROUP,
    V.HR,
    V.HTML,
    V.IFRAME,
    V.IMG,
    V.INPUT,
    V.LI,
    V.LINK,
    V.LISTING,
    V.MAIN,
    V.MARQUEE,
    V.MENU,
    V.META,
    V.NAV,
    V.NOEMBED,
    V.NOFRAMES,
    V.NOSCRIPT,
    V.OBJECT,
    V.OL,
    V.P,
    V.PARAM,
    V.PLAINTEXT,
    V.PRE,
    V.SCRIPT,
    V.SECTION,
    V.SELECT,
    V.SOURCE,
    V.STYLE,
    V.SUMMARY,
    V.TABLE,
    V.TBODY,
    V.TD,
    V.TEMPLATE,
    V.TEXTAREA,
    V.TFOOT,
    V.TH,
    V.THEAD,
    V.TITLE,
    V.TR,
    V.TRACK,
    V.UL,
    V.WBR,
    V.XMP
  ]),
  [W.MATHML]: /* @__PURE__ */ new Set([V.MI, V.MO, V.MN, V.MS, V.MTEXT, V.ANNOTATION_XML]),
  [W.SVG]: /* @__PURE__ */ new Set([V.TITLE, V.FOREIGN_OBJECT, V.DESC]),
  [W.XLINK]: /* @__PURE__ */ new Set(),
  [W.XML]: /* @__PURE__ */ new Set(),
  [W.XMLNS]: /* @__PURE__ */ new Set()
}, h0 = /* @__PURE__ */ new Set([V.H1, V.H2, V.H3, V.H4, V.H5, V.H6]), wf = /* @__PURE__ */ new Set([
  O.STYLE,
  O.SCRIPT,
  O.XMP,
  O.IFRAME,
  O.NOEMBED,
  O.NOFRAMES,
  O.PLAINTEXT
]);
function Mf(e, t) {
  return wf.has(e) || t && e === O.NOSCRIPT;
}
var _;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(_ || (_ = {}));
const Fe = {
  DATA: _.DATA,
  RCDATA: _.RCDATA,
  RAWTEXT: _.RAWTEXT,
  SCRIPT_DATA: _.SCRIPT_DATA,
  PLAINTEXT: _.PLAINTEXT,
  CDATA_SECTION: _.CDATA_SECTION
};
function Hf(e) {
  return e >= T.DIGIT_0 && e <= T.DIGIT_9;
}
function Xt(e) {
  return e >= T.LATIN_CAPITAL_A && e <= T.LATIN_CAPITAL_Z;
}
function Uf(e) {
  return e >= T.LATIN_SMALL_A && e <= T.LATIN_SMALL_Z;
}
function it(e) {
  return Uf(e) || Xt(e);
}
function Ns(e) {
  return it(e) || Hf(e);
}
function _r(e) {
  return e + 32;
}
function Mi(e) {
  return e === T.SPACE || e === T.LINE_FEED || e === T.TABULATION || e === T.FORM_FEED;
}
function Is(e) {
  return Mi(e) || e === T.SOLIDUS || e === T.GREATER_THAN_SIGN;
}
function qf(e) {
  return e === T.NULL ? L.nullCharacterReference : e > 1114111 ? L.characterReferenceOutsideUnicodeRange : Fi(e) ? L.surrogateCharacterReference : ki(e) ? L.noncharacterCharacterReference : Pi(e) || e === T.CARRIAGE_RETURN ? L.controlCharacterReference : null;
}
let Yf = class {
  constructor(t, r) {
    this.options = t, this.handler = r, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = _.DATA, this.returnState = _.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new Ff(r), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new O0(B0, (n, s) => {
      this.preprocessor.pos = this.entityStartPos + s - 1, this._flushCodePointConsumedAsCharacterReference(n);
    }, r.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(L.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (n) => {
        this._err(L.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + n);
      },
      validateNumericCharacterReference: (n) => {
        const s = qf(n);
        s && this._err(s, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, r = 0) {
    var n, s;
    (s = (n = this.handler).onParseError) === null || s === void 0 || s.call(n, this.preprocessor.getError(t, r));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t?.());
  }
  write(t, r, n) {
    this.active = !0, this.preprocessor.write(t, r), this._runParsingLoop(), this.paused || n?.();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let r = 0; r < t; r++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, r) {
    return this.preprocessor.startsWith(t, r) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: oe.START_TAG,
      tagName: "",
      tagID: i.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: oe.END_TAG,
      tagName: "",
      tagID: i.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: oe.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: oe.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, r) {
    this.currentCharacterToken = {
      type: t,
      chars: r,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, r;
    const n = this.currentToken;
    if (wi(n, this.currentAttr.name) === null) {
      if (n.attrs.push(this.currentAttr), n.location && this.currentLocation) {
        const s = (t = (r = n.location).attrs) !== null && t !== void 0 ? t : r.attrs = /* @__PURE__ */ Object.create(null);
        s[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(L.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Qr(t.tagName), t.type === oe.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(L.endTagWithAttributes), t.selfClosing && this._err(L.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case oe.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case oe.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case oe.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: oe.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, r) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += r;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, r);
  }
  _emitCodePoint(t) {
    const r = Mi(t) ? oe.WHITESPACE_CHARACTER : t === T.NULL ? oe.NULL_CHARACTER : oe.CHARACTER;
    this._appendCharToCurrentCharacterToken(r, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(oe.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = _.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Ye.Attribute : Ye.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === _.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === _.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === _.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case _.DATA: {
        this._stateData(t);
        break;
      }
      case _.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case _.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case _.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case _.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case _.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case _.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case _.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case _.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case _.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case _.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case _.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case _.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case _.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case _.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case _.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case _.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case _.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case _.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case _.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case _.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case _.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case _.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case _.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case _.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case _.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case _.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case _.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case _.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case _.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case _.COMMENT: {
        this._stateComment(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case _.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case _.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case _.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case _.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case _.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case _.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case _.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case _.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case _.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case _.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case _.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case _.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case _.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case _.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case _.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case _.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case _.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case _.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case _.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case _.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case _.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case _.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case T.LESS_THAN_SIGN: {
        this.state = _.TAG_OPEN;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case T.LESS_THAN_SIGN: {
        this.state = _.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (it(t))
      this._createStartTagToken(), this.state = _.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case T.EXCLAMATION_MARK: {
          this.state = _.MARKUP_DECLARATION_OPEN;
          break;
        }
        case T.SOLIDUS: {
          this.state = _.END_TAG_OPEN;
          break;
        }
        case T.QUESTION_MARK: {
          this._err(L.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = _.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case T.EOF: {
          this._err(L.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(L.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = _.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (it(t))
      this._createEndTagToken(), this.state = _.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case T.GREATER_THAN_SIGN: {
          this._err(L.missingEndTagName), this.state = _.DATA;
          break;
        }
        case T.EOF: {
          this._err(L.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(L.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = _.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = _.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case T.SOLIDUS: {
        this.state = _.SELF_CLOSING_START_TAG;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.tagName += he;
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        r.tagName += String.fromCodePoint(Xt(t) ? _r(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === T.SOLIDUS ? this.state = _.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = _.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    it(t) ? (this.state = _.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = _.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const r = this.currentToken;
    switch (r.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = _.BEFORE_ATTRIBUTE_NAME, !1;
      case T.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = _.SELF_CLOSING_START_TAG, !1;
      case T.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = _.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === T.SOLIDUS ? this.state = _.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = _.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    it(t) ? (this.state = _.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = _.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case T.SOLIDUS: {
        this.state = _.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case T.EXCLAMATION_MARK: {
        this.state = _.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = _.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    it(t) ? (this.state = _.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === T.HYPHEN_MINUS ? (this.state = _.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === T.HYPHEN_MINUS ? (this.state = _.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._err(L.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_ESCAPED, this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._err(L.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_ESCAPED, this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._err(L.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === T.SOLIDUS ? this.state = _.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : it(t) ? (this._emitChars("<"), this.state = _.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    it(t) ? (this.state = _.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(Re.SCRIPT, !1) && Is(this.preprocessor.peek(Re.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let r = 0; r < Re.SCRIPT.length; r++)
        this._emitCodePoint(this._consume());
      this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._err(L.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._err(L.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(he);
        break;
      }
      case T.EOF: {
        this._err(L.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === T.SOLIDUS ? (this.state = _.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(Re.SCRIPT, !1) && Is(this.preprocessor.peek(Re.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let r = 0; r < Re.SCRIPT.length; r++)
        this._emitCodePoint(this._consume());
      this.state = _.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.SOLIDUS:
      case T.GREATER_THAN_SIGN:
      case T.EOF: {
        this.state = _.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case T.EQUALS_SIGN: {
        this._err(L.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = _.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = _.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
      case T.SOLIDUS:
      case T.GREATER_THAN_SIGN:
      case T.EOF: {
        this._leaveAttrName(), this.state = _.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case T.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = _.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case T.QUOTATION_MARK:
      case T.APOSTROPHE:
      case T.LESS_THAN_SIGN: {
        this._err(L.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.currentAttr.name += he;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Xt(t) ? _r(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.SOLIDUS: {
        this.state = _.SELF_CLOSING_START_TAG;
        break;
      }
      case T.EQUALS_SIGN: {
        this.state = _.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = _.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.QUOTATION_MARK: {
        this.state = _.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this.state = _.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.missingAttributeValue), this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = _.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case T.QUOTATION_MARK: {
        this.state = _.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.currentAttr.value += he;
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case T.APOSTROPHE: {
        this.state = _.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.currentAttr.value += he;
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this._leaveAttrValue(), this.state = _.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), this.currentAttr.value += he;
        break;
      }
      case T.QUOTATION_MARK:
      case T.APOSTROPHE:
      case T.LESS_THAN_SIGN:
      case T.EQUALS_SIGN:
      case T.GRAVE_ACCENT: {
        this._err(L.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this._leaveAttrValue(), this.state = _.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case T.SOLIDUS: {
        this._leaveAttrValue(), this.state = _.SELF_CLOSING_START_TAG;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingWhitespaceBetweenAttributes), this.state = _.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case T.GREATER_THAN_SIGN: {
        const r = this.currentToken;
        r.selfClosing = !0, this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.EOF: {
        this._err(L.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.unexpectedSolidusInTag), this.state = _.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const r = this.currentToken;
    switch (t) {
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentComment(r);
        break;
      }
      case T.EOF: {
        this.emitCurrentComment(r), this._emitEOFToken();
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.data += he;
        break;
      }
      default:
        r.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(Re.DASH_DASH, !0) ? (this._createCommentToken(Re.DASH_DASH.length + 1), this.state = _.COMMENT_START) : this._consumeSequenceIfMatch(Re.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(Re.DOCTYPE.length + 1), this.state = _.DOCTYPE) : this._consumeSequenceIfMatch(Re.CDATA_START, !0) ? this.inForeignNode ? this.state = _.CDATA_SECTION : (this._err(L.cdataInHtmlContent), this._createCommentToken(Re.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = _.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(L.incorrectlyOpenedComment), this._createCommentToken(2), this.state = _.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.COMMENT_START_DASH;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.abruptClosingOfEmptyComment), this.state = _.DATA;
        const r = this.currentToken;
        this.emitCurrentComment(r);
        break;
      }
      default:
        this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const r = this.currentToken;
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.COMMENT_END;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.abruptClosingOfEmptyComment), this.state = _.DATA, this.emitCurrentComment(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInComment), this.emitCurrentComment(r), this._emitEOFToken();
        break;
      }
      default:
        r.data += "-", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const r = this.currentToken;
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.COMMENT_END_DASH;
        break;
      }
      case T.LESS_THAN_SIGN: {
        r.data += "<", this.state = _.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.data += he;
        break;
      }
      case T.EOF: {
        this._err(L.eofInComment), this.emitCurrentComment(r), this._emitEOFToken();
        break;
      }
      default:
        r.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const r = this.currentToken;
    switch (t) {
      case T.EXCLAMATION_MARK: {
        r.data += "!", this.state = _.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case T.LESS_THAN_SIGN: {
        r.data += "<";
        break;
      }
      default:
        this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === T.HYPHEN_MINUS ? this.state = _.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = _.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === T.HYPHEN_MINUS ? this.state = _.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = _.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== T.GREATER_THAN_SIGN && t !== T.EOF && this._err(L.nestedComment), this.state = _.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const r = this.currentToken;
    switch (t) {
      case T.HYPHEN_MINUS: {
        this.state = _.COMMENT_END;
        break;
      }
      case T.EOF: {
        this._err(L.eofInComment), this.emitCurrentComment(r), this._emitEOFToken();
        break;
      }
      default:
        r.data += "-", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const r = this.currentToken;
    switch (t) {
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentComment(r);
        break;
      }
      case T.EXCLAMATION_MARK: {
        this.state = _.COMMENT_END_BANG;
        break;
      }
      case T.HYPHEN_MINUS: {
        r.data += "-";
        break;
      }
      case T.EOF: {
        this._err(L.eofInComment), this.emitCurrentComment(r), this._emitEOFToken();
        break;
      }
      default:
        r.data += "--", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const r = this.currentToken;
    switch (t) {
      case T.HYPHEN_MINUS: {
        r.data += "--!", this.state = _.COMMENT_END_DASH;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.incorrectlyClosedComment), this.state = _.DATA, this.emitCurrentComment(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInComment), this.emitCurrentComment(r), this._emitEOFToken();
        break;
      }
      default:
        r.data += "--!", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = _.BEFORE_DOCTYPE_NAME;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), this._createDoctypeToken(null);
        const r = this.currentToken;
        r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingWhitespaceBeforeDoctypeName), this.state = _.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (Xt(t))
      this._createDoctypeToken(String.fromCharCode(_r(t))), this.state = _.DOCTYPE_NAME;
    else
      switch (t) {
        case T.SPACE:
        case T.LINE_FEED:
        case T.TABULATION:
        case T.FORM_FEED:
          break;
        case T.NULL: {
          this._err(L.unexpectedNullCharacter), this._createDoctypeToken(he), this.state = _.DOCTYPE_NAME;
          break;
        }
        case T.GREATER_THAN_SIGN: {
          this._err(L.missingDoctypeName), this._createDoctypeToken(null);
          const r = this.currentToken;
          r.forceQuirks = !0, this.emitCurrentDoctype(r), this.state = _.DATA;
          break;
        }
        case T.EOF: {
          this._err(L.eofInDoctype), this._createDoctypeToken(null);
          const r = this.currentToken;
          r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = _.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = _.AFTER_DOCTYPE_NAME;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.name += he;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        r.name += String.fromCodePoint(Xt(t) ? _r(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(Re.PUBLIC, !1) ? this.state = _.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(Re.SYSTEM, !1) ? this.state = _.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(L.invalidCharacterSequenceAfterDoctypeName), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = _.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case T.QUOTATION_MARK: {
        this._err(L.missingWhitespaceAfterDoctypePublicKeyword), r.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this._err(L.missingWhitespaceAfterDoctypePublicKeyword), r.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.missingDoctypePublicIdentifier), r.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingQuoteBeforeDoctypePublicIdentifier), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.QUOTATION_MARK: {
        r.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        r.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.missingDoctypePublicIdentifier), r.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingQuoteBeforeDoctypePublicIdentifier), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const r = this.currentToken;
    switch (t) {
      case T.QUOTATION_MARK: {
        this.state = _.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.publicId += he;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.abruptDoctypePublicIdentifier), r.forceQuirks = !0, this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        r.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const r = this.currentToken;
    switch (t) {
      case T.APOSTROPHE: {
        this.state = _.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.publicId += he;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.abruptDoctypePublicIdentifier), r.forceQuirks = !0, this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        r.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = _.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.QUOTATION_MARK: {
        this._err(L.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this._err(L.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingQuoteBeforeDoctypeSystemIdentifier), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.QUOTATION_MARK: {
        r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingQuoteBeforeDoctypeSystemIdentifier), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = _.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case T.QUOTATION_MARK: {
        this._err(L.missingWhitespaceAfterDoctypeSystemKeyword), r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this._err(L.missingWhitespaceAfterDoctypeSystemKeyword), r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.missingDoctypeSystemIdentifier), r.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingQuoteBeforeDoctypeSystemIdentifier), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.QUOTATION_MARK: {
        r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        r.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.missingDoctypeSystemIdentifier), r.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(r);
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.missingQuoteBeforeDoctypeSystemIdentifier), r.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const r = this.currentToken;
    switch (t) {
      case T.QUOTATION_MARK: {
        this.state = _.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.systemId += he;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.abruptDoctypeSystemIdentifier), r.forceQuirks = !0, this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        r.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const r = this.currentToken;
    switch (t) {
      case T.APOSTROPHE: {
        this.state = _.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter), r.systemId += he;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(L.abruptDoctypeSystemIdentifier), r.forceQuirks = !0, this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        r.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const r = this.currentToken;
    switch (t) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.EOF: {
        this._err(L.eofInDoctype), r.forceQuirks = !0, this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
      default:
        this._err(L.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const r = this.currentToken;
    switch (t) {
      case T.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(r), this.state = _.DATA;
        break;
      }
      case T.NULL: {
        this._err(L.unexpectedNullCharacter);
        break;
      }
      case T.EOF: {
        this.emitCurrentDoctype(r), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case T.RIGHT_SQUARE_BRACKET: {
        this.state = _.CDATA_SECTION_BRACKET;
        break;
      }
      case T.EOF: {
        this._err(L.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === T.RIGHT_SQUARE_BRACKET ? this.state = _.CDATA_SECTION_END : (this._emitChars("]"), this.state = _.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case T.GREATER_THAN_SIGN: {
        this.state = _.DATA;
        break;
      }
      case T.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = _.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(T.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && Ns(this.preprocessor.peek(1)) ? _.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    Ns(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === T.SEMICOLON && this._err(L.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
};
const Hi = /* @__PURE__ */ new Set([i.DD, i.DT, i.LI, i.OPTGROUP, i.OPTION, i.P, i.RB, i.RP, i.RT, i.RTC]), vs = /* @__PURE__ */ new Set([
  ...Hi,
  i.CAPTION,
  i.COLGROUP,
  i.TBODY,
  i.TD,
  i.TFOOT,
  i.TH,
  i.THEAD,
  i.TR
]), kr = /* @__PURE__ */ new Set([
  i.APPLET,
  i.CAPTION,
  i.HTML,
  i.MARQUEE,
  i.OBJECT,
  i.TABLE,
  i.TD,
  i.TEMPLATE,
  i.TH
]), $f = /* @__PURE__ */ new Set([...kr, i.OL, i.UL]), Wf = /* @__PURE__ */ new Set([...kr, i.BUTTON]), Bs = /* @__PURE__ */ new Set([i.ANNOTATION_XML, i.MI, i.MN, i.MO, i.MS, i.MTEXT]), Os = /* @__PURE__ */ new Set([i.DESC, i.FOREIGN_OBJECT, i.TITLE]), zf = /* @__PURE__ */ new Set([i.TR, i.TEMPLATE, i.HTML]), Gf = /* @__PURE__ */ new Set([i.TBODY, i.TFOOT, i.THEAD, i.TEMPLATE, i.HTML]), Vf = /* @__PURE__ */ new Set([i.TABLE, i.TEMPLATE, i.HTML]), Qf = /* @__PURE__ */ new Set([i.TD, i.TH]);
class jf {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, r, n) {
    this.treeAdapter = r, this.handler = n, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = i.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === i.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === W.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, r) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = r, this.currentTagId = r, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, r, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, r) {
    const n = this._indexOf(t);
    this.items[n] = r, n === this.stackTop && (this.current = r);
  }
  insertAfter(t, r, n) {
    const s = this._indexOf(t) + 1;
    this.items.splice(s, 0, r), this.tagIDs.splice(s, 0, n), this.stackTop++, s === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, s === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let r = this.stackTop + 1;
    do
      r = this.tagIDs.lastIndexOf(t, r - 1);
    while (r > 0 && this.treeAdapter.getNamespaceURI(this.items[r]) !== W.HTML);
    this.shortenToLength(r < 0 ? 0 : r);
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const r = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(r, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const r = this._indexOf(t);
    this.shortenToLength(r < 0 ? 0 : r);
  }
  popUntilPopped(t, r) {
    const n = this._indexOfTagNames(t, r);
    this.shortenToLength(n < 0 ? 0 : n);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(h0, W.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Qf, W.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, r) {
    for (let n = this.stackTop; n >= 0; n--)
      if (t.has(this.tagIDs[n]) && this.treeAdapter.getNamespaceURI(this.items[n]) === r)
        return n;
    return -1;
  }
  clearBackTo(t, r) {
    const n = this._indexOfTagNames(t, r);
    this.shortenToLength(n + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(Vf, W.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(Gf, W.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(zf, W.HTML);
  }
  remove(t) {
    const r = this._indexOf(t);
    r >= 0 && (r === this.stackTop ? this.pop() : (this.items.splice(r, 1), this.tagIDs.splice(r, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === i.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const r = this._indexOf(t) - 1;
    return r >= 0 ? this.items[r] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === i.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, r) {
    for (let n = this.stackTop; n >= 0; n--) {
      const s = this.tagIDs[n];
      switch (this.treeAdapter.getNamespaceURI(this.items[n])) {
        case W.HTML: {
          if (s === t)
            return !0;
          if (r.has(s))
            return !1;
          break;
        }
        case W.SVG: {
          if (Os.has(s))
            return !1;
          break;
        }
        case W.MATHML: {
          if (Bs.has(s))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, kr);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, $f);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, Wf);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const r = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case W.HTML: {
          if (h0.has(r))
            return !0;
          if (kr.has(r))
            return !1;
          break;
        }
        case W.SVG: {
          if (Os.has(r))
            return !1;
          break;
        }
        case W.MATHML: {
          if (Bs.has(r))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let r = this.stackTop; r >= 0; r--)
      if (this.treeAdapter.getNamespaceURI(this.items[r]) === W.HTML)
        switch (this.tagIDs[r]) {
          case t:
            return !0;
          case i.TABLE:
          case i.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === W.HTML)
        switch (this.tagIDs[t]) {
          case i.TBODY:
          case i.THEAD:
          case i.TFOOT:
            return !0;
          case i.TABLE:
          case i.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let r = this.stackTop; r >= 0; r--)
      if (this.treeAdapter.getNamespaceURI(this.items[r]) === W.HTML)
        switch (this.tagIDs[r]) {
          case t:
            return !0;
          case i.OPTION:
          case i.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; Hi.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; vs.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== t && vs.has(this.currentTagId); )
      this.pop();
  }
}
const xn = 3;
var Qe;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(Qe || (Qe = {}));
const ys = { type: Qe.Marker };
class Kf {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, r) {
    const n = [], s = r.length, a = this.treeAdapter.getTagName(t), u = this.treeAdapter.getNamespaceURI(t);
    for (let o = 0; o < this.entries.length; o++) {
      const f = this.entries[o];
      if (f.type === Qe.Marker)
        break;
      const { element: c } = f;
      if (this.treeAdapter.getTagName(c) === a && this.treeAdapter.getNamespaceURI(c) === u) {
        const l = this.treeAdapter.getAttrList(c);
        l.length === s && n.push({ idx: o, attrs: l });
      }
    }
    return n;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < xn)
      return;
    const r = this.treeAdapter.getAttrList(t), n = this._getNoahArkConditionCandidates(t, r);
    if (n.length < xn)
      return;
    const s = new Map(r.map((u) => [u.name, u.value]));
    let a = 0;
    for (let u = 0; u < n.length; u++) {
      const o = n[u];
      o.attrs.every((f) => s.get(f.name) === f.value) && (a += 1, a >= xn && this.entries.splice(o.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(ys);
  }
  pushElement(t, r) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: Qe.Element,
      element: t,
      token: r
    });
  }
  insertElementAfterBookmark(t, r) {
    const n = this.entries.indexOf(this.bookmark);
    this.entries.splice(n, 0, {
      type: Qe.Element,
      element: t,
      token: r
    });
  }
  removeEntry(t) {
    const r = this.entries.indexOf(t);
    r >= 0 && this.entries.splice(r, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(ys);
    t >= 0 ? this.entries.splice(0, t + 1) : this.entries.length = 0;
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const r = this.entries.find((n) => n.type === Qe.Marker || this.treeAdapter.getTagName(n.element) === t);
    return r && r.type === Qe.Element ? r : null;
  }
  getElementEntry(t) {
    return this.entries.find((r) => r.type === Qe.Element && r.element === t);
  }
}
const tt = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: we.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, r) {
    return {
      nodeName: e,
      tagName: e,
      attrs: r,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, r) {
    const n = e.childNodes.indexOf(r);
    e.childNodes.splice(n, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, r, n) {
    const s = e.childNodes.find((a) => a.nodeName === "#documentType");
    if (s)
      s.name = t, s.publicId = r, s.systemId = n;
    else {
      const a = {
        nodeName: "#documentType",
        name: t,
        publicId: r,
        systemId: n,
        parentNode: null
      };
      tt.appendChild(e, a);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const r = e.childNodes[e.childNodes.length - 1];
      if (tt.isTextNode(r)) {
        r.value += t;
        return;
      }
    }
    tt.appendChild(e, tt.createTextNode(t));
  },
  insertTextBefore(e, t, r) {
    const n = e.childNodes[e.childNodes.indexOf(r) - 1];
    n && tt.isTextNode(n) ? n.value += t : tt.insertBefore(e, tt.createTextNode(t), r);
  },
  adoptAttributes(e, t) {
    const r = new Set(e.attrs.map((n) => n.name));
    for (let n = 0; n < t.length; n++)
      r.has(t[n].name) || e.attrs.push(t[n]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, Ui = "html", Xf = "about:legacy-compat", Zf = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", qi = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], Jf = [
  ...qi,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], ed = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), Yi = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], td = [
  ...Yi,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function Rs(e, t) {
  return t.some((r) => e.startsWith(r));
}
function rd(e) {
  return e.name === Ui && e.publicId === null && (e.systemId === null || e.systemId === Xf);
}
function nd(e) {
  if (e.name !== Ui)
    return we.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === Zf)
    return we.QUIRKS;
  let { publicId: r } = e;
  if (r !== null) {
    if (r = r.toLowerCase(), ed.has(r))
      return we.QUIRKS;
    let n = t === null ? Jf : qi;
    if (Rs(r, n))
      return we.QUIRKS;
    if (n = t === null ? Yi : td, Rs(r, n))
      return we.LIMITED_QUIRKS;
  }
  return we.NO_QUIRKS;
}
const Ls = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, sd = "definitionurl", ad = "definitionURL", id = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), ud = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: W.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: W.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: W.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: W.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: W.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: W.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: W.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: W.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: W.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: W.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: W.XMLNS }]
]), od = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), cd = /* @__PURE__ */ new Set([
  i.B,
  i.BIG,
  i.BLOCKQUOTE,
  i.BODY,
  i.BR,
  i.CENTER,
  i.CODE,
  i.DD,
  i.DIV,
  i.DL,
  i.DT,
  i.EM,
  i.EMBED,
  i.H1,
  i.H2,
  i.H3,
  i.H4,
  i.H5,
  i.H6,
  i.HEAD,
  i.HR,
  i.I,
  i.IMG,
  i.LI,
  i.LISTING,
  i.MENU,
  i.META,
  i.NOBR,
  i.OL,
  i.P,
  i.PRE,
  i.RUBY,
  i.S,
  i.SMALL,
  i.SPAN,
  i.STRONG,
  i.STRIKE,
  i.SUB,
  i.SUP,
  i.TABLE,
  i.TT,
  i.U,
  i.UL,
  i.VAR
]);
function ld(e) {
  const t = e.tagID;
  return t === i.FONT && e.attrs.some(({ name: n }) => n === At.COLOR || n === At.SIZE || n === At.FACE) || cd.has(t);
}
function $i(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === sd) {
      e.attrs[t].name = ad;
      break;
    }
}
function Wi(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const r = id.get(e.attrs[t].name);
    r != null && (e.attrs[t].name = r);
  }
}
function $0(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const r = ud.get(e.attrs[t].name);
    r && (e.attrs[t].prefix = r.prefix, e.attrs[t].name = r.name, e.attrs[t].namespace = r.namespace);
  }
}
function fd(e) {
  const t = od.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Qr(e.tagName));
}
function dd(e, t) {
  return t === W.MATHML && (e === i.MI || e === i.MO || e === i.MN || e === i.MS || e === i.MTEXT);
}
function hd(e, t, r) {
  if (t === W.MATHML && e === i.ANNOTATION_XML) {
    for (let n = 0; n < r.length; n++)
      if (r[n].name === At.ENCODING) {
        const s = r[n].value.toLowerCase();
        return s === Ls.TEXT_HTML || s === Ls.APPLICATION_XML;
      }
  }
  return t === W.SVG && (e === i.FOREIGN_OBJECT || e === i.DESC || e === i.TITLE);
}
function Ed(e, t, r, n) {
  return (!n || n === W.HTML) && hd(e, t, r) || (!n || n === W.MATHML) && dd(e, t);
}
const xd = "hidden", md = 8, pd = 3;
var C;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(C || (C = {}));
const bd = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, zi = /* @__PURE__ */ new Set([i.TABLE, i.TBODY, i.TFOOT, i.THEAD, i.TR]), Fs = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: tt,
  onParseError: null
};
let Gi = class {
  constructor(t, r, n = null, s = null) {
    this.fragmentContext = n, this.scriptHandler = s, this.currentToken = null, this.stopped = !1, this.insertionMode = C.INITIAL, this.originalInsertionMode = C.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...Fs,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = r ?? this.treeAdapter.createDocument(), this.tokenizer = new Yf(this.options, this), this.activeFormattingElements = new Kf(this.treeAdapter), this.fragmentContextID = n ? Qr(this.treeAdapter.getTagName(n)) : i.UNKNOWN, this._setContextModes(n ?? this.document, this.fragmentContextID), this.openElements = new jf(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, r) {
    const n = new this(r);
    return n.tokenizer.write(t, !0), n.document;
  }
  static getFragmentParser(t, r) {
    const n = {
      ...Fs,
      ...r
    };
    t ?? (t = n.treeAdapter.createElement(O.TEMPLATE, W.HTML, []));
    const s = n.treeAdapter.createElement("documentmock", W.HTML, []), a = new this(n, s, t);
    return a.fragmentContextID === i.TEMPLATE && a.tmplInsertionModeStack.unshift(C.IN_TEMPLATE), a._initTokenizerForFragmentParsing(), a._insertFakeRootElement(), a._resetInsertionMode(), a._findFormInFragmentContext(), a;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), r = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, r), r;
  }
  //Errors
  /** @internal */
  _err(t, r, n) {
    var s;
    if (!this.onParseError)
      return;
    const a = (s = t.location) !== null && s !== void 0 ? s : bd, u = {
      code: r,
      startLine: a.startLine,
      startCol: a.startCol,
      startOffset: a.startOffset,
      endLine: n ? a.startLine : a.endLine,
      endCol: n ? a.startCol : a.endCol,
      endOffset: n ? a.startOffset : a.endOffset
    };
    this.onParseError(u);
  }
  //Stack events
  /** @internal */
  onItemPush(t, r, n) {
    var s, a;
    (a = (s = this.treeAdapter).onItemPush) === null || a === void 0 || a.call(s, t), n && this.openElements.stackTop > 0 && this._setContextModes(t, r);
  }
  /** @internal */
  onItemPop(t, r) {
    var n, s;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (s = (n = this.treeAdapter).onItemPop) === null || s === void 0 || s.call(n, t, this.openElements.current), r) {
      let a, u;
      this.openElements.stackTop === 0 && this.fragmentContext ? (a = this.fragmentContext, u = this.fragmentContextID) : { current: a, currentTagId: u } = this.openElements, this._setContextModes(a, u);
    }
  }
  _setContextModes(t, r) {
    const n = t === this.document || this.treeAdapter.getNamespaceURI(t) === W.HTML;
    this.currentNotInHTML = !n, this.tokenizer.inForeignNode = !n && !this._isIntegrationPoint(r, t);
  }
  /** @protected */
  _switchToTextParsing(t, r) {
    this._insertElement(t, W.HTML), this.tokenizer.state = r, this.originalInsertionMode = this.insertionMode, this.insertionMode = C.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = C.TEXT, this.originalInsertionMode = C.IN_BODY, this.tokenizer.state = Fe.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === O.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== W.HTML))
      switch (this.fragmentContextID) {
        case i.TITLE:
        case i.TEXTAREA: {
          this.tokenizer.state = Fe.RCDATA;
          break;
        }
        case i.STYLE:
        case i.XMP:
        case i.IFRAME:
        case i.NOEMBED:
        case i.NOFRAMES:
        case i.NOSCRIPT: {
          this.tokenizer.state = Fe.RAWTEXT;
          break;
        }
        case i.SCRIPT: {
          this.tokenizer.state = Fe.SCRIPT_DATA;
          break;
        }
        case i.PLAINTEXT: {
          this.tokenizer.state = Fe.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const r = t.name || "", n = t.publicId || "", s = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, r, n, s), t.location) {
      const u = this.treeAdapter.getChildNodes(this.document).find((o) => this.treeAdapter.isDocumentTypeNode(o));
      u && this.treeAdapter.setNodeSourceCodeLocation(u, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, r) {
    if (this.options.sourceCodeLocationInfo) {
      const n = r && {
        ...r,
        startTag: r
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, n);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(n, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, r) {
    const n = this.treeAdapter.createElement(t.tagName, r, t.attrs);
    this._attachElementToTree(n, t.location);
  }
  /** @protected */
  _insertElement(t, r) {
    const n = this.treeAdapter.createElement(t.tagName, r, t.attrs);
    this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, r) {
    const n = this.treeAdapter.createElement(t, W.HTML, []);
    this._attachElementToTree(n, null), this.openElements.push(n, r);
  }
  /** @protected */
  _insertTemplate(t) {
    const r = this.treeAdapter.createElement(t.tagName, W.HTML, t.attrs), n = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(r, n), this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(n, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(O.HTML, W.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, i.HTML);
  }
  /** @protected */
  _appendCommentNode(t, r) {
    const n = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(r, n), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(n, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let r, n;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: r, beforeElement: n } = this._findFosterParentingLocation(), n ? this.treeAdapter.insertTextBefore(r, t.chars, n) : this.treeAdapter.insertText(r, t.chars)) : (r = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(r, t.chars)), !t.location)
      return;
    const s = this.treeAdapter.getChildNodes(r), a = n ? s.lastIndexOf(n) : s.length, u = s[a - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(u)) {
      const { endLine: f, endCol: c, endOffset: l } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(u, { endLine: f, endCol: c, endOffset: l });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(u, t.location);
  }
  /** @protected */
  _adoptNodes(t, r) {
    for (let n = this.treeAdapter.getFirstChild(t); n; n = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(n), this.treeAdapter.appendChild(r, n);
  }
  /** @protected */
  _setEndLocation(t, r) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && r.location) {
      const n = r.location, s = this.treeAdapter.getTagName(t), a = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        r.type === oe.END_TAG && s === r.tagName ? {
          endTag: { ...n },
          endLine: n.endLine,
          endCol: n.endCol,
          endOffset: n.endOffset
        } : {
          endLine: n.startLine,
          endCol: n.startCol,
          endOffset: n.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, a);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let r, n;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (r = this.fragmentContext, n = this.fragmentContextID) : { current: r, currentTagId: n } = this.openElements, t.tagID === i.SVG && this.treeAdapter.getTagName(r) === O.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(r) === W.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === i.MGLYPH || t.tagID === i.MALIGNMARK) && !this._isIntegrationPoint(n, r, W.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case oe.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case oe.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case oe.COMMENT: {
        this.onComment(t);
        break;
      }
      case oe.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case oe.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case oe.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case oe.EOF: {
        this.onEof(t);
        break;
      }
      case oe.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, r, n) {
    const s = this.treeAdapter.getNamespaceURI(r), a = this.treeAdapter.getAttrList(r);
    return Ed(t, s, a, n);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const r = this.activeFormattingElements.entries.findIndex((s) => s.type === Qe.Marker || this.openElements.contains(s.element)), n = r < 0 ? t - 1 : r - 1;
      for (let s = n; s >= 0; s--) {
        const a = this.activeFormattingElements.entries[s];
        this._insertElement(a.token, this.treeAdapter.getNamespaceURI(a.element)), a.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = C.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(i.P), this.openElements.popUntilTagNamePopped(i.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case i.TR: {
          this.insertionMode = C.IN_ROW;
          return;
        }
        case i.TBODY:
        case i.THEAD:
        case i.TFOOT: {
          this.insertionMode = C.IN_TABLE_BODY;
          return;
        }
        case i.CAPTION: {
          this.insertionMode = C.IN_CAPTION;
          return;
        }
        case i.COLGROUP: {
          this.insertionMode = C.IN_COLUMN_GROUP;
          return;
        }
        case i.TABLE: {
          this.insertionMode = C.IN_TABLE;
          return;
        }
        case i.BODY: {
          this.insertionMode = C.IN_BODY;
          return;
        }
        case i.FRAMESET: {
          this.insertionMode = C.IN_FRAMESET;
          return;
        }
        case i.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case i.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case i.HTML: {
          this.insertionMode = this.headElement ? C.AFTER_HEAD : C.BEFORE_HEAD;
          return;
        }
        case i.TD:
        case i.TH: {
          if (t > 0) {
            this.insertionMode = C.IN_CELL;
            return;
          }
          break;
        }
        case i.HEAD: {
          if (t > 0) {
            this.insertionMode = C.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = C.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let r = t - 1; r > 0; r--) {
        const n = this.openElements.tagIDs[r];
        if (n === i.TEMPLATE)
          break;
        if (n === i.TABLE) {
          this.insertionMode = C.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = C.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return zi.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const r = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case i.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(r) === W.HTML)
            return { parent: this.treeAdapter.getTemplateContent(r), beforeElement: null };
          break;
        }
        case i.TABLE: {
          const n = this.treeAdapter.getParentNode(r);
          return n ? { parent: n, beforeElement: r } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const r = this._findFosterParentingLocation();
    r.beforeElement ? this.treeAdapter.insertBefore(r.parent, t, r.beforeElement) : this.treeAdapter.appendChild(r.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, r) {
    const n = this.treeAdapter.getNamespaceURI(t);
    return kf[n].has(r);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Qh(this, t);
      return;
    }
    switch (this.insertionMode) {
      case C.INITIAL: {
        Vt(this, t);
        break;
      }
      case C.BEFORE_HTML: {
        Jt(this, t);
        break;
      }
      case C.BEFORE_HEAD: {
        er(this, t);
        break;
      }
      case C.IN_HEAD: {
        tr(this, t);
        break;
      }
      case C.IN_HEAD_NO_SCRIPT: {
        rr(this, t);
        break;
      }
      case C.AFTER_HEAD: {
        nr(this, t);
        break;
      }
      case C.IN_BODY:
      case C.IN_CAPTION:
      case C.IN_CELL:
      case C.IN_TEMPLATE: {
        Qi(this, t);
        break;
      }
      case C.TEXT:
      case C.IN_SELECT:
      case C.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case C.IN_TABLE:
      case C.IN_TABLE_BODY:
      case C.IN_ROW: {
        mn(this, t);
        break;
      }
      case C.IN_TABLE_TEXT: {
        eu(this, t);
        break;
      }
      case C.IN_COLUMN_GROUP: {
        wr(this, t);
        break;
      }
      case C.AFTER_BODY: {
        Mr(this, t);
        break;
      }
      case C.AFTER_AFTER_BODY: {
        Dr(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Vh(this, t);
      return;
    }
    switch (this.insertionMode) {
      case C.INITIAL: {
        Vt(this, t);
        break;
      }
      case C.BEFORE_HTML: {
        Jt(this, t);
        break;
      }
      case C.BEFORE_HEAD: {
        er(this, t);
        break;
      }
      case C.IN_HEAD: {
        tr(this, t);
        break;
      }
      case C.IN_HEAD_NO_SCRIPT: {
        rr(this, t);
        break;
      }
      case C.AFTER_HEAD: {
        nr(this, t);
        break;
      }
      case C.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case C.IN_TABLE:
      case C.IN_TABLE_BODY:
      case C.IN_ROW: {
        mn(this, t);
        break;
      }
      case C.IN_COLUMN_GROUP: {
        wr(this, t);
        break;
      }
      case C.AFTER_BODY: {
        Mr(this, t);
        break;
      }
      case C.AFTER_AFTER_BODY: {
        Dr(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      E0(this, t);
      return;
    }
    switch (this.insertionMode) {
      case C.INITIAL:
      case C.BEFORE_HTML:
      case C.BEFORE_HEAD:
      case C.IN_HEAD:
      case C.IN_HEAD_NO_SCRIPT:
      case C.AFTER_HEAD:
      case C.IN_BODY:
      case C.IN_TABLE:
      case C.IN_CAPTION:
      case C.IN_COLUMN_GROUP:
      case C.IN_TABLE_BODY:
      case C.IN_ROW:
      case C.IN_CELL:
      case C.IN_SELECT:
      case C.IN_SELECT_IN_TABLE:
      case C.IN_TEMPLATE:
      case C.IN_FRAMESET:
      case C.AFTER_FRAMESET: {
        E0(this, t);
        break;
      }
      case C.IN_TABLE_TEXT: {
        Qt(this, t);
        break;
      }
      case C.AFTER_BODY: {
        Sd(this, t);
        break;
      }
      case C.AFTER_AFTER_BODY:
      case C.AFTER_AFTER_FRAMESET: {
        Nd(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case C.INITIAL: {
        Id(this, t);
        break;
      }
      case C.BEFORE_HEAD:
      case C.IN_HEAD:
      case C.IN_HEAD_NO_SCRIPT:
      case C.AFTER_HEAD: {
        this._err(t, L.misplacedDoctype);
        break;
      }
      case C.IN_TABLE_TEXT: {
        Qt(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, L.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? jh(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case C.INITIAL: {
        Vt(this, t);
        break;
      }
      case C.BEFORE_HTML: {
        vd(this, t);
        break;
      }
      case C.BEFORE_HEAD: {
        Od(this, t);
        break;
      }
      case C.IN_HEAD: {
        ze(this, t);
        break;
      }
      case C.IN_HEAD_NO_SCRIPT: {
        Ld(this, t);
        break;
      }
      case C.AFTER_HEAD: {
        Pd(this, t);
        break;
      }
      case C.IN_BODY: {
        Oe(this, t);
        break;
      }
      case C.IN_TABLE: {
        wt(this, t);
        break;
      }
      case C.IN_TABLE_TEXT: {
        Qt(this, t);
        break;
      }
      case C.IN_CAPTION: {
        yh(this, t);
        break;
      }
      case C.IN_COLUMN_GROUP: {
        G0(this, t);
        break;
      }
      case C.IN_TABLE_BODY: {
        Xr(this, t);
        break;
      }
      case C.IN_ROW: {
        Zr(this, t);
        break;
      }
      case C.IN_CELL: {
        Fh(this, t);
        break;
      }
      case C.IN_SELECT: {
        nu(this, t);
        break;
      }
      case C.IN_SELECT_IN_TABLE: {
        kh(this, t);
        break;
      }
      case C.IN_TEMPLATE: {
        Mh(this, t);
        break;
      }
      case C.AFTER_BODY: {
        Uh(this, t);
        break;
      }
      case C.IN_FRAMESET: {
        qh(this, t);
        break;
      }
      case C.AFTER_FRAMESET: {
        $h(this, t);
        break;
      }
      case C.AFTER_AFTER_BODY: {
        zh(this, t);
        break;
      }
      case C.AFTER_AFTER_FRAMESET: {
        Gh(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? Kh(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case C.INITIAL: {
        Vt(this, t);
        break;
      }
      case C.BEFORE_HTML: {
        Bd(this, t);
        break;
      }
      case C.BEFORE_HEAD: {
        yd(this, t);
        break;
      }
      case C.IN_HEAD: {
        Rd(this, t);
        break;
      }
      case C.IN_HEAD_NO_SCRIPT: {
        Fd(this, t);
        break;
      }
      case C.AFTER_HEAD: {
        kd(this, t);
        break;
      }
      case C.IN_BODY: {
        Kr(this, t);
        break;
      }
      case C.TEXT: {
        _h(this, t);
        break;
      }
      case C.IN_TABLE: {
        lr(this, t);
        break;
      }
      case C.IN_TABLE_TEXT: {
        Qt(this, t);
        break;
      }
      case C.IN_CAPTION: {
        Rh(this, t);
        break;
      }
      case C.IN_COLUMN_GROUP: {
        Lh(this, t);
        break;
      }
      case C.IN_TABLE_BODY: {
        x0(this, t);
        break;
      }
      case C.IN_ROW: {
        ru(this, t);
        break;
      }
      case C.IN_CELL: {
        Ph(this, t);
        break;
      }
      case C.IN_SELECT: {
        su(this, t);
        break;
      }
      case C.IN_SELECT_IN_TABLE: {
        wh(this, t);
        break;
      }
      case C.IN_TEMPLATE: {
        Hh(this, t);
        break;
      }
      case C.AFTER_BODY: {
        iu(this, t);
        break;
      }
      case C.IN_FRAMESET: {
        Yh(this, t);
        break;
      }
      case C.AFTER_FRAMESET: {
        Wh(this, t);
        break;
      }
      case C.AFTER_AFTER_BODY: {
        Dr(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case C.INITIAL: {
        Vt(this, t);
        break;
      }
      case C.BEFORE_HTML: {
        Jt(this, t);
        break;
      }
      case C.BEFORE_HEAD: {
        er(this, t);
        break;
      }
      case C.IN_HEAD: {
        tr(this, t);
        break;
      }
      case C.IN_HEAD_NO_SCRIPT: {
        rr(this, t);
        break;
      }
      case C.AFTER_HEAD: {
        nr(this, t);
        break;
      }
      case C.IN_BODY:
      case C.IN_TABLE:
      case C.IN_CAPTION:
      case C.IN_COLUMN_GROUP:
      case C.IN_TABLE_BODY:
      case C.IN_ROW:
      case C.IN_CELL:
      case C.IN_SELECT:
      case C.IN_SELECT_IN_TABLE: {
        Zi(this, t);
        break;
      }
      case C.TEXT: {
        gh(this, t);
        break;
      }
      case C.IN_TABLE_TEXT: {
        Qt(this, t);
        break;
      }
      case C.IN_TEMPLATE: {
        au(this, t);
        break;
      }
      case C.AFTER_BODY:
      case C.IN_FRAMESET:
      case C.AFTER_FRAMESET:
      case C.AFTER_AFTER_BODY:
      case C.AFTER_AFTER_FRAMESET: {
        z0(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === T.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case C.IN_HEAD:
      case C.IN_HEAD_NO_SCRIPT:
      case C.AFTER_HEAD:
      case C.TEXT:
      case C.IN_COLUMN_GROUP:
      case C.IN_SELECT:
      case C.IN_SELECT_IN_TABLE:
      case C.IN_FRAMESET:
      case C.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case C.IN_BODY:
      case C.IN_CAPTION:
      case C.IN_CELL:
      case C.IN_TEMPLATE:
      case C.AFTER_BODY:
      case C.AFTER_AFTER_BODY:
      case C.AFTER_AFTER_FRAMESET: {
        Vi(this, t);
        break;
      }
      case C.IN_TABLE:
      case C.IN_TABLE_BODY:
      case C.IN_ROW: {
        mn(this, t);
        break;
      }
      case C.IN_TABLE_TEXT: {
        Ji(this, t);
        break;
      }
    }
  }
};
function Td(e, t) {
  let r = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return r ? e.openElements.contains(r.element) ? e.openElements.hasInScope(t.tagID) || (r = null) : (e.activeFormattingElements.removeEntry(r), r = null) : Xi(e, t), r;
}
function Ad(e, t) {
  let r = null, n = e.openElements.stackTop;
  for (; n >= 0; n--) {
    const s = e.openElements.items[n];
    if (s === t.element)
      break;
    e._isSpecialElement(s, e.openElements.tagIDs[n]) && (r = s);
  }
  return r || (e.openElements.shortenToLength(n < 0 ? 0 : n), e.activeFormattingElements.removeEntry(t)), r;
}
function _d(e, t, r) {
  let n = t, s = e.openElements.getCommonAncestor(t);
  for (let a = 0, u = s; u !== r; a++, u = s) {
    s = e.openElements.getCommonAncestor(u);
    const o = e.activeFormattingElements.getElementEntry(u), f = o && a >= pd;
    !o || f ? (f && e.activeFormattingElements.removeEntry(o), e.openElements.remove(u)) : (u = gd(e, o), n === t && (e.activeFormattingElements.bookmark = o), e.treeAdapter.detachNode(n), e.treeAdapter.appendChild(u, n), n = u);
  }
  return n;
}
function gd(e, t) {
  const r = e.treeAdapter.getNamespaceURI(t.element), n = e.treeAdapter.createElement(t.token.tagName, r, t.token.attrs);
  return e.openElements.replace(t.element, n), t.element = n, n;
}
function Cd(e, t, r) {
  const n = e.treeAdapter.getTagName(t), s = Qr(n);
  if (e._isElementCausesFosterParenting(s))
    e._fosterParentElement(r);
  else {
    const a = e.treeAdapter.getNamespaceURI(t);
    s === i.TEMPLATE && a === W.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, r);
  }
}
function Dd(e, t, r) {
  const n = e.treeAdapter.getNamespaceURI(r.element), { token: s } = r, a = e.treeAdapter.createElement(s.tagName, n, s.attrs);
  e._adoptNodes(t, a), e.treeAdapter.appendChild(t, a), e.activeFormattingElements.insertElementAfterBookmark(a, s), e.activeFormattingElements.removeEntry(r), e.openElements.remove(r.element), e.openElements.insertAfter(t, a, s.tagID);
}
function W0(e, t) {
  for (let r = 0; r < md; r++) {
    const n = Td(e, t);
    if (!n)
      break;
    const s = Ad(e, n);
    if (!s)
      break;
    e.activeFormattingElements.bookmark = n;
    const a = _d(e, s, n.element), u = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(a), u && Cd(e, u, a), Dd(e, s, n);
  }
}
function E0(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function Sd(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Nd(e, t) {
  e._appendCommentNode(t, e.document);
}
function z0(e, t) {
  if (e.stopped = !0, t.location) {
    const r = e.fragmentContext ? 0 : 2;
    for (let n = e.openElements.stackTop; n >= r; n--)
      e._setEndLocation(e.openElements.items[n], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const n = e.openElements.items[0], s = e.treeAdapter.getNodeSourceCodeLocation(n);
      if (s && !s.endTag && (e._setEndLocation(n, t), e.openElements.stackTop >= 1)) {
        const a = e.openElements.items[1], u = e.treeAdapter.getNodeSourceCodeLocation(a);
        u && !u.endTag && e._setEndLocation(a, t);
      }
    }
  }
}
function Id(e, t) {
  e._setDocumentType(t);
  const r = t.forceQuirks ? we.QUIRKS : nd(t);
  rd(t) || e._err(t, L.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, r), e.insertionMode = C.BEFORE_HTML;
}
function Vt(e, t) {
  e._err(t, L.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, we.QUIRKS), e.insertionMode = C.BEFORE_HTML, e._processToken(t);
}
function vd(e, t) {
  t.tagID === i.HTML ? (e._insertElement(t, W.HTML), e.insertionMode = C.BEFORE_HEAD) : Jt(e, t);
}
function Bd(e, t) {
  const r = t.tagID;
  (r === i.HTML || r === i.HEAD || r === i.BODY || r === i.BR) && Jt(e, t);
}
function Jt(e, t) {
  e._insertFakeRootElement(), e.insertionMode = C.BEFORE_HEAD, e._processToken(t);
}
function Od(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.HEAD: {
      e._insertElement(t, W.HTML), e.headElement = e.openElements.current, e.insertionMode = C.IN_HEAD;
      break;
    }
    default:
      er(e, t);
  }
}
function yd(e, t) {
  const r = t.tagID;
  r === i.HEAD || r === i.BODY || r === i.HTML || r === i.BR ? er(e, t) : e._err(t, L.endTagWithoutMatchingOpenElement);
}
function er(e, t) {
  e._insertFakeElement(O.HEAD, i.HEAD), e.headElement = e.openElements.current, e.insertionMode = C.IN_HEAD, e._processToken(t);
}
function ze(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.BASE:
    case i.BASEFONT:
    case i.BGSOUND:
    case i.LINK:
    case i.META: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case i.TITLE: {
      e._switchToTextParsing(t, Fe.RCDATA);
      break;
    }
    case i.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, Fe.RAWTEXT) : (e._insertElement(t, W.HTML), e.insertionMode = C.IN_HEAD_NO_SCRIPT);
      break;
    }
    case i.NOFRAMES:
    case i.STYLE: {
      e._switchToTextParsing(t, Fe.RAWTEXT);
      break;
    }
    case i.SCRIPT: {
      e._switchToTextParsing(t, Fe.SCRIPT_DATA);
      break;
    }
    case i.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = C.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(C.IN_TEMPLATE);
      break;
    }
    case i.HEAD: {
      e._err(t, L.misplacedStartTagForHeadElement);
      break;
    }
    default:
      tr(e, t);
  }
}
function Rd(e, t) {
  switch (t.tagID) {
    case i.HEAD: {
      e.openElements.pop(), e.insertionMode = C.AFTER_HEAD;
      break;
    }
    case i.BODY:
    case i.BR:
    case i.HTML: {
      tr(e, t);
      break;
    }
    case i.TEMPLATE: {
      vt(e, t);
      break;
    }
    default:
      e._err(t, L.endTagWithoutMatchingOpenElement);
  }
}
function vt(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== i.TEMPLATE && e._err(t, L.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(i.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, L.endTagWithoutMatchingOpenElement);
}
function tr(e, t) {
  e.openElements.pop(), e.insertionMode = C.AFTER_HEAD, e._processToken(t);
}
function Ld(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.BASEFONT:
    case i.BGSOUND:
    case i.HEAD:
    case i.LINK:
    case i.META:
    case i.NOFRAMES:
    case i.STYLE: {
      ze(e, t);
      break;
    }
    case i.NOSCRIPT: {
      e._err(t, L.nestedNoscriptInHead);
      break;
    }
    default:
      rr(e, t);
  }
}
function Fd(e, t) {
  switch (t.tagID) {
    case i.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = C.IN_HEAD;
      break;
    }
    case i.BR: {
      rr(e, t);
      break;
    }
    default:
      e._err(t, L.endTagWithoutMatchingOpenElement);
  }
}
function rr(e, t) {
  const r = t.type === oe.EOF ? L.openElementsLeftAfterEof : L.disallowedContentInNoscriptInHead;
  e._err(t, r), e.openElements.pop(), e.insertionMode = C.IN_HEAD, e._processToken(t);
}
function Pd(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.BODY: {
      e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = C.IN_BODY;
      break;
    }
    case i.FRAMESET: {
      e._insertElement(t, W.HTML), e.insertionMode = C.IN_FRAMESET;
      break;
    }
    case i.BASE:
    case i.BASEFONT:
    case i.BGSOUND:
    case i.LINK:
    case i.META:
    case i.NOFRAMES:
    case i.SCRIPT:
    case i.STYLE:
    case i.TEMPLATE:
    case i.TITLE: {
      e._err(t, L.abandonedHeadElementChild), e.openElements.push(e.headElement, i.HEAD), ze(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case i.HEAD: {
      e._err(t, L.misplacedStartTagForHeadElement);
      break;
    }
    default:
      nr(e, t);
  }
}
function kd(e, t) {
  switch (t.tagID) {
    case i.BODY:
    case i.HTML:
    case i.BR: {
      nr(e, t);
      break;
    }
    case i.TEMPLATE: {
      vt(e, t);
      break;
    }
    default:
      e._err(t, L.endTagWithoutMatchingOpenElement);
  }
}
function nr(e, t) {
  e._insertFakeElement(O.BODY, i.BODY), e.insertionMode = C.IN_BODY, jr(e, t);
}
function jr(e, t) {
  switch (t.type) {
    case oe.CHARACTER: {
      Qi(e, t);
      break;
    }
    case oe.WHITESPACE_CHARACTER: {
      Vi(e, t);
      break;
    }
    case oe.COMMENT: {
      E0(e, t);
      break;
    }
    case oe.START_TAG: {
      Oe(e, t);
      break;
    }
    case oe.END_TAG: {
      Kr(e, t);
      break;
    }
    case oe.EOF: {
      Zi(e, t);
      break;
    }
  }
}
function Vi(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function Qi(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function wd(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Md(e, t) {
  const r = e.openElements.tryPeekProperlyNestedBodyElement();
  r && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(r, t.attrs));
}
function Hd(e, t) {
  const r = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && r && (e.treeAdapter.detachNode(r), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, W.HTML), e.insertionMode = C.IN_FRAMESET);
}
function Ud(e, t) {
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._insertElement(t, W.HTML);
}
function qd(e, t) {
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), h0.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, W.HTML);
}
function Yd(e, t) {
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._insertElement(t, W.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function $d(e, t) {
  const r = e.openElements.tmplCount > 0;
  (!e.formElement || r) && (e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._insertElement(t, W.HTML), r || (e.formElement = e.openElements.current));
}
function Wd(e, t) {
  e.framesetOk = !1;
  const r = t.tagID;
  for (let n = e.openElements.stackTop; n >= 0; n--) {
    const s = e.openElements.tagIDs[n];
    if (r === i.LI && s === i.LI || (r === i.DD || r === i.DT) && (s === i.DD || s === i.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.popUntilTagNamePopped(s);
      break;
    }
    if (s !== i.ADDRESS && s !== i.DIV && s !== i.P && e._isSpecialElement(e.openElements.items[n], s))
      break;
  }
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._insertElement(t, W.HTML);
}
function zd(e, t) {
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._insertElement(t, W.HTML), e.tokenizer.state = Fe.PLAINTEXT;
}
function Gd(e, t) {
  e.openElements.hasInScope(i.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.framesetOk = !1;
}
function Vd(e, t) {
  const r = e.activeFormattingElements.getElementEntryInScopeWithTagName(O.A);
  r && (W0(e, t), e.openElements.remove(r.element), e.activeFormattingElements.removeEntry(r)), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Qd(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function jd(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(i.NOBR) && (W0(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Kd(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function Xd(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== we.QUIRKS && e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = C.IN_TABLE;
}
function ji(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, W.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Ki(e) {
  const t = wi(e, At.TYPE);
  return t != null && t.toLowerCase() === xd;
}
function Zd(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, W.HTML), Ki(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function Jd(e, t) {
  e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
}
function eh(e, t) {
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._appendElement(t, W.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function th(e, t) {
  t.tagName = O.IMG, t.tagID = i.IMG, ji(e, t);
}
function rh(e, t) {
  e._insertElement(t, W.HTML), e.skipNextNewLine = !0, e.tokenizer.state = Fe.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = C.TEXT;
}
function nh(e, t) {
  e.openElements.hasInButtonScope(i.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, Fe.RAWTEXT);
}
function sh(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, Fe.RAWTEXT);
}
function Ps(e, t) {
  e._switchToTextParsing(t, Fe.RAWTEXT);
}
function ah(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === C.IN_TABLE || e.insertionMode === C.IN_CAPTION || e.insertionMode === C.IN_TABLE_BODY || e.insertionMode === C.IN_ROW || e.insertionMode === C.IN_CELL ? C.IN_SELECT_IN_TABLE : C.IN_SELECT;
}
function ih(e, t) {
  e.openElements.currentTagId === i.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML);
}
function uh(e, t) {
  e.openElements.hasInScope(i.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, W.HTML);
}
function oh(e, t) {
  e.openElements.hasInScope(i.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(i.RTC), e._insertElement(t, W.HTML);
}
function ch(e, t) {
  e._reconstructActiveFormattingElements(), $i(t), $0(t), t.selfClosing ? e._appendElement(t, W.MATHML) : e._insertElement(t, W.MATHML), t.ackSelfClosing = !0;
}
function lh(e, t) {
  e._reconstructActiveFormattingElements(), Wi(t), $0(t), t.selfClosing ? e._appendElement(t, W.SVG) : e._insertElement(t, W.SVG), t.ackSelfClosing = !0;
}
function ks(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML);
}
function Oe(e, t) {
  switch (t.tagID) {
    case i.I:
    case i.S:
    case i.B:
    case i.U:
    case i.EM:
    case i.TT:
    case i.BIG:
    case i.CODE:
    case i.FONT:
    case i.SMALL:
    case i.STRIKE:
    case i.STRONG: {
      Qd(e, t);
      break;
    }
    case i.A: {
      Vd(e, t);
      break;
    }
    case i.H1:
    case i.H2:
    case i.H3:
    case i.H4:
    case i.H5:
    case i.H6: {
      qd(e, t);
      break;
    }
    case i.P:
    case i.DL:
    case i.OL:
    case i.UL:
    case i.DIV:
    case i.DIR:
    case i.NAV:
    case i.MAIN:
    case i.MENU:
    case i.ASIDE:
    case i.CENTER:
    case i.FIGURE:
    case i.FOOTER:
    case i.HEADER:
    case i.HGROUP:
    case i.DIALOG:
    case i.DETAILS:
    case i.ADDRESS:
    case i.ARTICLE:
    case i.SEARCH:
    case i.SECTION:
    case i.SUMMARY:
    case i.FIELDSET:
    case i.BLOCKQUOTE:
    case i.FIGCAPTION: {
      Ud(e, t);
      break;
    }
    case i.LI:
    case i.DD:
    case i.DT: {
      Wd(e, t);
      break;
    }
    case i.BR:
    case i.IMG:
    case i.WBR:
    case i.AREA:
    case i.EMBED:
    case i.KEYGEN: {
      ji(e, t);
      break;
    }
    case i.HR: {
      eh(e, t);
      break;
    }
    case i.RB:
    case i.RTC: {
      uh(e, t);
      break;
    }
    case i.RT:
    case i.RP: {
      oh(e, t);
      break;
    }
    case i.PRE:
    case i.LISTING: {
      Yd(e, t);
      break;
    }
    case i.XMP: {
      nh(e, t);
      break;
    }
    case i.SVG: {
      lh(e, t);
      break;
    }
    case i.HTML: {
      wd(e, t);
      break;
    }
    case i.BASE:
    case i.LINK:
    case i.META:
    case i.STYLE:
    case i.TITLE:
    case i.SCRIPT:
    case i.BGSOUND:
    case i.BASEFONT:
    case i.TEMPLATE: {
      ze(e, t);
      break;
    }
    case i.BODY: {
      Md(e, t);
      break;
    }
    case i.FORM: {
      $d(e, t);
      break;
    }
    case i.NOBR: {
      jd(e, t);
      break;
    }
    case i.MATH: {
      ch(e, t);
      break;
    }
    case i.TABLE: {
      Xd(e, t);
      break;
    }
    case i.INPUT: {
      Zd(e, t);
      break;
    }
    case i.PARAM:
    case i.TRACK:
    case i.SOURCE: {
      Jd(e, t);
      break;
    }
    case i.IMAGE: {
      th(e, t);
      break;
    }
    case i.BUTTON: {
      Gd(e, t);
      break;
    }
    case i.APPLET:
    case i.OBJECT:
    case i.MARQUEE: {
      Kd(e, t);
      break;
    }
    case i.IFRAME: {
      sh(e, t);
      break;
    }
    case i.SELECT: {
      ah(e, t);
      break;
    }
    case i.OPTION:
    case i.OPTGROUP: {
      ih(e, t);
      break;
    }
    case i.NOEMBED:
    case i.NOFRAMES: {
      Ps(e, t);
      break;
    }
    case i.FRAMESET: {
      Hd(e, t);
      break;
    }
    case i.TEXTAREA: {
      rh(e, t);
      break;
    }
    case i.NOSCRIPT: {
      e.options.scriptingEnabled ? Ps(e, t) : ks(e, t);
      break;
    }
    case i.PLAINTEXT: {
      zd(e, t);
      break;
    }
    case i.COL:
    case i.TH:
    case i.TD:
    case i.TR:
    case i.HEAD:
    case i.FRAME:
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD:
    case i.CAPTION:
    case i.COLGROUP:
      break;
    default:
      ks(e, t);
  }
}
function fh(e, t) {
  if (e.openElements.hasInScope(i.BODY) && (e.insertionMode = C.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const r = e.openElements.tryPeekProperlyNestedBodyElement();
    r && e._setEndLocation(r, t);
  }
}
function dh(e, t) {
  e.openElements.hasInScope(i.BODY) && (e.insertionMode = C.AFTER_BODY, iu(e, t));
}
function hh(e, t) {
  const r = t.tagID;
  e.openElements.hasInScope(r) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(r));
}
function Eh(e) {
  const t = e.openElements.tmplCount > 0, { formElement: r } = e;
  t || (e.formElement = null), (r || t) && e.openElements.hasInScope(i.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(i.FORM) : r && e.openElements.remove(r));
}
function xh(e) {
  e.openElements.hasInButtonScope(i.P) || e._insertFakeElement(O.P, i.P), e._closePElement();
}
function mh(e) {
  e.openElements.hasInListItemScope(i.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(i.LI), e.openElements.popUntilTagNamePopped(i.LI));
}
function ph(e, t) {
  const r = t.tagID;
  e.openElements.hasInScope(r) && (e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilTagNamePopped(r));
}
function bh(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function Th(e, t) {
  const r = t.tagID;
  e.openElements.hasInScope(r) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(r), e.activeFormattingElements.clearToLastMarker());
}
function Ah(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(O.BR, i.BR), e.openElements.pop(), e.framesetOk = !1;
}
function Xi(e, t) {
  const r = t.tagName, n = t.tagID;
  for (let s = e.openElements.stackTop; s > 0; s--) {
    const a = e.openElements.items[s], u = e.openElements.tagIDs[s];
    if (n === u && (n !== i.UNKNOWN || e.treeAdapter.getTagName(a) === r)) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.stackTop >= s && e.openElements.shortenToLength(s);
      break;
    }
    if (e._isSpecialElement(a, u))
      break;
  }
}
function Kr(e, t) {
  switch (t.tagID) {
    case i.A:
    case i.B:
    case i.I:
    case i.S:
    case i.U:
    case i.EM:
    case i.TT:
    case i.BIG:
    case i.CODE:
    case i.FONT:
    case i.NOBR:
    case i.SMALL:
    case i.STRIKE:
    case i.STRONG: {
      W0(e, t);
      break;
    }
    case i.P: {
      xh(e);
      break;
    }
    case i.DL:
    case i.UL:
    case i.OL:
    case i.DIR:
    case i.DIV:
    case i.NAV:
    case i.PRE:
    case i.MAIN:
    case i.MENU:
    case i.ASIDE:
    case i.BUTTON:
    case i.CENTER:
    case i.FIGURE:
    case i.FOOTER:
    case i.HEADER:
    case i.HGROUP:
    case i.DIALOG:
    case i.ADDRESS:
    case i.ARTICLE:
    case i.DETAILS:
    case i.SEARCH:
    case i.SECTION:
    case i.SUMMARY:
    case i.LISTING:
    case i.FIELDSET:
    case i.BLOCKQUOTE:
    case i.FIGCAPTION: {
      hh(e, t);
      break;
    }
    case i.LI: {
      mh(e);
      break;
    }
    case i.DD:
    case i.DT: {
      ph(e, t);
      break;
    }
    case i.H1:
    case i.H2:
    case i.H3:
    case i.H4:
    case i.H5:
    case i.H6: {
      bh(e);
      break;
    }
    case i.BR: {
      Ah(e);
      break;
    }
    case i.BODY: {
      fh(e, t);
      break;
    }
    case i.HTML: {
      dh(e, t);
      break;
    }
    case i.FORM: {
      Eh(e);
      break;
    }
    case i.APPLET:
    case i.OBJECT:
    case i.MARQUEE: {
      Th(e, t);
      break;
    }
    case i.TEMPLATE: {
      vt(e, t);
      break;
    }
    default:
      Xi(e, t);
  }
}
function Zi(e, t) {
  e.tmplInsertionModeStack.length > 0 ? au(e, t) : z0(e, t);
}
function _h(e, t) {
  var r;
  t.tagID === i.SCRIPT && ((r = e.scriptHandler) === null || r === void 0 || r.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function gh(e, t) {
  e._err(t, L.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function mn(e, t) {
  if (zi.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = C.IN_TABLE_TEXT, t.type) {
      case oe.CHARACTER: {
        eu(e, t);
        break;
      }
      case oe.WHITESPACE_CHARACTER: {
        Ji(e, t);
        break;
      }
    }
  else
    xr(e, t);
}
function Ch(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, W.HTML), e.insertionMode = C.IN_CAPTION;
}
function Dh(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, W.HTML), e.insertionMode = C.IN_COLUMN_GROUP;
}
function Sh(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(O.COLGROUP, i.COLGROUP), e.insertionMode = C.IN_COLUMN_GROUP, G0(e, t);
}
function Nh(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, W.HTML), e.insertionMode = C.IN_TABLE_BODY;
}
function Ih(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(O.TBODY, i.TBODY), e.insertionMode = C.IN_TABLE_BODY, Xr(e, t);
}
function vh(e, t) {
  e.openElements.hasInTableScope(i.TABLE) && (e.openElements.popUntilTagNamePopped(i.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function Bh(e, t) {
  Ki(t) ? e._appendElement(t, W.HTML) : xr(e, t), t.ackSelfClosing = !0;
}
function Oh(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, W.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function wt(e, t) {
  switch (t.tagID) {
    case i.TD:
    case i.TH:
    case i.TR: {
      Ih(e, t);
      break;
    }
    case i.STYLE:
    case i.SCRIPT:
    case i.TEMPLATE: {
      ze(e, t);
      break;
    }
    case i.COL: {
      Sh(e, t);
      break;
    }
    case i.FORM: {
      Oh(e, t);
      break;
    }
    case i.TABLE: {
      vh(e, t);
      break;
    }
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD: {
      Nh(e, t);
      break;
    }
    case i.INPUT: {
      Bh(e, t);
      break;
    }
    case i.CAPTION: {
      Ch(e, t);
      break;
    }
    case i.COLGROUP: {
      Dh(e, t);
      break;
    }
    default:
      xr(e, t);
  }
}
function lr(e, t) {
  switch (t.tagID) {
    case i.TABLE: {
      e.openElements.hasInTableScope(i.TABLE) && (e.openElements.popUntilTagNamePopped(i.TABLE), e._resetInsertionMode());
      break;
    }
    case i.TEMPLATE: {
      vt(e, t);
      break;
    }
    case i.BODY:
    case i.CAPTION:
    case i.COL:
    case i.COLGROUP:
    case i.HTML:
    case i.TBODY:
    case i.TD:
    case i.TFOOT:
    case i.TH:
    case i.THEAD:
    case i.TR:
      break;
    default:
      xr(e, t);
  }
}
function xr(e, t) {
  const r = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, jr(e, t), e.fosterParentingEnabled = r;
}
function Ji(e, t) {
  e.pendingCharacterTokens.push(t);
}
function eu(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Qt(e, t) {
  let r = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; r < e.pendingCharacterTokens.length; r++)
      xr(e, e.pendingCharacterTokens[r]);
  else
    for (; r < e.pendingCharacterTokens.length; r++)
      e._insertCharacters(e.pendingCharacterTokens[r]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const tu = /* @__PURE__ */ new Set([i.CAPTION, i.COL, i.COLGROUP, i.TBODY, i.TD, i.TFOOT, i.TH, i.THEAD, i.TR]);
function yh(e, t) {
  const r = t.tagID;
  tu.has(r) ? e.openElements.hasInTableScope(i.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = C.IN_TABLE, wt(e, t)) : Oe(e, t);
}
function Rh(e, t) {
  const r = t.tagID;
  switch (r) {
    case i.CAPTION:
    case i.TABLE: {
      e.openElements.hasInTableScope(i.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = C.IN_TABLE, r === i.TABLE && lr(e, t));
      break;
    }
    case i.BODY:
    case i.COL:
    case i.COLGROUP:
    case i.HTML:
    case i.TBODY:
    case i.TD:
    case i.TFOOT:
    case i.TH:
    case i.THEAD:
    case i.TR:
      break;
    default:
      Kr(e, t);
  }
}
function G0(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.COL: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case i.TEMPLATE: {
      ze(e, t);
      break;
    }
    default:
      wr(e, t);
  }
}
function Lh(e, t) {
  switch (t.tagID) {
    case i.COLGROUP: {
      e.openElements.currentTagId === i.COLGROUP && (e.openElements.pop(), e.insertionMode = C.IN_TABLE);
      break;
    }
    case i.TEMPLATE: {
      vt(e, t);
      break;
    }
    case i.COL:
      break;
    default:
      wr(e, t);
  }
}
function wr(e, t) {
  e.openElements.currentTagId === i.COLGROUP && (e.openElements.pop(), e.insertionMode = C.IN_TABLE, e._processToken(t));
}
function Xr(e, t) {
  switch (t.tagID) {
    case i.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, W.HTML), e.insertionMode = C.IN_ROW;
      break;
    }
    case i.TH:
    case i.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(O.TR, i.TR), e.insertionMode = C.IN_ROW, Zr(e, t);
      break;
    }
    case i.CAPTION:
    case i.COL:
    case i.COLGROUP:
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE, wt(e, t));
      break;
    }
    default:
      wt(e, t);
  }
}
function x0(e, t) {
  const r = t.tagID;
  switch (t.tagID) {
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD: {
      e.openElements.hasInTableScope(r) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE);
      break;
    }
    case i.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE, lr(e, t));
      break;
    }
    case i.BODY:
    case i.CAPTION:
    case i.COL:
    case i.COLGROUP:
    case i.HTML:
    case i.TD:
    case i.TH:
    case i.TR:
      break;
    default:
      lr(e, t);
  }
}
function Zr(e, t) {
  switch (t.tagID) {
    case i.TH:
    case i.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, W.HTML), e.insertionMode = C.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case i.CAPTION:
    case i.COL:
    case i.COLGROUP:
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD:
    case i.TR: {
      e.openElements.hasInTableScope(i.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE_BODY, Xr(e, t));
      break;
    }
    default:
      wt(e, t);
  }
}
function ru(e, t) {
  switch (t.tagID) {
    case i.TR: {
      e.openElements.hasInTableScope(i.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE_BODY);
      break;
    }
    case i.TABLE: {
      e.openElements.hasInTableScope(i.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE_BODY, x0(e, t));
      break;
    }
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(i.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = C.IN_TABLE_BODY, x0(e, t));
      break;
    }
    case i.BODY:
    case i.CAPTION:
    case i.COL:
    case i.COLGROUP:
    case i.HTML:
    case i.TD:
    case i.TH:
      break;
    default:
      lr(e, t);
  }
}
function Fh(e, t) {
  const r = t.tagID;
  tu.has(r) ? (e.openElements.hasInTableScope(i.TD) || e.openElements.hasInTableScope(i.TH)) && (e._closeTableCell(), Zr(e, t)) : Oe(e, t);
}
function Ph(e, t) {
  const r = t.tagID;
  switch (r) {
    case i.TD:
    case i.TH: {
      e.openElements.hasInTableScope(r) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(r), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = C.IN_ROW);
      break;
    }
    case i.TABLE:
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD:
    case i.TR: {
      e.openElements.hasInTableScope(r) && (e._closeTableCell(), ru(e, t));
      break;
    }
    case i.BODY:
    case i.CAPTION:
    case i.COL:
    case i.COLGROUP:
    case i.HTML:
      break;
    default:
      Kr(e, t);
  }
}
function nu(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.OPTION: {
      e.openElements.currentTagId === i.OPTION && e.openElements.pop(), e._insertElement(t, W.HTML);
      break;
    }
    case i.OPTGROUP: {
      e.openElements.currentTagId === i.OPTION && e.openElements.pop(), e.openElements.currentTagId === i.OPTGROUP && e.openElements.pop(), e._insertElement(t, W.HTML);
      break;
    }
    case i.HR: {
      e.openElements.currentTagId === i.OPTION && e.openElements.pop(), e.openElements.currentTagId === i.OPTGROUP && e.openElements.pop(), e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case i.INPUT:
    case i.KEYGEN:
    case i.TEXTAREA:
    case i.SELECT: {
      e.openElements.hasInSelectScope(i.SELECT) && (e.openElements.popUntilTagNamePopped(i.SELECT), e._resetInsertionMode(), t.tagID !== i.SELECT && e._processStartTag(t));
      break;
    }
    case i.SCRIPT:
    case i.TEMPLATE: {
      ze(e, t);
      break;
    }
  }
}
function su(e, t) {
  switch (t.tagID) {
    case i.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === i.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === i.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === i.OPTGROUP && e.openElements.pop();
      break;
    }
    case i.OPTION: {
      e.openElements.currentTagId === i.OPTION && e.openElements.pop();
      break;
    }
    case i.SELECT: {
      e.openElements.hasInSelectScope(i.SELECT) && (e.openElements.popUntilTagNamePopped(i.SELECT), e._resetInsertionMode());
      break;
    }
    case i.TEMPLATE: {
      vt(e, t);
      break;
    }
  }
}
function kh(e, t) {
  const r = t.tagID;
  r === i.CAPTION || r === i.TABLE || r === i.TBODY || r === i.TFOOT || r === i.THEAD || r === i.TR || r === i.TD || r === i.TH ? (e.openElements.popUntilTagNamePopped(i.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : nu(e, t);
}
function wh(e, t) {
  const r = t.tagID;
  r === i.CAPTION || r === i.TABLE || r === i.TBODY || r === i.TFOOT || r === i.THEAD || r === i.TR || r === i.TD || r === i.TH ? e.openElements.hasInTableScope(r) && (e.openElements.popUntilTagNamePopped(i.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : su(e, t);
}
function Mh(e, t) {
  switch (t.tagID) {
    case i.BASE:
    case i.BASEFONT:
    case i.BGSOUND:
    case i.LINK:
    case i.META:
    case i.NOFRAMES:
    case i.SCRIPT:
    case i.STYLE:
    case i.TEMPLATE:
    case i.TITLE: {
      ze(e, t);
      break;
    }
    case i.CAPTION:
    case i.COLGROUP:
    case i.TBODY:
    case i.TFOOT:
    case i.THEAD: {
      e.tmplInsertionModeStack[0] = C.IN_TABLE, e.insertionMode = C.IN_TABLE, wt(e, t);
      break;
    }
    case i.COL: {
      e.tmplInsertionModeStack[0] = C.IN_COLUMN_GROUP, e.insertionMode = C.IN_COLUMN_GROUP, G0(e, t);
      break;
    }
    case i.TR: {
      e.tmplInsertionModeStack[0] = C.IN_TABLE_BODY, e.insertionMode = C.IN_TABLE_BODY, Xr(e, t);
      break;
    }
    case i.TD:
    case i.TH: {
      e.tmplInsertionModeStack[0] = C.IN_ROW, e.insertionMode = C.IN_ROW, Zr(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = C.IN_BODY, e.insertionMode = C.IN_BODY, Oe(e, t);
  }
}
function Hh(e, t) {
  t.tagID === i.TEMPLATE && vt(e, t);
}
function au(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(i.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : z0(e, t);
}
function Uh(e, t) {
  t.tagID === i.HTML ? Oe(e, t) : Mr(e, t);
}
function iu(e, t) {
  var r;
  if (t.tagID === i.HTML) {
    if (e.fragmentContext || (e.insertionMode = C.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === i.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const n = e.openElements.items[1];
      n && !(!((r = e.treeAdapter.getNodeSourceCodeLocation(n)) === null || r === void 0) && r.endTag) && e._setEndLocation(n, t);
    }
  } else
    Mr(e, t);
}
function Mr(e, t) {
  e.insertionMode = C.IN_BODY, jr(e, t);
}
function qh(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.FRAMESET: {
      e._insertElement(t, W.HTML);
      break;
    }
    case i.FRAME: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case i.NOFRAMES: {
      ze(e, t);
      break;
    }
  }
}
function Yh(e, t) {
  t.tagID === i.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== i.FRAMESET && (e.insertionMode = C.AFTER_FRAMESET));
}
function $h(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.NOFRAMES: {
      ze(e, t);
      break;
    }
  }
}
function Wh(e, t) {
  t.tagID === i.HTML && (e.insertionMode = C.AFTER_AFTER_FRAMESET);
}
function zh(e, t) {
  t.tagID === i.HTML ? Oe(e, t) : Dr(e, t);
}
function Dr(e, t) {
  e.insertionMode = C.IN_BODY, jr(e, t);
}
function Gh(e, t) {
  switch (t.tagID) {
    case i.HTML: {
      Oe(e, t);
      break;
    }
    case i.NOFRAMES: {
      ze(e, t);
      break;
    }
  }
}
function Vh(e, t) {
  t.chars = he, e._insertCharacters(t);
}
function Qh(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function uu(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== W.HTML && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function jh(e, t) {
  if (ld(t))
    uu(e), e._startTagOutsideForeignContent(t);
  else {
    const r = e._getAdjustedCurrentElement(), n = e.treeAdapter.getNamespaceURI(r);
    n === W.MATHML ? $i(t) : n === W.SVG && (fd(t), Wi(t)), $0(t), t.selfClosing ? e._appendElement(t, n) : e._insertElement(t, n), t.ackSelfClosing = !0;
  }
}
function Kh(e, t) {
  if (t.tagID === i.P || t.tagID === i.BR) {
    uu(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const n = e.openElements.items[r];
    if (e.treeAdapter.getNamespaceURI(n) === W.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const s = e.treeAdapter.getTagName(n);
    if (s.toLowerCase() === t.tagName) {
      t.tagName = s, e.openElements.shortenToLength(r);
      break;
    }
  }
}
const Xh = /* @__PURE__ */ new Set([
  O.AREA,
  O.BASE,
  O.BASEFONT,
  O.BGSOUND,
  O.BR,
  O.COL,
  O.EMBED,
  O.FRAME,
  O.HR,
  O.IMG,
  O.INPUT,
  O.KEYGEN,
  O.LINK,
  O.META,
  O.PARAM,
  O.SOURCE,
  O.TRACK,
  O.WBR
]);
function Zh(e, t) {
  return t.treeAdapter.isElementNode(e) && t.treeAdapter.getNamespaceURI(e) === W.HTML && Xh.has(t.treeAdapter.getTagName(e));
}
const Jh = { treeAdapter: tt, scriptingEnabled: !0 };
function e1(e, t) {
  const r = { ...Jh, ...t };
  return ou(e, r);
}
function t1(e, t) {
  let r = "";
  const n = t.treeAdapter.isElementNode(e) && t.treeAdapter.getTagName(e) === O.TEMPLATE && t.treeAdapter.getNamespaceURI(e) === W.HTML ? t.treeAdapter.getTemplateContent(e) : e, s = t.treeAdapter.getChildNodes(n);
  if (s)
    for (const a of s)
      r += ou(a, t);
  return r;
}
function ou(e, t) {
  return t.treeAdapter.isElementNode(e) ? r1(e, t) : t.treeAdapter.isTextNode(e) ? s1(e, t) : t.treeAdapter.isCommentNode(e) ? a1(e, t) : t.treeAdapter.isDocumentTypeNode(e) ? i1(e, t) : "";
}
function r1(e, t) {
  const r = t.treeAdapter.getTagName(e);
  return `<${r}${n1(e, t)}>${Zh(e, t) ? "" : `${t1(e, t)}</${r}>`}`;
}
function n1(e, { treeAdapter: t }) {
  let r = "";
  for (const n of t.getAttrList(e)) {
    if (r += " ", n.namespace)
      switch (n.namespace) {
        case W.XML: {
          r += `xml:${n.name}`;
          break;
        }
        case W.XMLNS: {
          n.name !== "xmlns" && (r += "xmlns:"), r += n.name;
          break;
        }
        case W.XLINK: {
          r += `xlink:${n.name}`;
          break;
        }
        default:
          r += `${n.prefix}:${n.name}`;
      }
    else
      r += n.name;
    r += `="${Za(n.value)}"`;
  }
  return r;
}
function s1(e, t) {
  const { treeAdapter: r } = t, n = r.getTextNodeContent(e), s = r.getParentNode(e), a = s && r.isElementNode(s) && r.getTagName(s);
  return a && r.getNamespaceURI(s) === W.HTML && Mf(a, t.scriptingEnabled) ? n : Ja(n);
}
function a1(e, { treeAdapter: t }) {
  return `<!--${t.getCommentNodeContent(e)}-->`;
}
function i1(e, { treeAdapter: t }) {
  return `<!DOCTYPE ${t.getDocumentTypeNodeName(e)}>`;
}
function u1(e, t) {
  return Gi.parse(e, t);
}
function o1(e, t, r) {
  typeof e == "string" && (r = t, t = e, e = null);
  const n = Gi.getFragmentParser(e, r);
  return n.tokenizer.write(t, !0), n.getFragment();
}
function ws(e) {
  const t = e.includes('"') ? "'" : '"';
  return t + e + t;
}
function c1(e, t, r) {
  let n = "!DOCTYPE ";
  return e && (n += e), t ? n += ` PUBLIC ${ws(t)}` : r && (n += " SYSTEM"), r && (n += ` ${ws(r)}`), n;
}
const ut = {
  // Re-exports from domhandler
  isCommentNode: Yr,
  isElementNode: ee,
  isTextNode: Ke,
  //Node construction
  createDocument() {
    const e = new Ct([]);
    return e["x-mode"] = we.NO_QUIRKS, e;
  },
  createDocumentFragment() {
    return new Ct([]);
  },
  createElement(e, t, r) {
    const n = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null);
    for (let o = 0; o < r.length; o++) {
      const f = r[o].name;
      n[f] = r[o].value, s[f] = r[o].namespace, a[f] = r[o].prefix;
    }
    const u = new v0(e, n, []);
    return u.namespace = t, u["x-attribsNamespace"] = s, u["x-attribsPrefix"] = a, u;
  },
  createCommentNode(e) {
    return new S0(e);
  },
  createTextNode(e) {
    return new ar(e);
  },
  //Tree mutation
  appendChild(e, t) {
    const r = e.children[e.children.length - 1];
    r && (r.next = t, t.prev = r), e.children.push(t), t.parent = e;
  },
  insertBefore(e, t, r) {
    const n = e.children.indexOf(r), { prev: s } = r;
    s && (s.next = t, t.prev = s), r.prev = t, t.next = r, e.children.splice(n, 0, t), t.parent = e;
  },
  setTemplateContent(e, t) {
    ut.appendChild(e, t);
  },
  getTemplateContent(e) {
    return e.children[0];
  },
  setDocumentType(e, t, r, n) {
    const s = c1(t, r, n);
    let a = e.children.find((u) => n0(u) && u.name === "!doctype");
    a ? a.data = s ?? null : (a = new N0("!doctype", s), ut.appendChild(e, a)), a["x-name"] = t, a["x-publicId"] = r, a["x-systemId"] = n;
  },
  setDocumentMode(e, t) {
    e["x-mode"] = t;
  },
  getDocumentMode(e) {
    return e["x-mode"];
  },
  detachNode(e) {
    if (e.parent) {
      const t = e.parent.children.indexOf(e), { prev: r, next: n } = e;
      e.prev = null, e.next = null, r && (r.next = n), n && (n.prev = r), e.parent.children.splice(t, 1), e.parent = null;
    }
  },
  insertText(e, t) {
    const r = e.children[e.children.length - 1];
    r && Ke(r) ? r.data += t : ut.appendChild(e, ut.createTextNode(t));
  },
  insertTextBefore(e, t, r) {
    const n = e.children[e.children.indexOf(r) - 1];
    n && Ke(n) ? n.data += t : ut.insertBefore(e, ut.createTextNode(t), r);
  },
  adoptAttributes(e, t) {
    for (let r = 0; r < t.length; r++) {
      const n = t[r].name;
      e.attribs[n] === void 0 && (e.attribs[n] = t[r].value, e["x-attribsNamespace"][n] = t[r].namespace, e["x-attribsPrefix"][n] = t[r].prefix);
    }
  },
  //Tree traversing
  getFirstChild(e) {
    return e.children[0];
  },
  getChildNodes(e) {
    return e.children;
  },
  getParentNode(e) {
    return e.parent;
  },
  getAttrList(e) {
    return e.attributes;
  },
  //Node data
  getTagName(e) {
    return e.name;
  },
  getNamespaceURI(e) {
    return e.namespace;
  },
  getTextNodeContent(e) {
    return e.data;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    var t;
    return (t = e["x-name"]) !== null && t !== void 0 ? t : "";
  },
  getDocumentTypeNodePublicId(e) {
    var t;
    return (t = e["x-publicId"]) !== null && t !== void 0 ? t : "";
  },
  getDocumentTypeNodeSystemId(e) {
    var t;
    return (t = e["x-systemId"]) !== null && t !== void 0 ? t : "";
  },
  //Node types
  isDocumentTypeNode(e) {
    return n0(e) && e.name === "!doctype";
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    t && (e.startIndex = t.startOffset, e.endIndex = t.endOffset), e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    t.endOffset != null && (e.endIndex = t.endOffset), e.sourceCodeLocation = {
      ...e.sourceCodeLocation,
      ...t
    };
  }
};
function l1(e, t, r, n) {
  var s;
  return (s = t.treeAdapter) !== null && s !== void 0 || (t.treeAdapter = ut), t.scriptingEnabled !== !1 && (t.scriptingEnabled = !0), r ? u1(e, t) : o1(n, e, t);
}
const f1 = { treeAdapter: ut };
function d1(e) {
  const t = "length" in e ? e : [e];
  for (let n = 0; n < t.length; n += 1) {
    const s = t[n];
    dt(s) && Array.prototype.splice.call(t, n, 1, ...s.children);
  }
  let r = "";
  for (let n = 0; n < t.length; n += 1) {
    const s = t[n];
    r += e1(s, f1);
  }
  return r;
}
var J;
(function(e) {
  e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(J || (J = {}));
var G;
(function(e) {
  e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.BeforeSpecialT = 23] = "BeforeSpecialT", e[e.SpecialStartSequence = 24] = "SpecialStartSequence", e[e.InSpecialTag = 25] = "InSpecialTag", e[e.InEntity = 26] = "InEntity";
})(G || (G = {}));
function et(e) {
  return e === J.Space || e === J.NewLine || e === J.Tab || e === J.FormFeed || e === J.CarriageReturn;
}
function gr(e) {
  return e === J.Slash || e === J.Gt || et(e);
}
function h1(e) {
  return e >= J.LowerA && e <= J.LowerZ || e >= J.UpperA && e <= J.UpperZ;
}
var je;
(function(e) {
  e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
})(je || (je = {}));
const De = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 62]),
  // `-->`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ])
  // `</textarea`
};
class E1 {
  constructor({ xmlMode: t = !1, decodeEntities: r = !0 }, n) {
    this.cbs = n, this.state = G.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = G.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = t, this.decodeEntities = r, this.entityDecoder = new O0(t ? Qa : B0, (s, a) => this.emitCodePoint(s, a));
  }
  reset() {
    this.state = G.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = G.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
  }
  write(t) {
    this.offset += this.buffer.length, this.buffer = t, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(t) {
    t === J.Lt || !this.decodeEntities && this.fastForwardTo(J.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = G.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === J.Amp && this.startEntity();
  }
  stateSpecialStartSequence(t) {
    const r = this.sequenceIndex === this.currentSequence.length;
    if (!(r ? (
      // If we are at the end of the sequence, make sure the tag name has ended
      gr(t)
    ) : (
      // Otherwise, do a case-insensitive comparison
      (t | 32) === this.currentSequence[this.sequenceIndex]
    )))
      this.isSpecial = !1;
    else if (!r) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0, this.state = G.InTagName, this.stateInTagName(t);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(t) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (t === J.Gt || et(t)) {
        const r = this.index - this.currentSequence.length;
        if (this.sectionStart < r) {
          const n = this.index;
          this.index = r, this.cbs.ontext(this.sectionStart, r), this.index = n;
        }
        this.isSpecial = !1, this.sectionStart = r + 2, this.stateInClosingTagName(t);
        return;
      }
      this.sequenceIndex = 0;
    }
    (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === De.TitleEnd ? this.decodeEntities && t === J.Amp && this.startEntity() : this.fastForwardTo(J.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === J.Lt);
  }
  stateCDATASequence(t) {
    t === De.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === De.Cdata.length && (this.state = G.InCommentLike, this.currentSequence = De.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = G.InDeclaration, this.stateInDeclaration(t));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(t) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === t)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(t) {
    t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === De.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = G.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(t) {
    return this.xmlMode ? !gr(t) : h1(t);
  }
  startSpecial(t, r) {
    this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = r, this.state = G.SpecialStartSequence;
  }
  stateBeforeTagName(t) {
    if (t === J.ExclamationMark)
      this.state = G.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (t === J.Questionmark)
      this.state = G.InProcessingInstruction, this.sectionStart = this.index + 1;
    else if (this.isTagStartChar(t)) {
      const r = t | 32;
      this.sectionStart = this.index, this.xmlMode ? this.state = G.InTagName : r === De.ScriptEnd[2] ? this.state = G.BeforeSpecialS : r === De.TitleEnd[2] ? this.state = G.BeforeSpecialT : this.state = G.InTagName;
    } else t === J.Slash ? this.state = G.BeforeClosingTagName : (this.state = G.Text, this.stateText(t));
  }
  stateInTagName(t) {
    gr(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateBeforeClosingTagName(t) {
    et(t) || (t === J.Gt ? this.state = G.Text : (this.state = this.isTagStartChar(t) ? G.InClosingTagName : G.InSpecialComment, this.sectionStart = this.index));
  }
  stateInClosingTagName(t) {
    (t === J.Gt || et(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = G.AfterClosingTagName, this.stateAfterClosingTagName(t));
  }
  stateAfterClosingTagName(t) {
    (t === J.Gt || this.fastForwardTo(J.Gt)) && (this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(t) {
    t === J.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = G.InSpecialTag, this.sequenceIndex = 0) : this.state = G.Text, this.sectionStart = this.index + 1) : t === J.Slash ? this.state = G.InSelfClosingTag : et(t) || (this.state = G.InAttributeName, this.sectionStart = this.index);
  }
  stateInSelfClosingTag(t) {
    t === J.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = G.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : et(t) || (this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateInAttributeName(t) {
    (t === J.Eq || gr(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = G.AfterAttributeName, this.stateAfterAttributeName(t));
  }
  stateAfterAttributeName(t) {
    t === J.Eq ? this.state = G.BeforeAttributeValue : t === J.Slash || t === J.Gt ? (this.cbs.onattribend(je.NoValue, this.sectionStart), this.sectionStart = -1, this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(t)) : et(t) || (this.cbs.onattribend(je.NoValue, this.sectionStart), this.state = G.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(t) {
    t === J.DoubleQuote ? (this.state = G.InAttributeValueDq, this.sectionStart = this.index + 1) : t === J.SingleQuote ? (this.state = G.InAttributeValueSq, this.sectionStart = this.index + 1) : et(t) || (this.sectionStart = this.index, this.state = G.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
  }
  handleInAttributeValue(t, r) {
    t === r || !this.decodeEntities && this.fastForwardTo(r) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(r === J.DoubleQuote ? je.Double : je.Single, this.index + 1), this.state = G.BeforeAttributeName) : this.decodeEntities && t === J.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(t) {
    this.handleInAttributeValue(t, J.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(t) {
    this.handleInAttributeValue(t, J.SingleQuote);
  }
  stateInAttributeValueNoQuotes(t) {
    et(t) || t === J.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(je.Unquoted, this.index), this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === J.Amp && this.startEntity();
  }
  stateBeforeDeclaration(t) {
    t === J.OpeningSquareBracket ? (this.state = G.CDATASequence, this.sequenceIndex = 0) : this.state = t === J.Dash ? G.BeforeComment : G.InDeclaration;
  }
  stateInDeclaration(t) {
    (t === J.Gt || this.fastForwardTo(J.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateInProcessingInstruction(t) {
    (t === J.Gt || this.fastForwardTo(J.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeComment(t) {
    t === J.Dash ? (this.state = G.InCommentLike, this.currentSequence = De.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = G.InDeclaration;
  }
  stateInSpecialComment(t) {
    (t === J.Gt || this.fastForwardTo(J.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeSpecialS(t) {
    const r = t | 32;
    r === De.ScriptEnd[3] ? this.startSpecial(De.ScriptEnd, 4) : r === De.StyleEnd[3] ? this.startSpecial(De.StyleEnd, 4) : (this.state = G.InTagName, this.stateInTagName(t));
  }
  stateBeforeSpecialT(t) {
    const r = t | 32;
    r === De.TitleEnd[3] ? this.startSpecial(De.TitleEnd, 4) : r === De.TextareaEnd[3] ? this.startSpecial(De.TextareaEnd, 4) : (this.state = G.InTagName, this.stateInTagName(t));
  }
  startEntity() {
    this.baseState = this.state, this.state = G.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? Ye.Strict : this.baseState === G.Text || this.baseState === G.InSpecialTag ? Ye.Legacy : Ye.Attribute);
  }
  stateInEntity() {
    const t = this.entityDecoder.write(this.buffer, this.index - this.offset);
    t >= 0 ? (this.state = this.baseState, t === 0 && (this.index = this.entityStart)) : this.index = this.offset + this.buffer.length - 1;
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === G.Text || this.state === G.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === G.InAttributeValueDq || this.state === G.InAttributeValueSq || this.state === G.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const t = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case G.Text: {
          this.stateText(t);
          break;
        }
        case G.SpecialStartSequence: {
          this.stateSpecialStartSequence(t);
          break;
        }
        case G.InSpecialTag: {
          this.stateInSpecialTag(t);
          break;
        }
        case G.CDATASequence: {
          this.stateCDATASequence(t);
          break;
        }
        case G.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(t);
          break;
        }
        case G.InAttributeName: {
          this.stateInAttributeName(t);
          break;
        }
        case G.InCommentLike: {
          this.stateInCommentLike(t);
          break;
        }
        case G.InSpecialComment: {
          this.stateInSpecialComment(t);
          break;
        }
        case G.BeforeAttributeName: {
          this.stateBeforeAttributeName(t);
          break;
        }
        case G.InTagName: {
          this.stateInTagName(t);
          break;
        }
        case G.InClosingTagName: {
          this.stateInClosingTagName(t);
          break;
        }
        case G.BeforeTagName: {
          this.stateBeforeTagName(t);
          break;
        }
        case G.AfterAttributeName: {
          this.stateAfterAttributeName(t);
          break;
        }
        case G.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(t);
          break;
        }
        case G.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(t);
          break;
        }
        case G.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(t);
          break;
        }
        case G.AfterClosingTagName: {
          this.stateAfterClosingTagName(t);
          break;
        }
        case G.BeforeSpecialS: {
          this.stateBeforeSpecialS(t);
          break;
        }
        case G.BeforeSpecialT: {
          this.stateBeforeSpecialT(t);
          break;
        }
        case G.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(t);
          break;
        }
        case G.InSelfClosingTag: {
          this.stateInSelfClosingTag(t);
          break;
        }
        case G.InDeclaration: {
          this.stateInDeclaration(t);
          break;
        }
        case G.BeforeDeclaration: {
          this.stateBeforeDeclaration(t);
          break;
        }
        case G.BeforeComment: {
          this.stateBeforeComment(t);
          break;
        }
        case G.InProcessingInstruction: {
          this.stateInProcessingInstruction(t);
          break;
        }
        case G.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === G.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const t = this.buffer.length + this.offset;
    this.sectionStart >= t || (this.state === G.InCommentLike ? this.currentSequence === De.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === G.InTagName || this.state === G.BeforeAttributeName || this.state === G.BeforeAttributeValue || this.state === G.AfterAttributeName || this.state === G.InAttributeName || this.state === G.InAttributeValueSq || this.state === G.InAttributeValueDq || this.state === G.InAttributeValueNq || this.state === G.InClosingTagName || this.cbs.ontext(this.sectionStart, t));
  }
  emitCodePoint(t, r) {
    this.baseState !== G.Text && this.baseState !== G.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
  }
}
const Ft = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), le = /* @__PURE__ */ new Set(["p"]), Ms = /* @__PURE__ */ new Set(["thead", "tbody"]), Hs = /* @__PURE__ */ new Set(["dd", "dt"]), Us = /* @__PURE__ */ new Set(["rt", "rp"]), x1 = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", le],
  ["h1", le],
  ["h2", le],
  ["h3", le],
  ["h4", le],
  ["h5", le],
  ["h6", le],
  ["select", Ft],
  ["input", Ft],
  ["output", Ft],
  ["button", Ft],
  ["datalist", Ft],
  ["textarea", Ft],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Hs],
  ["dt", Hs],
  ["address", le],
  ["article", le],
  ["aside", le],
  ["blockquote", le],
  ["details", le],
  ["div", le],
  ["dl", le],
  ["fieldset", le],
  ["figcaption", le],
  ["figure", le],
  ["footer", le],
  ["form", le],
  ["header", le],
  ["hr", le],
  ["main", le],
  ["nav", le],
  ["ol", le],
  ["pre", le],
  ["section", le],
  ["table", le],
  ["ul", le],
  ["rt", Us],
  ["rp", Us],
  ["tbody", Ms],
  ["tfoot", Ms]
]), m1 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), qs = /* @__PURE__ */ new Set(["math", "svg"]), Ys = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), p1 = /\s|\//;
class b1 {
  constructor(t, r = {}) {
    var n, s, a, u, o, f;
    this.options = r, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = t ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (n = r.lowerCaseTags) !== null && n !== void 0 ? n : this.htmlMode, this.lowerCaseAttributeNames = (s = r.lowerCaseAttributeNames) !== null && s !== void 0 ? s : this.htmlMode, this.recognizeSelfClosing = (a = r.recognizeSelfClosing) !== null && a !== void 0 ? a : !this.htmlMode, this.tokenizer = new ((u = r.Tokenizer) !== null && u !== void 0 ? u : E1)(this.options, this), this.foreignContext = [!this.htmlMode], (f = (o = this.cbs).onparserinit) === null || f === void 0 || f.call(o, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(t, r) {
    var n, s;
    const a = this.getSlice(t, r);
    this.endIndex = r - 1, (s = (n = this.cbs).ontext) === null || s === void 0 || s.call(n, a), this.startIndex = r;
  }
  /** @internal */
  ontextentity(t, r) {
    var n, s;
    this.endIndex = r - 1, (s = (n = this.cbs).ontext) === null || s === void 0 || s.call(n, s0(t)), this.startIndex = r;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   */
  isVoidElement(t) {
    return this.htmlMode && m1.has(t);
  }
  /** @internal */
  onopentagname(t, r) {
    this.endIndex = r;
    let n = this.getSlice(t, r);
    this.lowerCaseTagNames && (n = n.toLowerCase()), this.emitOpenTag(n);
  }
  emitOpenTag(t) {
    var r, n, s, a;
    this.openTagStart = this.startIndex, this.tagname = t;
    const u = this.htmlMode && x1.get(t);
    if (u)
      for (; this.stack.length > 0 && u.has(this.stack[0]); ) {
        const o = this.stack.shift();
        (n = (r = this.cbs).onclosetag) === null || n === void 0 || n.call(r, o, !0);
      }
    this.isVoidElement(t) || (this.stack.unshift(t), this.htmlMode && (qs.has(t) ? this.foreignContext.unshift(!0) : Ys.has(t) && this.foreignContext.unshift(!1))), (a = (s = this.cbs).onopentagname) === null || a === void 0 || a.call(s, t), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(t) {
    var r, n;
    this.startIndex = this.openTagStart, this.attribs && ((n = (r = this.cbs).onopentag) === null || n === void 0 || n.call(r, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /** @internal */
  onopentagend(t) {
    this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
  }
  /** @internal */
  onclosetag(t, r) {
    var n, s, a, u, o, f, c, l;
    this.endIndex = r;
    let x = this.getSlice(t, r);
    if (this.lowerCaseTagNames && (x = x.toLowerCase()), this.htmlMode && (qs.has(x) || Ys.has(x)) && this.foreignContext.shift(), this.isVoidElement(x))
      this.htmlMode && x === "br" && ((u = (a = this.cbs).onopentagname) === null || u === void 0 || u.call(a, "br"), (f = (o = this.cbs).onopentag) === null || f === void 0 || f.call(o, "br", {}, !0), (l = (c = this.cbs).onclosetag) === null || l === void 0 || l.call(c, "br", !1));
    else {
      const d = this.stack.indexOf(x);
      if (d !== -1)
        for (let p = 0; p <= d; p++) {
          const h = this.stack.shift();
          (s = (n = this.cbs).onclosetag) === null || s === void 0 || s.call(n, h, p !== d);
        }
      else this.htmlMode && x === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = r + 1;
  }
  /** @internal */
  onselfclosingtag(t) {
    this.endIndex = t, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
  }
  closeCurrentTag(t) {
    var r, n;
    const s = this.tagname;
    this.endOpenTag(t), this.stack[0] === s && ((n = (r = this.cbs).onclosetag) === null || n === void 0 || n.call(r, s, !t), this.stack.shift());
  }
  /** @internal */
  onattribname(t, r) {
    this.startIndex = t;
    const n = this.getSlice(t, r);
    this.attribname = this.lowerCaseAttributeNames ? n.toLowerCase() : n;
  }
  /** @internal */
  onattribdata(t, r) {
    this.attribvalue += this.getSlice(t, r);
  }
  /** @internal */
  onattribentity(t) {
    this.attribvalue += s0(t);
  }
  /** @internal */
  onattribend(t, r) {
    var n, s;
    this.endIndex = r, (s = (n = this.cbs).onattribute) === null || s === void 0 || s.call(n, this.attribname, this.attribvalue, t === je.Double ? '"' : t === je.Single ? "'" : t === je.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(t) {
    const r = t.search(p1);
    let n = r < 0 ? t : t.substr(0, r);
    return this.lowerCaseTagNames && (n = n.toLowerCase()), n;
  }
  /** @internal */
  ondeclaration(t, r) {
    this.endIndex = r;
    const n = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const s = this.getInstructionName(n);
      this.cbs.onprocessinginstruction(`!${s}`, `!${n}`);
    }
    this.startIndex = r + 1;
  }
  /** @internal */
  onprocessinginstruction(t, r) {
    this.endIndex = r;
    const n = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const s = this.getInstructionName(n);
      this.cbs.onprocessinginstruction(`?${s}`, `?${n}`);
    }
    this.startIndex = r + 1;
  }
  /** @internal */
  oncomment(t, r, n) {
    var s, a, u, o;
    this.endIndex = r, (a = (s = this.cbs).oncomment) === null || a === void 0 || a.call(s, this.getSlice(t, r - n)), (o = (u = this.cbs).oncommentend) === null || o === void 0 || o.call(u), this.startIndex = r + 1;
  }
  /** @internal */
  oncdata(t, r, n) {
    var s, a, u, o, f, c, l, x, d, p;
    this.endIndex = r;
    const h = this.getSlice(t, r - n);
    !this.htmlMode || this.options.recognizeCDATA ? ((a = (s = this.cbs).oncdatastart) === null || a === void 0 || a.call(s), (o = (u = this.cbs).ontext) === null || o === void 0 || o.call(u, h), (c = (f = this.cbs).oncdataend) === null || c === void 0 || c.call(f)) : ((x = (l = this.cbs).oncomment) === null || x === void 0 || x.call(l, `[CDATA[${h}]]`), (p = (d = this.cbs).oncommentend) === null || p === void 0 || p.call(d)), this.startIndex = r + 1;
  }
  /** @internal */
  onend() {
    var t, r;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let n = 0; n < this.stack.length; n++)
        this.cbs.onclosetag(this.stack[n], !0);
    }
    (r = (t = this.cbs).onend) === null || r === void 0 || r.call(t);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var t, r, n, s;
    (r = (t = this.cbs).onreset) === null || r === void 0 || r.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (s = (n = this.cbs).onparserinit) === null || s === void 0 || s.call(n, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(t) {
    this.reset(), this.end(t);
  }
  getSlice(t, r) {
    for (; t - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let n = this.buffers[0].slice(t - this.bufferOffset, r - this.bufferOffset);
    for (; r - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), n += this.buffers[0].slice(0, r - this.bufferOffset);
    return n;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(t) {
    var r, n;
    if (this.ended) {
      (n = (r = this.cbs).onerror) === null || n === void 0 || n.call(r, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(t) {
    var r, n;
    if (this.ended) {
      (n = (r = this.cbs).onerror) === null || n === void 0 || n.call(r, new Error(".end() after done!"));
      return;
    }
    t && this.write(t), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(t) {
    this.write(t);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(t) {
    this.end(t);
  }
}
function T1(e, t) {
  const r = new _o(void 0, t);
  return new b1(r, t).end(e), r.root;
}
const A1 = Ql((e, t, r, n) => t._useHtmlParser2 ? T1(e, t) : l1(e, t, r, n)), _1 = vf(A1, (e, t) => t._useHtmlParser2 ? $r(e, t) : d1(e));
Me.extend(uo);
Me.extend($a);
Me.extend(za);
function h2() {
  const e = {
    mondayToThursday: [
      ["08:00 AM", "08:30 AM"],
      ["10:15 AM", "10:45 AM"],
      ["12:45 PM", "01:15 PM"],
      ["03:15 PM", "03:45 PM"],
      ["05:45 PM", "06:15 PM"],
      ["08:45 PM", "09:15 PM"]
    ],
    friday: [
      ["08:00 AM", "08:30 AM"],
      ["10:15 AM", "10:45 AM"],
      ["12:45 PM", "01:15 PM"],
      ["03:15 PM", "03:45 PM"],
      ["07:45 PM", "08:15 PM"]
    ]
  }, t = Me().tz("America/New_York"), r = t.day();
  let n = [];
  if (r >= 1 && r <= 4)
    n = e.mondayToThursday;
  else if (r === 5)
    n = e.friday;
  else
    return !1;
  for (const [s, a] of n)
    if (t.isAfter(Me.tz(s, "hh:mm A", "America/New_York")) && t.isBefore(Me.tz(a, "hh:mm A", "America/New_York")))
      return !0;
  return !1;
}
function E2(e) {
  return Me.tz(e, "YYYY-MM-DD HH:mm:ss", "America/Los_Angeles").format("MMM. DD, YYYY [at] h:mm a");
}
const x2 = (e) => Me(e).format("MMM. D, YYYY"), m2 = (e) => e == "sm" && window.innerWidth < 768, p2 = (e, t) => e.length <= t ? e : e.substring(0, t) + "...", b2 = (e) => {
  if (!e) return 0;
  const n = e.split(/\s+/).length / 200;
  return Math.ceil(n);
}, T2 = (e) => {
  const t = [...e];
  for (let r = t.length - 1; r > 0; r--) {
    const n = Math.floor(Math.random() * (r + 1));
    [t[r], t[n]] = [t[n], t[r]];
  }
  return t;
}, A2 = (e) => "/" + decodeURI(e).toLowerCase() + "/", _2 = (e, t) => t.filter((n) => n.id === e)[0];
function g2(e) {
  return e >= 1e9 ? (e / 1e9).toFixed(2) + "B" : e >= 1e6 ? (e / 1e6).toFixed(2) + "M" : e.toString();
}
const C2 = (e) => {
  const t = [], r = _1(e, {
    xmlMode: !1
    // Do not treat input as XML
  }), n = /\[?(?:NASDAQ|NYSE):\s*([A-Z]+)]?/i;
  return r("h3").each((s, a) => {
    const o = r(a).text().match(n);
    if (o && o[1]) {
      const f = o[1];
      t.includes(f) || t.push(f);
    }
  }), r("p").each((s, a) => {
    const o = r(a).text().match(n);
    if (o && o[1]) {
      const f = o[1];
      t.includes(f) || t.push(f);
    }
  }), t;
}, D2 = /\[?(?:NASDAQ|NYSE):\s*([A-Z]+)]?/i;
function g1(e) {
  const t = document.cookie.split(";");
  for (const r of t) {
    const [n, s] = r.split("=");
    if (n.trim() === e)
      return decodeURIComponent(s);
  }
  return null;
}
const C1 = () => !!g1("cookieConsent"), D1 = {
  key: 0,
  class: "cookie-consent"
}, S1 = { class: "container xl:container w-full mx-auto cookie-consent-body gap-[16px] relative !px-0" }, S2 = /* @__PURE__ */ Nt({
  __name: "CookieConsent",
  setup(e) {
    const t = $e(!0), r = $e(null);
    function n(a, u, o) {
      const f = /* @__PURE__ */ new Date();
      f.setTime(f.getTime() + o * 24 * 60 * 60 * 1e3);
      const c = `expires=${f.toUTCString()}`;
      document.cookie = `${a}=${encodeURIComponent(u)}; ${c}; path=/`;
    }
    const s = async () => {
      C1() || (t.value = !1, await setTimeout(() => {
        n("cookieConsent", !0, 182), t.value = !0;
      }, 12e3));
    };
    return ft(async () => {
      await s();
    }), C0(
      () => t.value,
      () => {
        t.value && r.value && (console.log("hide banner"), clearTimeout(r.value));
      }
    ), (a, u) => t.value ? bt("", !0) : (pe(), ve("section", D1, [
      X("div", S1, [
        u[2] || (u[2] = X("p", { class: "white-space-nowrap text-left" }, [
          ot(" We use cookies to provide you with the best online experience. If you continue browsing, we consider that you accept our "),
          X("span", { class: "inline-flex" }, [
            X("a", {
              to: "/cookie-policy",
              class: "underline",
              innerHTML: "Cookie Policy"
            }),
            ot(" , ")
          ]),
          ot(" and also agree to the terms of our "),
          X("span", null, [
            X("a", {
              to: "/privacy-policy",
              class: "underline",
              innerHTML: "Privacy Policy"
            }),
            ot(" and "),
            X("a", {
              to: "/terms-of-service",
              class: "underline",
              innerHTML: "Terms of Use."
            })
          ])
        ], -1)),
        X("button", {
          class: "absolute z-[50] button-close-consent",
          onClick: u[0] || (u[0] = (o) => t.value = !0)
        }, u[1] || (u[1] = [
          X("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            height: "48",
            width: "48",
            fill: "#fff"
          }, [
            X("path", { d: "m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z" })
          ], -1)
        ]))
      ])
    ]));
  }
});
function cu(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: N1 } = Object.prototype, { getPrototypeOf: V0 } = Object, Jr = /* @__PURE__ */ ((e) => (t) => {
  const r = N1.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ge = (e) => (e = e.toLowerCase(), (t) => Jr(t) === e), en = (e) => (t) => typeof t === e, { isArray: Yt } = Array, fr = en("undefined");
function I1(e) {
  return e !== null && !fr(e) && e.constructor !== null && !fr(e.constructor) && He(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const lu = Ge("ArrayBuffer");
function v1(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && lu(e.buffer), t;
}
const B1 = en("string"), He = en("function"), fu = en("number"), tn = (e) => e !== null && typeof e == "object", O1 = (e) => e === !0 || e === !1, Sr = (e) => {
  if (Jr(e) !== "object")
    return !1;
  const t = V0(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, y1 = Ge("Date"), R1 = Ge("File"), L1 = Ge("Blob"), F1 = Ge("FileList"), P1 = (e) => tn(e) && He(e.pipe), k1 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || He(e.append) && ((t = Jr(e)) === "formdata" || // detect form-data instance
  t === "object" && He(e.toString) && e.toString() === "[object FormData]"));
}, w1 = Ge("URLSearchParams"), [M1, H1, U1, q1] = ["ReadableStream", "Request", "Response", "Headers"].map(Ge), Y1 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function mr(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), Yt(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    const a = r ? Object.getOwnPropertyNames(e) : Object.keys(e), u = a.length;
    let o;
    for (n = 0; n < u; n++)
      o = a[n], t.call(null, e[o], o, e);
  }
}
function du(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const Tt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, hu = (e) => !fr(e) && e !== Tt;
function m0() {
  const { caseless: e } = hu(this) && this || {}, t = {}, r = (n, s) => {
    const a = e && du(t, s) || s;
    Sr(t[a]) && Sr(n) ? t[a] = m0(t[a], n) : Sr(n) ? t[a] = m0({}, n) : Yt(n) ? t[a] = n.slice() : t[a] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && mr(arguments[n], r);
  return t;
}
const $1 = (e, t, r, { allOwnKeys: n } = {}) => (mr(t, (s, a) => {
  r && He(s) ? e[a] = cu(s, r) : e[a] = s;
}, { allOwnKeys: n }), e), W1 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), z1 = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, G1 = (e, t, r, n) => {
  let s, a, u;
  const o = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), a = s.length; a-- > 0; )
      u = s[a], (!n || n(u, e, t)) && !o[u] && (t[u] = e[u], o[u] = !0);
    e = r !== !1 && V0(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, V1 = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Q1 = (e) => {
  if (!e) return null;
  if (Yt(e)) return e;
  let t = e.length;
  if (!fu(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, j1 = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && V0(Uint8Array)), K1 = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const a = s.value;
    t.call(e, a[0], a[1]);
  }
}, X1 = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Z1 = Ge("HTMLFormElement"), J1 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), $s = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), eE = Ge("RegExp"), Eu = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  mr(r, (s, a) => {
    let u;
    (u = t(s, a, e)) !== !1 && (n[a] = u || s);
  }), Object.defineProperties(e, n);
}, tE = (e) => {
  Eu(e, (t, r) => {
    if (He(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (He(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, rE = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((a) => {
      r[a] = !0;
    });
  };
  return Yt(e) ? n(e) : n(String(e).split(t)), r;
}, nE = () => {
}, sE = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, pn = "abcdefghijklmnopqrstuvwxyz", Ws = "0123456789", xu = {
  DIGIT: Ws,
  ALPHA: pn,
  ALPHA_DIGIT: pn + pn.toUpperCase() + Ws
}, aE = (e = 16, t = xu.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function iE(e) {
  return !!(e && He(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const uE = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (tn(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[s] = n;
        const a = Yt(n) ? [] : {};
        return mr(n, (u, o) => {
          const f = r(u, s + 1);
          !fr(f) && (a[o] = f);
        }), t[s] = void 0, a;
      }
    }
    return n;
  };
  return r(e, 0);
}, oE = Ge("AsyncFunction"), cE = (e) => e && (tn(e) || He(e)) && He(e.then) && He(e.catch), mu = ((e, t) => e ? setImmediate : t ? ((r, n) => (Tt.addEventListener("message", ({ source: s, data: a }) => {
  s === Tt && a === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), Tt.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  He(Tt.postMessage)
), lE = typeof queueMicrotask < "u" ? queueMicrotask.bind(Tt) : typeof process < "u" && process.nextTick || mu, F = {
  isArray: Yt,
  isArrayBuffer: lu,
  isBuffer: I1,
  isFormData: k1,
  isArrayBufferView: v1,
  isString: B1,
  isNumber: fu,
  isBoolean: O1,
  isObject: tn,
  isPlainObject: Sr,
  isReadableStream: M1,
  isRequest: H1,
  isResponse: U1,
  isHeaders: q1,
  isUndefined: fr,
  isDate: y1,
  isFile: R1,
  isBlob: L1,
  isRegExp: eE,
  isFunction: He,
  isStream: P1,
  isURLSearchParams: w1,
  isTypedArray: j1,
  isFileList: F1,
  forEach: mr,
  merge: m0,
  extend: $1,
  trim: Y1,
  stripBOM: W1,
  inherits: z1,
  toFlatObject: G1,
  kindOf: Jr,
  kindOfTest: Ge,
  endsWith: V1,
  toArray: Q1,
  forEachEntry: K1,
  matchAll: X1,
  isHTMLForm: Z1,
  hasOwnProperty: $s,
  hasOwnProp: $s,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Eu,
  freezeMethods: tE,
  toObjectSet: rE,
  toCamelCase: J1,
  noop: nE,
  toFiniteNumber: sE,
  findKey: du,
  global: Tt,
  isContextDefined: hu,
  ALPHABET: xu,
  generateString: aE,
  isSpecCompliantForm: iE,
  toJSONObject: uE,
  isAsyncFn: oE,
  isThenable: cE,
  setImmediate: mu,
  asap: lE
};
function ne(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
F.inherits(ne, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: F.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const pu = ne.prototype, bu = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  bu[e] = { value: e };
});
Object.defineProperties(ne, bu);
Object.defineProperty(pu, "isAxiosError", { value: !0 });
ne.from = (e, t, r, n, s, a) => {
  const u = Object.create(pu);
  return F.toFlatObject(e, u, function(f) {
    return f !== Error.prototype;
  }, (o) => o !== "isAxiosError"), ne.call(u, e.message, t, r, n, s), u.cause = e, u.name = e.name, a && Object.assign(u, a), u;
};
const fE = null;
function p0(e) {
  return F.isPlainObject(e) || F.isArray(e);
}
function Tu(e) {
  return F.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function zs(e, t, r) {
  return e ? e.concat(t).map(function(s, a) {
    return s = Tu(s), !r && a ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function dE(e) {
  return F.isArray(e) && !e.some(p0);
}
const hE = F.toFlatObject(F, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function rn(e, t, r) {
  if (!F.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = F.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, E) {
    return !F.isUndefined(E[m]);
  });
  const n = r.metaTokens, s = r.visitor || l, a = r.dots, u = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && F.isSpecCompliantForm(t);
  if (!F.isFunction(s))
    throw new TypeError("visitor must be a function");
  function c(h) {
    if (h === null) return "";
    if (F.isDate(h))
      return h.toISOString();
    if (!f && F.isBlob(h))
      throw new ne("Blob is not supported. Use a Buffer instead.");
    return F.isArrayBuffer(h) || F.isTypedArray(h) ? f && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function l(h, m, E) {
    let D = h;
    if (h && !E && typeof h == "object") {
      if (F.endsWith(m, "{}"))
        m = n ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (F.isArray(h) && dE(h) || (F.isFileList(h) || F.endsWith(m, "[]")) && (D = F.toArray(h)))
        return m = Tu(m), D.forEach(function(A, g) {
          !(F.isUndefined(A) || A === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            u === !0 ? zs([m], g, a) : u === null ? m : m + "[]",
            c(A)
          );
        }), !1;
    }
    return p0(h) ? !0 : (t.append(zs(E, m, a), c(h)), !1);
  }
  const x = [], d = Object.assign(hE, {
    defaultVisitor: l,
    convertValue: c,
    isVisitable: p0
  });
  function p(h, m) {
    if (!F.isUndefined(h)) {
      if (x.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      x.push(h), F.forEach(h, function(D, b) {
        (!(F.isUndefined(D) || D === null) && s.call(
          t,
          D,
          F.isString(b) ? b.trim() : b,
          m,
          d
        )) === !0 && p(D, m ? m.concat(b) : [b]);
      }), x.pop();
    }
  }
  if (!F.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function Gs(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Q0(e, t) {
  this._pairs = [], e && rn(e, this, t);
}
const Au = Q0.prototype;
Au.append = function(t, r) {
  this._pairs.push([t, r]);
};
Au.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Gs);
  } : Gs;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function EE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function _u(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || EE;
  F.isFunction(r) && (r = {
    serialize: r
  });
  const s = r && r.serialize;
  let a;
  if (s ? a = s(t, r) : a = F.isURLSearchParams(t) ? t.toString() : new Q0(t, r).toString(n), a) {
    const u = e.indexOf("#");
    u !== -1 && (e = e.slice(0, u)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Vs {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    F.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const gu = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, xE = typeof URLSearchParams < "u" ? URLSearchParams : Q0, mE = typeof FormData < "u" ? FormData : null, pE = typeof Blob < "u" ? Blob : null, bE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: xE,
    FormData: mE,
    Blob: pE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, j0 = typeof window < "u" && typeof document < "u", b0 = typeof navigator == "object" && navigator || void 0, TE = j0 && (!b0 || ["ReactNative", "NativeScript", "NS"].indexOf(b0.product) < 0), AE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", _E = j0 && window.location.href || "http://localhost", gE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: j0,
  hasStandardBrowserEnv: TE,
  hasStandardBrowserWebWorkerEnv: AE,
  navigator: b0,
  origin: _E
}, Symbol.toStringTag, { value: "Module" })), Be = {
  ...gE,
  ...bE
};
function CE(e, t) {
  return rn(e, new Be.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, a) {
      return Be.isNode && F.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function DE(e) {
  return F.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function SE(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let a;
  for (n = 0; n < s; n++)
    a = r[n], t[a] = e[a];
  return t;
}
function Cu(e) {
  function t(r, n, s, a) {
    let u = r[a++];
    if (u === "__proto__") return !0;
    const o = Number.isFinite(+u), f = a >= r.length;
    return u = !u && F.isArray(s) ? s.length : u, f ? (F.hasOwnProp(s, u) ? s[u] = [s[u], n] : s[u] = n, !o) : ((!s[u] || !F.isObject(s[u])) && (s[u] = []), t(r, n, s[u], a) && F.isArray(s[u]) && (s[u] = SE(s[u])), !o);
  }
  if (F.isFormData(e) && F.isFunction(e.entries)) {
    const r = {};
    return F.forEachEntry(e, (n, s) => {
      t(DE(n), s, r, 0);
    }), r;
  }
  return null;
}
function NE(e, t, r) {
  if (F.isString(e))
    try {
      return (t || JSON.parse)(e), F.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const pr = {
  transitional: gu,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, a = F.isObject(t);
    if (a && F.isHTMLForm(t) && (t = new FormData(t)), F.isFormData(t))
      return s ? JSON.stringify(Cu(t)) : t;
    if (F.isArrayBuffer(t) || F.isBuffer(t) || F.isStream(t) || F.isFile(t) || F.isBlob(t) || F.isReadableStream(t))
      return t;
    if (F.isArrayBufferView(t))
      return t.buffer;
    if (F.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let o;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return CE(t, this.formSerializer).toString();
      if ((o = F.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return rn(
          o ? { "files[]": t } : t,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return a || s ? (r.setContentType("application/json", !1), NE(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || pr.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (F.isResponse(t) || F.isReadableStream(t))
      return t;
    if (t && F.isString(t) && (n && !this.responseType || s)) {
      const u = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (o) {
        if (u)
          throw o.name === "SyntaxError" ? ne.from(o, ne.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Be.classes.FormData,
    Blob: Be.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
F.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  pr.headers[e] = {};
});
const IE = F.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vE = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(u) {
    s = u.indexOf(":"), r = u.substring(0, s).trim().toLowerCase(), n = u.substring(s + 1).trim(), !(!r || t[r] && IE[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Qs = Symbol("internals");
function jt(e) {
  return e && String(e).trim().toLowerCase();
}
function Nr(e) {
  return e === !1 || e == null ? e : F.isArray(e) ? e.map(Nr) : String(e);
}
function BE(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const OE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function bn(e, t, r, n, s) {
  if (F.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!F.isString(t)) {
    if (F.isString(n))
      return t.indexOf(n) !== -1;
    if (F.isRegExp(n))
      return n.test(t);
  }
}
function yE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function RE(e, t) {
  const r = F.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, a, u) {
        return this[n].call(this, t, s, a, u);
      },
      configurable: !0
    });
  });
}
class Pe {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function a(o, f, c) {
      const l = jt(f);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const x = F.findKey(s, l);
      (!x || s[x] === void 0 || c === !0 || c === void 0 && s[x] !== !1) && (s[x || f] = Nr(o));
    }
    const u = (o, f) => F.forEach(o, (c, l) => a(c, l, f));
    if (F.isPlainObject(t) || t instanceof this.constructor)
      u(t, r);
    else if (F.isString(t) && (t = t.trim()) && !OE(t))
      u(vE(t), r);
    else if (F.isHeaders(t))
      for (const [o, f] of t.entries())
        a(f, o, n);
    else
      t != null && a(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = jt(t), t) {
      const n = F.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return BE(s);
        if (F.isFunction(r))
          return r.call(this, s, n);
        if (F.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = jt(t), t) {
      const n = F.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || bn(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function a(u) {
      if (u = jt(u), u) {
        const o = F.findKey(n, u);
        o && (!r || bn(n, n[o], o, r)) && (delete n[o], s = !0);
      }
    }
    return F.isArray(t) ? t.forEach(a) : a(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const a = r[n];
      (!t || bn(this, this[a], a, t, !0)) && (delete this[a], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return F.forEach(this, (s, a) => {
      const u = F.findKey(n, a);
      if (u) {
        r[u] = Nr(s), delete r[a];
        return;
      }
      const o = t ? yE(a) : String(a).trim();
      o !== a && delete r[a], r[o] = Nr(s), n[o] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return F.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && F.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[Qs] = this[Qs] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function a(u) {
      const o = jt(u);
      n[o] || (RE(s, u), n[o] = !0);
    }
    return F.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
Pe.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
F.reduceDescriptors(Pe.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
F.freezeMethods(Pe);
function Tn(e, t) {
  const r = this || pr, n = t || r, s = Pe.from(n.headers);
  let a = n.data;
  return F.forEach(e, function(o) {
    a = o.call(r, a, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), a;
}
function Du(e) {
  return !!(e && e.__CANCEL__);
}
function $t(e, t, r) {
  ne.call(this, e ?? "canceled", ne.ERR_CANCELED, t, r), this.name = "CanceledError";
}
F.inherits($t, ne, {
  __CANCEL__: !0
});
function Su(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new ne(
    "Request failed with status code " + r.status,
    [ne.ERR_BAD_REQUEST, ne.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function LE(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function FE(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, a = 0, u;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const c = Date.now(), l = n[a];
    u || (u = c), r[s] = f, n[s] = c;
    let x = a, d = 0;
    for (; x !== s; )
      d += r[x++], x = x % e;
    if (s = (s + 1) % e, s === a && (a = (a + 1) % e), c - u < t)
      return;
    const p = l && c - l;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function PE(e, t) {
  let r = 0, n = 1e3 / t, s, a;
  const u = (c, l = Date.now()) => {
    r = l, s = null, a && (clearTimeout(a), a = null), e.apply(null, c);
  };
  return [(...c) => {
    const l = Date.now(), x = l - r;
    x >= n ? u(c, l) : (s = c, a || (a = setTimeout(() => {
      a = null, u(s);
    }, n - x)));
  }, () => s && u(s)];
}
const Hr = (e, t, r = 3) => {
  let n = 0;
  const s = FE(50, 250);
  return PE((a) => {
    const u = a.loaded, o = a.lengthComputable ? a.total : void 0, f = u - n, c = s(f), l = u <= o;
    n = u;
    const x = {
      loaded: u,
      total: o,
      progress: o ? u / o : void 0,
      bytes: f,
      rate: c || void 0,
      estimated: c && o && l ? (o - u) / c : void 0,
      event: a,
      lengthComputable: o != null,
      [t ? "download" : "upload"]: !0
    };
    e(x);
  }, r);
}, js = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Ks = (e) => (...t) => F.asap(() => e(...t)), kE = Be.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, Be.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(Be.origin),
  Be.navigator && /(msie|trident)/i.test(Be.navigator.userAgent)
) : () => !0, wE = Be.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, a) {
      const u = [e + "=" + encodeURIComponent(t)];
      F.isNumber(r) && u.push("expires=" + new Date(r).toGMTString()), F.isString(n) && u.push("path=" + n), F.isString(s) && u.push("domain=" + s), a === !0 && u.push("secure"), document.cookie = u.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ME(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function HE(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Nu(e, t) {
  return e && !ME(t) ? HE(e, t) : t;
}
const Xs = (e) => e instanceof Pe ? { ...e } : e;
function St(e, t) {
  t = t || {};
  const r = {};
  function n(c, l, x, d) {
    return F.isPlainObject(c) && F.isPlainObject(l) ? F.merge.call({ caseless: d }, c, l) : F.isPlainObject(l) ? F.merge({}, l) : F.isArray(l) ? l.slice() : l;
  }
  function s(c, l, x, d) {
    if (F.isUndefined(l)) {
      if (!F.isUndefined(c))
        return n(void 0, c, x, d);
    } else return n(c, l, x, d);
  }
  function a(c, l) {
    if (!F.isUndefined(l))
      return n(void 0, l);
  }
  function u(c, l) {
    if (F.isUndefined(l)) {
      if (!F.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, l);
  }
  function o(c, l, x) {
    if (x in t)
      return n(c, l);
    if (x in e)
      return n(void 0, c);
  }
  const f = {
    url: a,
    method: a,
    data: a,
    baseURL: u,
    transformRequest: u,
    transformResponse: u,
    paramsSerializer: u,
    timeout: u,
    timeoutMessage: u,
    withCredentials: u,
    withXSRFToken: u,
    adapter: u,
    responseType: u,
    xsrfCookieName: u,
    xsrfHeaderName: u,
    onUploadProgress: u,
    onDownloadProgress: u,
    decompress: u,
    maxContentLength: u,
    maxBodyLength: u,
    beforeRedirect: u,
    transport: u,
    httpAgent: u,
    httpsAgent: u,
    cancelToken: u,
    socketPath: u,
    responseEncoding: u,
    validateStatus: o,
    headers: (c, l, x) => s(Xs(c), Xs(l), x, !0)
  };
  return F.forEach(Object.keys(Object.assign({}, e, t)), function(l) {
    const x = f[l] || s, d = x(e[l], t[l], l);
    F.isUndefined(d) && x !== o || (r[l] = d);
  }), r;
}
const Iu = (e) => {
  const t = St({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: a, headers: u, auth: o } = t;
  t.headers = u = Pe.from(u), t.url = _u(Nu(t.baseURL, t.url), e.params, e.paramsSerializer), o && u.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let f;
  if (F.isFormData(r)) {
    if (Be.hasStandardBrowserEnv || Be.hasStandardBrowserWebWorkerEnv)
      u.setContentType(void 0);
    else if ((f = u.getContentType()) !== !1) {
      const [c, ...l] = f ? f.split(";").map((x) => x.trim()).filter(Boolean) : [];
      u.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (Be.hasStandardBrowserEnv && (n && F.isFunction(n) && (n = n(t)), n || n !== !1 && kE(t.url))) {
    const c = s && a && wE.read(a);
    c && u.set(s, c);
  }
  return t;
}, UE = typeof XMLHttpRequest < "u", qE = UE && function(e) {
  return new Promise(function(r, n) {
    const s = Iu(e);
    let a = s.data;
    const u = Pe.from(s.headers).normalize();
    let { responseType: o, onUploadProgress: f, onDownloadProgress: c } = s, l, x, d, p, h;
    function m() {
      p && p(), h && h(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let E = new XMLHttpRequest();
    E.open(s.method.toUpperCase(), s.url, !0), E.timeout = s.timeout;
    function D() {
      if (!E)
        return;
      const A = Pe.from(
        "getAllResponseHeaders" in E && E.getAllResponseHeaders()
      ), N = {
        data: !o || o === "text" || o === "json" ? E.responseText : E.response,
        status: E.status,
        statusText: E.statusText,
        headers: A,
        config: e,
        request: E
      };
      Su(function(B) {
        r(B), m();
      }, function(B) {
        n(B), m();
      }, N), E = null;
    }
    "onloadend" in E ? E.onloadend = D : E.onreadystatechange = function() {
      !E || E.readyState !== 4 || E.status === 0 && !(E.responseURL && E.responseURL.indexOf("file:") === 0) || setTimeout(D);
    }, E.onabort = function() {
      E && (n(new ne("Request aborted", ne.ECONNABORTED, e, E)), E = null);
    }, E.onerror = function() {
      n(new ne("Network Error", ne.ERR_NETWORK, e, E)), E = null;
    }, E.ontimeout = function() {
      let g = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const N = s.transitional || gu;
      s.timeoutErrorMessage && (g = s.timeoutErrorMessage), n(new ne(
        g,
        N.clarifyTimeoutError ? ne.ETIMEDOUT : ne.ECONNABORTED,
        e,
        E
      )), E = null;
    }, a === void 0 && u.setContentType(null), "setRequestHeader" in E && F.forEach(u.toJSON(), function(g, N) {
      E.setRequestHeader(N, g);
    }), F.isUndefined(s.withCredentials) || (E.withCredentials = !!s.withCredentials), o && o !== "json" && (E.responseType = s.responseType), c && ([d, h] = Hr(c, !0), E.addEventListener("progress", d)), f && E.upload && ([x, p] = Hr(f), E.upload.addEventListener("progress", x), E.upload.addEventListener("loadend", p)), (s.cancelToken || s.signal) && (l = (A) => {
      E && (n(!A || A.type ? new $t(null, e, E) : A), E.abort(), E = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const b = LE(s.url);
    if (b && Be.protocols.indexOf(b) === -1) {
      n(new ne("Unsupported protocol " + b + ":", ne.ERR_BAD_REQUEST, e));
      return;
    }
    E.send(a || null);
  });
}, YE = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), s;
    const a = function(c) {
      if (!s) {
        s = !0, o();
        const l = c instanceof Error ? c : this.reason;
        n.abort(l instanceof ne ? l : new $t(l instanceof Error ? l.message : l));
      }
    };
    let u = t && setTimeout(() => {
      u = null, a(new ne(`timeout ${t} of ms exceeded`, ne.ETIMEDOUT));
    }, t);
    const o = () => {
      e && (u && clearTimeout(u), u = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(a) : c.removeEventListener("abort", a);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", a));
    const { signal: f } = n;
    return f.unsubscribe = () => F.asap(o), f;
  }
}, $E = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, WE = async function* (e, t) {
  for await (const r of zE(e))
    yield* $E(r, t);
}, zE = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, Zs = (e, t, r, n) => {
  const s = WE(e, t);
  let a = 0, u, o = (f) => {
    u || (u = !0, n && n(f));
  };
  return new ReadableStream({
    async pull(f) {
      try {
        const { done: c, value: l } = await s.next();
        if (c) {
          o(), f.close();
          return;
        }
        let x = l.byteLength;
        if (r) {
          let d = a += x;
          r(d);
        }
        f.enqueue(new Uint8Array(l));
      } catch (c) {
        throw o(c), c;
      }
    },
    cancel(f) {
      return o(f), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, nn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", vu = nn && typeof ReadableStream == "function", GE = nn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Bu = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, VE = vu && Bu(() => {
  let e = !1;
  const t = new Request(Be.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Js = 64 * 1024, T0 = vu && Bu(() => F.isReadableStream(new Response("").body)), Ur = {
  stream: T0 && ((e) => e.body)
};
nn && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Ur[t] && (Ur[t] = F.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new ne(`Response type '${t}' is not supported`, ne.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const QE = async (e) => {
  if (e == null)
    return 0;
  if (F.isBlob(e))
    return e.size;
  if (F.isSpecCompliantForm(e))
    return (await new Request(Be.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (F.isArrayBufferView(e) || F.isArrayBuffer(e))
    return e.byteLength;
  if (F.isURLSearchParams(e) && (e = e + ""), F.isString(e))
    return (await GE(e)).byteLength;
}, jE = async (e, t) => {
  const r = F.toFiniteNumber(e.getContentLength());
  return r ?? QE(t);
}, KE = nn && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: s,
    cancelToken: a,
    timeout: u,
    onDownloadProgress: o,
    onUploadProgress: f,
    responseType: c,
    headers: l,
    withCredentials: x = "same-origin",
    fetchOptions: d
  } = Iu(e);
  c = c ? (c + "").toLowerCase() : "text";
  let p = YE([s, a && a.toAbortSignal()], u), h;
  const m = p && p.unsubscribe && (() => {
    p.unsubscribe();
  });
  let E;
  try {
    if (f && VE && r !== "get" && r !== "head" && (E = await jE(l, n)) !== 0) {
      let N = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), I;
      if (F.isFormData(n) && (I = N.headers.get("content-type")) && l.setContentType(I), N.body) {
        const [B, y] = js(
          E,
          Hr(Ks(f))
        );
        n = Zs(N.body, Js, B, y);
      }
    }
    F.isString(x) || (x = x ? "include" : "omit");
    const D = "credentials" in Request.prototype;
    h = new Request(t, {
      ...d,
      signal: p,
      method: r.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: D ? x : void 0
    });
    let b = await fetch(h);
    const A = T0 && (c === "stream" || c === "response");
    if (T0 && (o || A && m)) {
      const N = {};
      ["status", "statusText", "headers"].forEach((Y) => {
        N[Y] = b[Y];
      });
      const I = F.toFiniteNumber(b.headers.get("content-length")), [B, y] = o && js(
        I,
        Hr(Ks(o), !0)
      ) || [];
      b = new Response(
        Zs(b.body, Js, B, () => {
          y && y(), m && m();
        }),
        N
      );
    }
    c = c || "text";
    let g = await Ur[F.findKey(Ur, c) || "text"](b, e);
    return !A && m && m(), await new Promise((N, I) => {
      Su(N, I, {
        data: g,
        headers: Pe.from(b.headers),
        status: b.status,
        statusText: b.statusText,
        config: e,
        request: h
      });
    });
  } catch (D) {
    throw m && m(), D && D.name === "TypeError" && /fetch/i.test(D.message) ? Object.assign(
      new ne("Network Error", ne.ERR_NETWORK, e, h),
      {
        cause: D.cause || D
      }
    ) : ne.from(D, D && D.code, e, h);
  }
}), A0 = {
  http: fE,
  xhr: qE,
  fetch: KE
};
F.forEach(A0, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ea = (e) => `- ${e}`, XE = (e) => F.isFunction(e) || e === null || e === !1, Ou = {
  getAdapter: (e) => {
    e = F.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const s = {};
    for (let a = 0; a < t; a++) {
      r = e[a];
      let u;
      if (n = r, !XE(r) && (n = A0[(u = String(r)).toLowerCase()], n === void 0))
        throw new ne(`Unknown adapter '${u}'`);
      if (n)
        break;
      s[u || "#" + a] = n;
    }
    if (!n) {
      const a = Object.entries(s).map(
        ([o, f]) => `adapter ${o} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let u = t ? a.length > 1 ? `since :
` + a.map(ea).join(`
`) : " " + ea(a[0]) : "as no adapter specified";
      throw new ne(
        "There is no suitable adapter to dispatch the request " + u,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: A0
};
function An(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $t(null, e);
}
function ta(e) {
  return An(e), e.headers = Pe.from(e.headers), e.data = Tn.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ou.getAdapter(e.adapter || pr.adapter)(e).then(function(n) {
    return An(e), n.data = Tn.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Pe.from(n.headers), n;
  }, function(n) {
    return Du(n) || (An(e), n && n.response && (n.response.data = Tn.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Pe.from(n.response.headers))), Promise.reject(n);
  });
}
const yu = "1.7.8", sn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  sn[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ra = {};
sn.transitional = function(t, r, n) {
  function s(a, u) {
    return "[Axios v" + yu + "] Transitional option '" + a + "'" + u + (n ? ". " + n : "");
  }
  return (a, u, o) => {
    if (t === !1)
      throw new ne(
        s(u, " has been removed" + (r ? " in " + r : "")),
        ne.ERR_DEPRECATED
      );
    return r && !ra[u] && (ra[u] = !0, console.warn(
      s(
        u,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, u, o) : !0;
  };
};
sn.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function ZE(e, t, r) {
  if (typeof e != "object")
    throw new ne("options must be an object", ne.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const a = n[s], u = t[a];
    if (u) {
      const o = e[a], f = o === void 0 || u(o, a, e);
      if (f !== !0)
        throw new ne("option " + a + " must be " + f, ne.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new ne("Unknown option " + a, ne.ERR_BAD_OPTION);
  }
}
const Ir = {
  assertOptions: ZE,
  validators: sn
}, Ve = Ir.validators;
class _t {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Vs(),
      response: new Vs()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const a = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = St(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: a } = r;
    n !== void 0 && Ir.assertOptions(n, {
      silentJSONParsing: Ve.transitional(Ve.boolean),
      forcedJSONParsing: Ve.transitional(Ve.boolean),
      clarifyTimeoutError: Ve.transitional(Ve.boolean)
    }, !1), s != null && (F.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : Ir.assertOptions(s, {
      encode: Ve.function,
      serialize: Ve.function
    }, !0)), Ir.assertOptions(r, {
      baseUrl: Ve.spelling("baseURL"),
      withXsrfToken: Ve.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let u = a && F.merge(
      a.common,
      a[r.method]
    );
    a && F.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete a[h];
      }
    ), r.headers = Pe.concat(u, a);
    const o = [];
    let f = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(r) === !1 || (f = f && m.synchronous, o.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let l, x = 0, d;
    if (!f) {
      const h = [ta.bind(this), void 0];
      for (h.unshift.apply(h, o), h.push.apply(h, c), d = h.length, l = Promise.resolve(r); x < d; )
        l = l.then(h[x++], h[x++]);
      return l;
    }
    d = o.length;
    let p = r;
    for (x = 0; x < d; ) {
      const h = o[x++], m = o[x++];
      try {
        p = h(p);
      } catch (E) {
        m.call(this, E);
        break;
      }
    }
    try {
      l = ta.call(this, p);
    } catch (h) {
      return Promise.reject(h);
    }
    for (x = 0, d = c.length; x < d; )
      l = l.then(c[x++], c[x++]);
    return l;
  }
  getUri(t) {
    t = St(this.defaults, t);
    const r = Nu(t.baseURL, t.url);
    return _u(r, t.params, t.paramsSerializer);
  }
}
F.forEach(["delete", "get", "head", "options"], function(t) {
  _t.prototype[t] = function(r, n) {
    return this.request(St(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
F.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(a, u, o) {
      return this.request(St(o || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: u
      }));
    };
  }
  _t.prototype[t] = r(), _t.prototype[t + "Form"] = r(!0);
});
class K0 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners) return;
      let a = n._listeners.length;
      for (; a-- > 0; )
        n._listeners[a](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let a;
      const u = new Promise((o) => {
        n.subscribe(o), a = o;
      }).then(s);
      return u.cancel = function() {
        n.unsubscribe(a);
      }, u;
    }, t(function(a, u, o) {
      n.reason || (n.reason = new $t(a, u, o), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new K0(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
function JE(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function ex(e) {
  return F.isObject(e) && e.isAxiosError === !0;
}
const _0 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(_0).forEach(([e, t]) => {
  _0[t] = e;
});
function Ru(e) {
  const t = new _t(e), r = cu(_t.prototype.request, t);
  return F.extend(r, _t.prototype, t, { allOwnKeys: !0 }), F.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return Ru(St(e, s));
  }, r;
}
const me = Ru(pr);
me.Axios = _t;
me.CanceledError = $t;
me.CancelToken = K0;
me.isCancel = Du;
me.VERSION = yu;
me.toFormData = rn;
me.AxiosError = ne;
me.Cancel = me.CanceledError;
me.all = function(t) {
  return Promise.all(t);
};
me.spread = JE;
me.isAxiosError = ex;
me.mergeConfig = St;
me.AxiosHeaders = Pe;
me.formToJSON = (e) => Cu(F.isHTMLForm(e) ? new FormData(e) : e);
me.getAdapter = Ou.getAdapter;
me.HttpStatusCode = _0;
me.default = me;
var Lu = { exports: {} };
function tx(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var _n = { exports: {} };
const rx = {}, nx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rx
}, Symbol.toStringTag, { value: "Module" })), sx = /* @__PURE__ */ so(nx);
var na;
function ue() {
  return na || (na = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(re, function() {
      var r = r || function(n, s) {
        var a;
        if (typeof window < "u" && window.crypto && (a = window.crypto), typeof self < "u" && self.crypto && (a = self.crypto), typeof globalThis < "u" && globalThis.crypto && (a = globalThis.crypto), !a && typeof window < "u" && window.msCrypto && (a = window.msCrypto), !a && typeof re < "u" && re.crypto && (a = re.crypto), !a && typeof tx == "function")
          try {
            a = sx;
          } catch {
          }
        var u = function() {
          if (a) {
            if (typeof a.getRandomValues == "function")
              try {
                return a.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof a.randomBytes == "function")
              try {
                return a.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, o = Object.create || /* @__PURE__ */ function() {
          function b() {
          }
          return function(A) {
            var g;
            return b.prototype = A, g = new b(), b.prototype = null, g;
          };
        }(), f = {}, c = f.lib = {}, l = c.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(b) {
              var A = o(this);
              return b && A.mixIn(b), (!A.hasOwnProperty("init") || this.init === A.init) && (A.init = function() {
                A.$super.init.apply(this, arguments);
              }), A.init.prototype = A, A.$super = this, A;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var b = this.extend();
              return b.init.apply(b, arguments), b;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(b) {
              for (var A in b)
                b.hasOwnProperty(A) && (this[A] = b[A]);
              b.hasOwnProperty("toString") && (this.toString = b.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), x = c.WordArray = l.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(b, A) {
            b = this.words = b || [], A != s ? this.sigBytes = A : this.sigBytes = b.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(b) {
            return (b || p).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(b) {
            var A = this.words, g = b.words, N = this.sigBytes, I = b.sigBytes;
            if (this.clamp(), N % 4)
              for (var B = 0; B < I; B++) {
                var y = g[B >>> 2] >>> 24 - B % 4 * 8 & 255;
                A[N + B >>> 2] |= y << 24 - (N + B) % 4 * 8;
              }
            else
              for (var Y = 0; Y < I; Y += 4)
                A[N + Y >>> 2] = g[Y >>> 2];
            return this.sigBytes += I, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var b = this.words, A = this.sigBytes;
            b[A >>> 2] &= 4294967295 << 32 - A % 4 * 8, b.length = n.ceil(A / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var b = l.clone.call(this);
            return b.words = this.words.slice(0), b;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(b) {
            for (var A = [], g = 0; g < b; g += 4)
              A.push(u());
            return new x.init(A, b);
          }
        }), d = f.enc = {}, p = d.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(b) {
            for (var A = b.words, g = b.sigBytes, N = [], I = 0; I < g; I++) {
              var B = A[I >>> 2] >>> 24 - I % 4 * 8 & 255;
              N.push((B >>> 4).toString(16)), N.push((B & 15).toString(16));
            }
            return N.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(b) {
            for (var A = b.length, g = [], N = 0; N < A; N += 2)
              g[N >>> 3] |= parseInt(b.substr(N, 2), 16) << 24 - N % 8 * 4;
            return new x.init(g, A / 2);
          }
        }, h = d.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(b) {
            for (var A = b.words, g = b.sigBytes, N = [], I = 0; I < g; I++) {
              var B = A[I >>> 2] >>> 24 - I % 4 * 8 & 255;
              N.push(String.fromCharCode(B));
            }
            return N.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(b) {
            for (var A = b.length, g = [], N = 0; N < A; N++)
              g[N >>> 2] |= (b.charCodeAt(N) & 255) << 24 - N % 4 * 8;
            return new x.init(g, A);
          }
        }, m = d.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(b) {
            try {
              return decodeURIComponent(escape(h.stringify(b)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(b) {
            return h.parse(unescape(encodeURIComponent(b)));
          }
        }, E = c.BufferedBlockAlgorithm = l.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new x.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(b) {
            typeof b == "string" && (b = m.parse(b)), this._data.concat(b), this._nDataBytes += b.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(b) {
            var A, g = this._data, N = g.words, I = g.sigBytes, B = this.blockSize, y = B * 4, Y = I / y;
            b ? Y = n.ceil(Y) : Y = n.max((Y | 0) - this._minBufferSize, 0);
            var S = Y * B, v = n.min(S * 4, I);
            if (S) {
              for (var M = 0; M < S; M += B)
                this._doProcessBlock(N, M);
              A = N.splice(0, S), g.sigBytes -= v;
            }
            return new x.init(A, v);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var b = l.clone.call(this);
            return b._data = this._data.clone(), b;
          },
          _minBufferSize: 0
        });
        c.Hasher = E.extend({
          /**
           * Configuration options.
           */
          cfg: l.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(b) {
            this.cfg = this.cfg.extend(b), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            E.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(b) {
            return this._append(b), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(b) {
            b && this._append(b);
            var A = this._doFinalize();
            return A;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(b) {
            return function(A, g) {
              return new b.init(g).finalize(A);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(b) {
            return function(A, g) {
              return new D.HMAC.init(b, g).finalize(A);
            };
          }
        });
        var D = f.algo = {};
        return f;
      }(Math);
      return r;
    });
  }(_n)), _n.exports;
}
var gn = { exports: {} }, sa;
function an() {
  return sa || (sa = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function(n) {
        var s = r, a = s.lib, u = a.Base, o = a.WordArray, f = s.x64 = {};
        f.Word = u.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(c, l) {
            this.high = c, this.low = l;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), f.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(c, l) {
            c = this.words = c || [], l != n ? this.sigBytes = l : this.sigBytes = c.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var c = this.words, l = c.length, x = [], d = 0; d < l; d++) {
              var p = c[d];
              x.push(p.high), x.push(p.low);
            }
            return o.create(x, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var c = u.clone.call(this), l = c.words = this.words.slice(0), x = l.length, d = 0; d < x; d++)
              l[d] = l[d].clone();
            return c;
          }
        });
      }(), r;
    });
  }(gn)), gn.exports;
}
var Cn = { exports: {} }, aa;
function ax() {
  return aa || (aa = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var n = r, s = n.lib, a = s.WordArray, u = a.init, o = a.init = function(f) {
            if (f instanceof ArrayBuffer && (f = new Uint8Array(f)), (f instanceof Int8Array || typeof Uint8ClampedArray < "u" && f instanceof Uint8ClampedArray || f instanceof Int16Array || f instanceof Uint16Array || f instanceof Int32Array || f instanceof Uint32Array || f instanceof Float32Array || f instanceof Float64Array) && (f = new Uint8Array(f.buffer, f.byteOffset, f.byteLength)), f instanceof Uint8Array) {
              for (var c = f.byteLength, l = [], x = 0; x < c; x++)
                l[x >>> 2] |= f[x] << 24 - x % 4 * 8;
              u.call(this, l, c);
            } else
              u.apply(this, arguments);
          };
          o.prototype = a;
        }
      }(), r.lib.WordArray;
    });
  }(Cn)), Cn.exports;
}
var Dn = { exports: {} }, ia;
function ix() {
  return ia || (ia = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.WordArray, u = n.enc;
        u.Utf16 = u.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(f) {
            for (var c = f.words, l = f.sigBytes, x = [], d = 0; d < l; d += 2) {
              var p = c[d >>> 2] >>> 16 - d % 4 * 8 & 65535;
              x.push(String.fromCharCode(p));
            }
            return x.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(f) {
            for (var c = f.length, l = [], x = 0; x < c; x++)
              l[x >>> 1] |= f.charCodeAt(x) << 16 - x % 2 * 16;
            return a.create(l, c * 2);
          }
        }, u.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(f) {
            for (var c = f.words, l = f.sigBytes, x = [], d = 0; d < l; d += 2) {
              var p = o(c[d >>> 2] >>> 16 - d % 4 * 8 & 65535);
              x.push(String.fromCharCode(p));
            }
            return x.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(f) {
            for (var c = f.length, l = [], x = 0; x < c; x++)
              l[x >>> 1] |= o(f.charCodeAt(x) << 16 - x % 2 * 16);
            return a.create(l, c * 2);
          }
        };
        function o(f) {
          return f << 8 & 4278255360 | f >>> 8 & 16711935;
        }
      }(), r.enc.Utf16;
    });
  }(Dn)), Dn.exports;
}
var Sn = { exports: {} }, ua;
function Bt() {
  return ua || (ua = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.WordArray, u = n.enc;
        u.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(f) {
            var c = f.words, l = f.sigBytes, x = this._map;
            f.clamp();
            for (var d = [], p = 0; p < l; p += 3)
              for (var h = c[p >>> 2] >>> 24 - p % 4 * 8 & 255, m = c[p + 1 >>> 2] >>> 24 - (p + 1) % 4 * 8 & 255, E = c[p + 2 >>> 2] >>> 24 - (p + 2) % 4 * 8 & 255, D = h << 16 | m << 8 | E, b = 0; b < 4 && p + b * 0.75 < l; b++)
                d.push(x.charAt(D >>> 6 * (3 - b) & 63));
            var A = x.charAt(64);
            if (A)
              for (; d.length % 4; )
                d.push(A);
            return d.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(f) {
            var c = f.length, l = this._map, x = this._reverseMap;
            if (!x) {
              x = this._reverseMap = [];
              for (var d = 0; d < l.length; d++)
                x[l.charCodeAt(d)] = d;
            }
            var p = l.charAt(64);
            if (p) {
              var h = f.indexOf(p);
              h !== -1 && (c = h);
            }
            return o(f, c, x);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function o(f, c, l) {
          for (var x = [], d = 0, p = 0; p < c; p++)
            if (p % 4) {
              var h = l[f.charCodeAt(p - 1)] << p % 4 * 2, m = l[f.charCodeAt(p)] >>> 6 - p % 4 * 2, E = h | m;
              x[d >>> 2] |= E << 24 - d % 4 * 8, d++;
            }
          return a.create(x, d);
        }
      }(), r.enc.Base64;
    });
  }(Sn)), Sn.exports;
}
var Nn = { exports: {} }, oa;
function ux() {
  return oa || (oa = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.WordArray, u = n.enc;
        u.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(f, c) {
            c === void 0 && (c = !0);
            var l = f.words, x = f.sigBytes, d = c ? this._safe_map : this._map;
            f.clamp();
            for (var p = [], h = 0; h < x; h += 3)
              for (var m = l[h >>> 2] >>> 24 - h % 4 * 8 & 255, E = l[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, D = l[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, b = m << 16 | E << 8 | D, A = 0; A < 4 && h + A * 0.75 < x; A++)
                p.push(d.charAt(b >>> 6 * (3 - A) & 63));
            var g = d.charAt(64);
            if (g)
              for (; p.length % 4; )
                p.push(g);
            return p.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(f, c) {
            c === void 0 && (c = !0);
            var l = f.length, x = c ? this._safe_map : this._map, d = this._reverseMap;
            if (!d) {
              d = this._reverseMap = [];
              for (var p = 0; p < x.length; p++)
                d[x.charCodeAt(p)] = p;
            }
            var h = x.charAt(64);
            if (h) {
              var m = f.indexOf(h);
              m !== -1 && (l = m);
            }
            return o(f, l, d);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function o(f, c, l) {
          for (var x = [], d = 0, p = 0; p < c; p++)
            if (p % 4) {
              var h = l[f.charCodeAt(p - 1)] << p % 4 * 2, m = l[f.charCodeAt(p)] >>> 6 - p % 4 * 2, E = h | m;
              x[d >>> 2] |= E << 24 - d % 4 * 8, d++;
            }
          return a.create(x, d);
        }
      }(), r.enc.Base64url;
    });
  }(Nn)), Nn.exports;
}
var In = { exports: {} }, ca;
function Ot() {
  return ca || (ca = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function(n) {
        var s = r, a = s.lib, u = a.WordArray, o = a.Hasher, f = s.algo, c = [];
        (function() {
          for (var m = 0; m < 64; m++)
            c[m] = n.abs(n.sin(m + 1)) * 4294967296 | 0;
        })();
        var l = f.MD5 = o.extend({
          _doReset: function() {
            this._hash = new u.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(m, E) {
            for (var D = 0; D < 16; D++) {
              var b = E + D, A = m[b];
              m[b] = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360;
            }
            var g = this._hash.words, N = m[E + 0], I = m[E + 1], B = m[E + 2], y = m[E + 3], Y = m[E + 4], S = m[E + 5], v = m[E + 6], M = m[E + 7], U = m[E + 8], $ = m[E + 9], P = m[E + 10], w = m[E + 11], Q = m[E + 12], z = m[E + 13], j = m[E + 14], K = m[E + 15], R = g[0], k = g[1], q = g[2], H = g[3];
            R = x(R, k, q, H, N, 7, c[0]), H = x(H, R, k, q, I, 12, c[1]), q = x(q, H, R, k, B, 17, c[2]), k = x(k, q, H, R, y, 22, c[3]), R = x(R, k, q, H, Y, 7, c[4]), H = x(H, R, k, q, S, 12, c[5]), q = x(q, H, R, k, v, 17, c[6]), k = x(k, q, H, R, M, 22, c[7]), R = x(R, k, q, H, U, 7, c[8]), H = x(H, R, k, q, $, 12, c[9]), q = x(q, H, R, k, P, 17, c[10]), k = x(k, q, H, R, w, 22, c[11]), R = x(R, k, q, H, Q, 7, c[12]), H = x(H, R, k, q, z, 12, c[13]), q = x(q, H, R, k, j, 17, c[14]), k = x(k, q, H, R, K, 22, c[15]), R = d(R, k, q, H, I, 5, c[16]), H = d(H, R, k, q, v, 9, c[17]), q = d(q, H, R, k, w, 14, c[18]), k = d(k, q, H, R, N, 20, c[19]), R = d(R, k, q, H, S, 5, c[20]), H = d(H, R, k, q, P, 9, c[21]), q = d(q, H, R, k, K, 14, c[22]), k = d(k, q, H, R, Y, 20, c[23]), R = d(R, k, q, H, $, 5, c[24]), H = d(H, R, k, q, j, 9, c[25]), q = d(q, H, R, k, y, 14, c[26]), k = d(k, q, H, R, U, 20, c[27]), R = d(R, k, q, H, z, 5, c[28]), H = d(H, R, k, q, B, 9, c[29]), q = d(q, H, R, k, M, 14, c[30]), k = d(k, q, H, R, Q, 20, c[31]), R = p(R, k, q, H, S, 4, c[32]), H = p(H, R, k, q, U, 11, c[33]), q = p(q, H, R, k, w, 16, c[34]), k = p(k, q, H, R, j, 23, c[35]), R = p(R, k, q, H, I, 4, c[36]), H = p(H, R, k, q, Y, 11, c[37]), q = p(q, H, R, k, M, 16, c[38]), k = p(k, q, H, R, P, 23, c[39]), R = p(R, k, q, H, z, 4, c[40]), H = p(H, R, k, q, N, 11, c[41]), q = p(q, H, R, k, y, 16, c[42]), k = p(k, q, H, R, v, 23, c[43]), R = p(R, k, q, H, $, 4, c[44]), H = p(H, R, k, q, Q, 11, c[45]), q = p(q, H, R, k, K, 16, c[46]), k = p(k, q, H, R, B, 23, c[47]), R = h(R, k, q, H, N, 6, c[48]), H = h(H, R, k, q, M, 10, c[49]), q = h(q, H, R, k, j, 15, c[50]), k = h(k, q, H, R, S, 21, c[51]), R = h(R, k, q, H, Q, 6, c[52]), H = h(H, R, k, q, y, 10, c[53]), q = h(q, H, R, k, P, 15, c[54]), k = h(k, q, H, R, I, 21, c[55]), R = h(R, k, q, H, U, 6, c[56]), H = h(H, R, k, q, K, 10, c[57]), q = h(q, H, R, k, v, 15, c[58]), k = h(k, q, H, R, z, 21, c[59]), R = h(R, k, q, H, Y, 6, c[60]), H = h(H, R, k, q, w, 10, c[61]), q = h(q, H, R, k, B, 15, c[62]), k = h(k, q, H, R, $, 21, c[63]), g[0] = g[0] + R | 0, g[1] = g[1] + k | 0, g[2] = g[2] + q | 0, g[3] = g[3] + H | 0;
          },
          _doFinalize: function() {
            var m = this._data, E = m.words, D = this._nDataBytes * 8, b = m.sigBytes * 8;
            E[b >>> 5] |= 128 << 24 - b % 32;
            var A = n.floor(D / 4294967296), g = D;
            E[(b + 64 >>> 9 << 4) + 15] = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, E[(b + 64 >>> 9 << 4) + 14] = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, m.sigBytes = (E.length + 1) * 4, this._process();
            for (var N = this._hash, I = N.words, B = 0; B < 4; B++) {
              var y = I[B];
              I[B] = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360;
            }
            return N;
          },
          clone: function() {
            var m = o.clone.call(this);
            return m._hash = this._hash.clone(), m;
          }
        });
        function x(m, E, D, b, A, g, N) {
          var I = m + (E & D | ~E & b) + A + N;
          return (I << g | I >>> 32 - g) + E;
        }
        function d(m, E, D, b, A, g, N) {
          var I = m + (E & b | D & ~b) + A + N;
          return (I << g | I >>> 32 - g) + E;
        }
        function p(m, E, D, b, A, g, N) {
          var I = m + (E ^ D ^ b) + A + N;
          return (I << g | I >>> 32 - g) + E;
        }
        function h(m, E, D, b, A, g, N) {
          var I = m + (D ^ (E | ~b)) + A + N;
          return (I << g | I >>> 32 - g) + E;
        }
        s.MD5 = o._createHelper(l), s.HmacMD5 = o._createHmacHelper(l);
      }(Math), r.MD5;
    });
  }(In)), In.exports;
}
var vn = { exports: {} }, la;
function Fu() {
  return la || (la = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.WordArray, u = s.Hasher, o = n.algo, f = [], c = o.SHA1 = u.extend({
          _doReset: function() {
            this._hash = new a.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(l, x) {
            for (var d = this._hash.words, p = d[0], h = d[1], m = d[2], E = d[3], D = d[4], b = 0; b < 80; b++) {
              if (b < 16)
                f[b] = l[x + b] | 0;
              else {
                var A = f[b - 3] ^ f[b - 8] ^ f[b - 14] ^ f[b - 16];
                f[b] = A << 1 | A >>> 31;
              }
              var g = (p << 5 | p >>> 27) + D + f[b];
              b < 20 ? g += (h & m | ~h & E) + 1518500249 : b < 40 ? g += (h ^ m ^ E) + 1859775393 : b < 60 ? g += (h & m | h & E | m & E) - 1894007588 : g += (h ^ m ^ E) - 899497514, D = E, E = m, m = h << 30 | h >>> 2, h = p, p = g;
            }
            d[0] = d[0] + p | 0, d[1] = d[1] + h | 0, d[2] = d[2] + m | 0, d[3] = d[3] + E | 0, d[4] = d[4] + D | 0;
          },
          _doFinalize: function() {
            var l = this._data, x = l.words, d = this._nDataBytes * 8, p = l.sigBytes * 8;
            return x[p >>> 5] |= 128 << 24 - p % 32, x[(p + 64 >>> 9 << 4) + 14] = Math.floor(d / 4294967296), x[(p + 64 >>> 9 << 4) + 15] = d, l.sigBytes = x.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var l = u.clone.call(this);
            return l._hash = this._hash.clone(), l;
          }
        });
        n.SHA1 = u._createHelper(c), n.HmacSHA1 = u._createHmacHelper(c);
      }(), r.SHA1;
    });
  }(vn)), vn.exports;
}
var Bn = { exports: {} }, fa;
function X0() {
  return fa || (fa = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      return function(n) {
        var s = r, a = s.lib, u = a.WordArray, o = a.Hasher, f = s.algo, c = [], l = [];
        (function() {
          function p(D) {
            for (var b = n.sqrt(D), A = 2; A <= b; A++)
              if (!(D % A))
                return !1;
            return !0;
          }
          function h(D) {
            return (D - (D | 0)) * 4294967296 | 0;
          }
          for (var m = 2, E = 0; E < 64; )
            p(m) && (E < 8 && (c[E] = h(n.pow(m, 1 / 2))), l[E] = h(n.pow(m, 1 / 3)), E++), m++;
        })();
        var x = [], d = f.SHA256 = o.extend({
          _doReset: function() {
            this._hash = new u.init(c.slice(0));
          },
          _doProcessBlock: function(p, h) {
            for (var m = this._hash.words, E = m[0], D = m[1], b = m[2], A = m[3], g = m[4], N = m[5], I = m[6], B = m[7], y = 0; y < 64; y++) {
              if (y < 16)
                x[y] = p[h + y] | 0;
              else {
                var Y = x[y - 15], S = (Y << 25 | Y >>> 7) ^ (Y << 14 | Y >>> 18) ^ Y >>> 3, v = x[y - 2], M = (v << 15 | v >>> 17) ^ (v << 13 | v >>> 19) ^ v >>> 10;
                x[y] = S + x[y - 7] + M + x[y - 16];
              }
              var U = g & N ^ ~g & I, $ = E & D ^ E & b ^ D & b, P = (E << 30 | E >>> 2) ^ (E << 19 | E >>> 13) ^ (E << 10 | E >>> 22), w = (g << 26 | g >>> 6) ^ (g << 21 | g >>> 11) ^ (g << 7 | g >>> 25), Q = B + w + U + l[y] + x[y], z = P + $;
              B = I, I = N, N = g, g = A + Q | 0, A = b, b = D, D = E, E = Q + z | 0;
            }
            m[0] = m[0] + E | 0, m[1] = m[1] + D | 0, m[2] = m[2] + b | 0, m[3] = m[3] + A | 0, m[4] = m[4] + g | 0, m[5] = m[5] + N | 0, m[6] = m[6] + I | 0, m[7] = m[7] + B | 0;
          },
          _doFinalize: function() {
            var p = this._data, h = p.words, m = this._nDataBytes * 8, E = p.sigBytes * 8;
            return h[E >>> 5] |= 128 << 24 - E % 32, h[(E + 64 >>> 9 << 4) + 14] = n.floor(m / 4294967296), h[(E + 64 >>> 9 << 4) + 15] = m, p.sigBytes = h.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var p = o.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        s.SHA256 = o._createHelper(d), s.HmacSHA256 = o._createHmacHelper(d);
      }(Math), r.SHA256;
    });
  }(Bn)), Bn.exports;
}
var On = { exports: {} }, da;
function ox() {
  return da || (da = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), X0());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.WordArray, u = n.algo, o = u.SHA256, f = u.SHA224 = o.extend({
          _doReset: function() {
            this._hash = new a.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var c = o._doFinalize.call(this);
            return c.sigBytes -= 4, c;
          }
        });
        n.SHA224 = o._createHelper(f), n.HmacSHA224 = o._createHmacHelper(f);
      }(), r.SHA224;
    });
  }(On)), On.exports;
}
var yn = { exports: {} }, ha;
function Pu() {
  return ha || (ha = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), an());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.Hasher, u = n.x64, o = u.Word, f = u.WordArray, c = n.algo;
        function l() {
          return o.create.apply(o, arguments);
        }
        var x = [
          l(1116352408, 3609767458),
          l(1899447441, 602891725),
          l(3049323471, 3964484399),
          l(3921009573, 2173295548),
          l(961987163, 4081628472),
          l(1508970993, 3053834265),
          l(2453635748, 2937671579),
          l(2870763221, 3664609560),
          l(3624381080, 2734883394),
          l(310598401, 1164996542),
          l(607225278, 1323610764),
          l(1426881987, 3590304994),
          l(1925078388, 4068182383),
          l(2162078206, 991336113),
          l(2614888103, 633803317),
          l(3248222580, 3479774868),
          l(3835390401, 2666613458),
          l(4022224774, 944711139),
          l(264347078, 2341262773),
          l(604807628, 2007800933),
          l(770255983, 1495990901),
          l(1249150122, 1856431235),
          l(1555081692, 3175218132),
          l(1996064986, 2198950837),
          l(2554220882, 3999719339),
          l(2821834349, 766784016),
          l(2952996808, 2566594879),
          l(3210313671, 3203337956),
          l(3336571891, 1034457026),
          l(3584528711, 2466948901),
          l(113926993, 3758326383),
          l(338241895, 168717936),
          l(666307205, 1188179964),
          l(773529912, 1546045734),
          l(1294757372, 1522805485),
          l(1396182291, 2643833823),
          l(1695183700, 2343527390),
          l(1986661051, 1014477480),
          l(2177026350, 1206759142),
          l(2456956037, 344077627),
          l(2730485921, 1290863460),
          l(2820302411, 3158454273),
          l(3259730800, 3505952657),
          l(3345764771, 106217008),
          l(3516065817, 3606008344),
          l(3600352804, 1432725776),
          l(4094571909, 1467031594),
          l(275423344, 851169720),
          l(430227734, 3100823752),
          l(506948616, 1363258195),
          l(659060556, 3750685593),
          l(883997877, 3785050280),
          l(958139571, 3318307427),
          l(1322822218, 3812723403),
          l(1537002063, 2003034995),
          l(1747873779, 3602036899),
          l(1955562222, 1575990012),
          l(2024104815, 1125592928),
          l(2227730452, 2716904306),
          l(2361852424, 442776044),
          l(2428436474, 593698344),
          l(2756734187, 3733110249),
          l(3204031479, 2999351573),
          l(3329325298, 3815920427),
          l(3391569614, 3928383900),
          l(3515267271, 566280711),
          l(3940187606, 3454069534),
          l(4118630271, 4000239992),
          l(116418474, 1914138554),
          l(174292421, 2731055270),
          l(289380356, 3203993006),
          l(460393269, 320620315),
          l(685471733, 587496836),
          l(852142971, 1086792851),
          l(1017036298, 365543100),
          l(1126000580, 2618297676),
          l(1288033470, 3409855158),
          l(1501505948, 4234509866),
          l(1607167915, 987167468),
          l(1816402316, 1246189591)
        ], d = [];
        (function() {
          for (var h = 0; h < 80; h++)
            d[h] = l();
        })();
        var p = c.SHA512 = a.extend({
          _doReset: function() {
            this._hash = new f.init([
              new o.init(1779033703, 4089235720),
              new o.init(3144134277, 2227873595),
              new o.init(1013904242, 4271175723),
              new o.init(2773480762, 1595750129),
              new o.init(1359893119, 2917565137),
              new o.init(2600822924, 725511199),
              new o.init(528734635, 4215389547),
              new o.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(h, m) {
            for (var E = this._hash.words, D = E[0], b = E[1], A = E[2], g = E[3], N = E[4], I = E[5], B = E[6], y = E[7], Y = D.high, S = D.low, v = b.high, M = b.low, U = A.high, $ = A.low, P = g.high, w = g.low, Q = N.high, z = N.low, j = I.high, K = I.low, R = B.high, k = B.low, q = y.high, H = y.low, se = Y, ie = S, fe = v, te = M, Ne = U, de = $, Ie = P, ye = w, xe = Q, Te = z, Xe = j, Ze = K, nt = R, Je = k, xt = q, yt = H, We = 0; We < 80; We++) {
              var Ue, st, br = d[We];
              if (We < 16)
                st = br.high = h[m + We * 2] | 0, Ue = br.low = h[m + We * 2 + 1] | 0;
              else {
                var J0 = d[We - 15], Rt = J0.high, Wt = J0.low, wu = (Rt >>> 1 | Wt << 31) ^ (Rt >>> 8 | Wt << 24) ^ Rt >>> 7, es = (Wt >>> 1 | Rt << 31) ^ (Wt >>> 8 | Rt << 24) ^ (Wt >>> 7 | Rt << 25), ts = d[We - 2], Lt = ts.high, zt = ts.low, Mu = (Lt >>> 19 | zt << 13) ^ (Lt << 3 | zt >>> 29) ^ Lt >>> 6, rs = (zt >>> 19 | Lt << 13) ^ (zt << 3 | Lt >>> 29) ^ (zt >>> 6 | Lt << 26), ns = d[We - 7], Hu = ns.high, Uu = ns.low, ss = d[We - 16], qu = ss.high, as = ss.low;
                Ue = es + Uu, st = wu + Hu + (Ue >>> 0 < es >>> 0 ? 1 : 0), Ue = Ue + rs, st = st + Mu + (Ue >>> 0 < rs >>> 0 ? 1 : 0), Ue = Ue + as, st = st + qu + (Ue >>> 0 < as >>> 0 ? 1 : 0), br.high = st, br.low = Ue;
              }
              var Yu = xe & Xe ^ ~xe & nt, is = Te & Ze ^ ~Te & Je, $u = se & fe ^ se & Ne ^ fe & Ne, Wu = ie & te ^ ie & de ^ te & de, zu = (se >>> 28 | ie << 4) ^ (se << 30 | ie >>> 2) ^ (se << 25 | ie >>> 7), us = (ie >>> 28 | se << 4) ^ (ie << 30 | se >>> 2) ^ (ie << 25 | se >>> 7), Gu = (xe >>> 14 | Te << 18) ^ (xe >>> 18 | Te << 14) ^ (xe << 23 | Te >>> 9), Vu = (Te >>> 14 | xe << 18) ^ (Te >>> 18 | xe << 14) ^ (Te << 23 | xe >>> 9), os = x[We], Qu = os.high, cs = os.low, ke = yt + Vu, at = xt + Gu + (ke >>> 0 < yt >>> 0 ? 1 : 0), ke = ke + is, at = at + Yu + (ke >>> 0 < is >>> 0 ? 1 : 0), ke = ke + cs, at = at + Qu + (ke >>> 0 < cs >>> 0 ? 1 : 0), ke = ke + Ue, at = at + st + (ke >>> 0 < Ue >>> 0 ? 1 : 0), ls = us + Wu, ju = zu + $u + (ls >>> 0 < us >>> 0 ? 1 : 0);
              xt = nt, yt = Je, nt = Xe, Je = Ze, Xe = xe, Ze = Te, Te = ye + ke | 0, xe = Ie + at + (Te >>> 0 < ye >>> 0 ? 1 : 0) | 0, Ie = Ne, ye = de, Ne = fe, de = te, fe = se, te = ie, ie = ke + ls | 0, se = at + ju + (ie >>> 0 < ke >>> 0 ? 1 : 0) | 0;
            }
            S = D.low = S + ie, D.high = Y + se + (S >>> 0 < ie >>> 0 ? 1 : 0), M = b.low = M + te, b.high = v + fe + (M >>> 0 < te >>> 0 ? 1 : 0), $ = A.low = $ + de, A.high = U + Ne + ($ >>> 0 < de >>> 0 ? 1 : 0), w = g.low = w + ye, g.high = P + Ie + (w >>> 0 < ye >>> 0 ? 1 : 0), z = N.low = z + Te, N.high = Q + xe + (z >>> 0 < Te >>> 0 ? 1 : 0), K = I.low = K + Ze, I.high = j + Xe + (K >>> 0 < Ze >>> 0 ? 1 : 0), k = B.low = k + Je, B.high = R + nt + (k >>> 0 < Je >>> 0 ? 1 : 0), H = y.low = H + yt, y.high = q + xt + (H >>> 0 < yt >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var h = this._data, m = h.words, E = this._nDataBytes * 8, D = h.sigBytes * 8;
            m[D >>> 5] |= 128 << 24 - D % 32, m[(D + 128 >>> 10 << 5) + 30] = Math.floor(E / 4294967296), m[(D + 128 >>> 10 << 5) + 31] = E, h.sigBytes = m.length * 4, this._process();
            var b = this._hash.toX32();
            return b;
          },
          clone: function() {
            var h = a.clone.call(this);
            return h._hash = this._hash.clone(), h;
          },
          blockSize: 1024 / 32
        });
        n.SHA512 = a._createHelper(p), n.HmacSHA512 = a._createHmacHelper(p);
      }(), r.SHA512;
    });
  }(yn)), yn.exports;
}
var Rn = { exports: {} }, Ea;
function cx() {
  return Ea || (Ea = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), an(), Pu());
    })(re, function(r) {
      return function() {
        var n = r, s = n.x64, a = s.Word, u = s.WordArray, o = n.algo, f = o.SHA512, c = o.SHA384 = f.extend({
          _doReset: function() {
            this._hash = new u.init([
              new a.init(3418070365, 3238371032),
              new a.init(1654270250, 914150663),
              new a.init(2438529370, 812702999),
              new a.init(355462360, 4144912697),
              new a.init(1731405415, 4290775857),
              new a.init(2394180231, 1750603025),
              new a.init(3675008525, 1694076839),
              new a.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var l = f._doFinalize.call(this);
            return l.sigBytes -= 16, l;
          }
        });
        n.SHA384 = f._createHelper(c), n.HmacSHA384 = f._createHmacHelper(c);
      }(), r.SHA384;
    });
  }(Rn)), Rn.exports;
}
var Ln = { exports: {} }, xa;
function lx() {
  return xa || (xa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), an());
    })(re, function(r) {
      return function(n) {
        var s = r, a = s.lib, u = a.WordArray, o = a.Hasher, f = s.x64, c = f.Word, l = s.algo, x = [], d = [], p = [];
        (function() {
          for (var E = 1, D = 0, b = 0; b < 24; b++) {
            x[E + 5 * D] = (b + 1) * (b + 2) / 2 % 64;
            var A = D % 5, g = (2 * E + 3 * D) % 5;
            E = A, D = g;
          }
          for (var E = 0; E < 5; E++)
            for (var D = 0; D < 5; D++)
              d[E + 5 * D] = D + (2 * E + 3 * D) % 5 * 5;
          for (var N = 1, I = 0; I < 24; I++) {
            for (var B = 0, y = 0, Y = 0; Y < 7; Y++) {
              if (N & 1) {
                var S = (1 << Y) - 1;
                S < 32 ? y ^= 1 << S : B ^= 1 << S - 32;
              }
              N & 128 ? N = N << 1 ^ 113 : N <<= 1;
            }
            p[I] = c.create(B, y);
          }
        })();
        var h = [];
        (function() {
          for (var E = 0; E < 25; E++)
            h[E] = c.create();
        })();
        var m = l.SHA3 = o.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: o.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var E = this._state = [], D = 0; D < 25; D++)
              E[D] = new c.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(E, D) {
            for (var b = this._state, A = this.blockSize / 2, g = 0; g < A; g++) {
              var N = E[D + 2 * g], I = E[D + 2 * g + 1];
              N = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360, I = (I << 8 | I >>> 24) & 16711935 | (I << 24 | I >>> 8) & 4278255360;
              var B = b[g];
              B.high ^= I, B.low ^= N;
            }
            for (var y = 0; y < 24; y++) {
              for (var Y = 0; Y < 5; Y++) {
                for (var S = 0, v = 0, M = 0; M < 5; M++) {
                  var B = b[Y + 5 * M];
                  S ^= B.high, v ^= B.low;
                }
                var U = h[Y];
                U.high = S, U.low = v;
              }
              for (var Y = 0; Y < 5; Y++)
                for (var $ = h[(Y + 4) % 5], P = h[(Y + 1) % 5], w = P.high, Q = P.low, S = $.high ^ (w << 1 | Q >>> 31), v = $.low ^ (Q << 1 | w >>> 31), M = 0; M < 5; M++) {
                  var B = b[Y + 5 * M];
                  B.high ^= S, B.low ^= v;
                }
              for (var z = 1; z < 25; z++) {
                var S, v, B = b[z], j = B.high, K = B.low, R = x[z];
                R < 32 ? (S = j << R | K >>> 32 - R, v = K << R | j >>> 32 - R) : (S = K << R - 32 | j >>> 64 - R, v = j << R - 32 | K >>> 64 - R);
                var k = h[d[z]];
                k.high = S, k.low = v;
              }
              var q = h[0], H = b[0];
              q.high = H.high, q.low = H.low;
              for (var Y = 0; Y < 5; Y++)
                for (var M = 0; M < 5; M++) {
                  var z = Y + 5 * M, B = b[z], se = h[z], ie = h[(Y + 1) % 5 + 5 * M], fe = h[(Y + 2) % 5 + 5 * M];
                  B.high = se.high ^ ~ie.high & fe.high, B.low = se.low ^ ~ie.low & fe.low;
                }
              var B = b[0], te = p[y];
              B.high ^= te.high, B.low ^= te.low;
            }
          },
          _doFinalize: function() {
            var E = this._data, D = E.words;
            this._nDataBytes * 8;
            var b = E.sigBytes * 8, A = this.blockSize * 32;
            D[b >>> 5] |= 1 << 24 - b % 32, D[(n.ceil((b + 1) / A) * A >>> 5) - 1] |= 128, E.sigBytes = D.length * 4, this._process();
            for (var g = this._state, N = this.cfg.outputLength / 8, I = N / 8, B = [], y = 0; y < I; y++) {
              var Y = g[y], S = Y.high, v = Y.low;
              S = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, v = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360, B.push(v), B.push(S);
            }
            return new u.init(B, N);
          },
          clone: function() {
            for (var E = o.clone.call(this), D = E._state = this._state.slice(0), b = 0; b < 25; b++)
              D[b] = D[b].clone();
            return E;
          }
        });
        s.SHA3 = o._createHelper(m), s.HmacSHA3 = o._createHmacHelper(m);
      }(Math), r.SHA3;
    });
  }(Ln)), Ln.exports;
}
var Fn = { exports: {} }, ma;
function fx() {
  return ma || (ma = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(n) {
        var s = r, a = s.lib, u = a.WordArray, o = a.Hasher, f = s.algo, c = u.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), l = u.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), x = u.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), d = u.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), p = u.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), h = u.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), m = f.RIPEMD160 = o.extend({
          _doReset: function() {
            this._hash = u.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(I, B) {
            for (var y = 0; y < 16; y++) {
              var Y = B + y, S = I[Y];
              I[Y] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360;
            }
            var v = this._hash.words, M = p.words, U = h.words, $ = c.words, P = l.words, w = x.words, Q = d.words, z, j, K, R, k, q, H, se, ie, fe;
            q = z = v[0], H = j = v[1], se = K = v[2], ie = R = v[3], fe = k = v[4];
            for (var te, y = 0; y < 80; y += 1)
              te = z + I[B + $[y]] | 0, y < 16 ? te += E(j, K, R) + M[0] : y < 32 ? te += D(j, K, R) + M[1] : y < 48 ? te += b(j, K, R) + M[2] : y < 64 ? te += A(j, K, R) + M[3] : te += g(j, K, R) + M[4], te = te | 0, te = N(te, w[y]), te = te + k | 0, z = k, k = R, R = N(K, 10), K = j, j = te, te = q + I[B + P[y]] | 0, y < 16 ? te += g(H, se, ie) + U[0] : y < 32 ? te += A(H, se, ie) + U[1] : y < 48 ? te += b(H, se, ie) + U[2] : y < 64 ? te += D(H, se, ie) + U[3] : te += E(H, se, ie) + U[4], te = te | 0, te = N(te, Q[y]), te = te + fe | 0, q = fe, fe = ie, ie = N(se, 10), se = H, H = te;
            te = v[1] + K + ie | 0, v[1] = v[2] + R + fe | 0, v[2] = v[3] + k + q | 0, v[3] = v[4] + z + H | 0, v[4] = v[0] + j + se | 0, v[0] = te;
          },
          _doFinalize: function() {
            var I = this._data, B = I.words, y = this._nDataBytes * 8, Y = I.sigBytes * 8;
            B[Y >>> 5] |= 128 << 24 - Y % 32, B[(Y + 64 >>> 9 << 4) + 14] = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360, I.sigBytes = (B.length + 1) * 4, this._process();
            for (var S = this._hash, v = S.words, M = 0; M < 5; M++) {
              var U = v[M];
              v[M] = (U << 8 | U >>> 24) & 16711935 | (U << 24 | U >>> 8) & 4278255360;
            }
            return S;
          },
          clone: function() {
            var I = o.clone.call(this);
            return I._hash = this._hash.clone(), I;
          }
        });
        function E(I, B, y) {
          return I ^ B ^ y;
        }
        function D(I, B, y) {
          return I & B | ~I & y;
        }
        function b(I, B, y) {
          return (I | ~B) ^ y;
        }
        function A(I, B, y) {
          return I & y | B & ~y;
        }
        function g(I, B, y) {
          return I ^ (B | ~y);
        }
        function N(I, B) {
          return I << B | I >>> 32 - B;
        }
        s.RIPEMD160 = o._createHelper(m), s.HmacRIPEMD160 = o._createHmacHelper(m);
      }(), r.RIPEMD160;
    });
  }(Fn)), Fn.exports;
}
var Pn = { exports: {} }, pa;
function Z0() {
  return pa || (pa = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(ue());
    })(re, function(r) {
      (function() {
        var n = r, s = n.lib, a = s.Base, u = n.enc, o = u.Utf8, f = n.algo;
        f.HMAC = a.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(c, l) {
            c = this._hasher = new c.init(), typeof l == "string" && (l = o.parse(l));
            var x = c.blockSize, d = x * 4;
            l.sigBytes > d && (l = c.finalize(l)), l.clamp();
            for (var p = this._oKey = l.clone(), h = this._iKey = l.clone(), m = p.words, E = h.words, D = 0; D < x; D++)
              m[D] ^= 1549556828, E[D] ^= 909522486;
            p.sigBytes = h.sigBytes = d, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var c = this._hasher;
            c.reset(), c.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(c) {
            return this._hasher.update(c), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(c) {
            var l = this._hasher, x = l.finalize(c);
            l.reset();
            var d = l.finalize(this._oKey.clone().concat(x));
            return d;
          }
        });
      })();
    });
  }(Pn)), Pn.exports;
}
var kn = { exports: {} }, ba;
function dx() {
  return ba || (ba = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), X0(), Z0());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.Base, u = s.WordArray, o = n.algo, f = o.SHA256, c = o.HMAC, l = o.PBKDF2 = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: f,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(x) {
            this.cfg = this.cfg.extend(x);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(x, d) {
            for (var p = this.cfg, h = c.create(p.hasher, x), m = u.create(), E = u.create([1]), D = m.words, b = E.words, A = p.keySize, g = p.iterations; D.length < A; ) {
              var N = h.update(d).finalize(E);
              h.reset();
              for (var I = N.words, B = I.length, y = N, Y = 1; Y < g; Y++) {
                y = h.finalize(y), h.reset();
                for (var S = y.words, v = 0; v < B; v++)
                  I[v] ^= S[v];
              }
              m.concat(N), b[0]++;
            }
            return m.sigBytes = A * 4, m;
          }
        });
        n.PBKDF2 = function(x, d, p) {
          return l.create(p).compute(x, d);
        };
      }(), r.PBKDF2;
    });
  }(kn)), kn.exports;
}
var wn = { exports: {} }, Ta;
function Et() {
  return Ta || (Ta = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Fu(), Z0());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.Base, u = s.WordArray, o = n.algo, f = o.MD5, c = o.EvpKDF = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: f,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(l, x) {
            for (var d, p = this.cfg, h = p.hasher.create(), m = u.create(), E = m.words, D = p.keySize, b = p.iterations; E.length < D; ) {
              d && h.update(d), d = h.update(l).finalize(x), h.reset();
              for (var A = 1; A < b; A++)
                d = h.finalize(d), h.reset();
              m.concat(d);
            }
            return m.sigBytes = D * 4, m;
          }
        });
        n.EvpKDF = function(l, x, d) {
          return c.create(d).compute(l, x);
        };
      }(), r.EvpKDF;
    });
  }(wn)), wn.exports;
}
var Mn = { exports: {} }, Aa;
function Ce() {
  return Aa || (Aa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Et());
    })(re, function(r) {
      r.lib.Cipher || function(n) {
        var s = r, a = s.lib, u = a.Base, o = a.WordArray, f = a.BufferedBlockAlgorithm, c = s.enc;
        c.Utf8;
        var l = c.Base64, x = s.algo, d = x.EvpKDF, p = a.Cipher = f.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: u.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(S, v) {
            return this.create(this._ENC_XFORM_MODE, S, v);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(S, v) {
            return this.create(this._DEC_XFORM_MODE, S, v);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(S, v, M) {
            this.cfg = this.cfg.extend(M), this._xformMode = S, this._key = v, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            f.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(S) {
            return this._append(S), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(S) {
            S && this._append(S);
            var v = this._doFinalize();
            return v;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: /* @__PURE__ */ function() {
            function S(v) {
              return typeof v == "string" ? Y : I;
            }
            return function(v) {
              return {
                encrypt: function(M, U, $) {
                  return S(U).encrypt(v, M, U, $);
                },
                decrypt: function(M, U, $) {
                  return S(U).decrypt(v, M, U, $);
                }
              };
            };
          }()
        });
        a.StreamCipher = p.extend({
          _doFinalize: function() {
            var S = this._process(!0);
            return S;
          },
          blockSize: 1
        });
        var h = s.mode = {}, m = a.BlockCipherMode = u.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(S, v) {
            return this.Encryptor.create(S, v);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(S, v) {
            return this.Decryptor.create(S, v);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(S, v) {
            this._cipher = S, this._iv = v;
          }
        }), E = h.CBC = function() {
          var S = m.extend();
          S.Encryptor = S.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(M, U) {
              var $ = this._cipher, P = $.blockSize;
              v.call(this, M, U, P), $.encryptBlock(M, U), this._prevBlock = M.slice(U, U + P);
            }
          }), S.Decryptor = S.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(M, U) {
              var $ = this._cipher, P = $.blockSize, w = M.slice(U, U + P);
              $.decryptBlock(M, U), v.call(this, M, U, P), this._prevBlock = w;
            }
          });
          function v(M, U, $) {
            var P, w = this._iv;
            w ? (P = w, this._iv = n) : P = this._prevBlock;
            for (var Q = 0; Q < $; Q++)
              M[U + Q] ^= P[Q];
          }
          return S;
        }(), D = s.pad = {}, b = D.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(S, v) {
            for (var M = v * 4, U = M - S.sigBytes % M, $ = U << 24 | U << 16 | U << 8 | U, P = [], w = 0; w < U; w += 4)
              P.push($);
            var Q = o.create(P, U);
            S.concat(Q);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(S) {
            var v = S.words[S.sigBytes - 1 >>> 2] & 255;
            S.sigBytes -= v;
          }
        };
        a.BlockCipher = p.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: p.cfg.extend({
            mode: E,
            padding: b
          }),
          reset: function() {
            var S;
            p.reset.call(this);
            var v = this.cfg, M = v.iv, U = v.mode;
            this._xformMode == this._ENC_XFORM_MODE ? S = U.createEncryptor : (S = U.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == S ? this._mode.init(this, M && M.words) : (this._mode = S.call(U, this, M && M.words), this._mode.__creator = S);
          },
          _doProcessBlock: function(S, v) {
            this._mode.processBlock(S, v);
          },
          _doFinalize: function() {
            var S, v = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (v.pad(this._data, this.blockSize), S = this._process(!0)) : (S = this._process(!0), v.unpad(S)), S;
          },
          blockSize: 128 / 32
        });
        var A = a.CipherParams = u.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(S) {
            this.mixIn(S);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(S) {
            return (S || this.formatter).stringify(this);
          }
        }), g = s.format = {}, N = g.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(S) {
            var v, M = S.ciphertext, U = S.salt;
            return U ? v = o.create([1398893684, 1701076831]).concat(U).concat(M) : v = M, v.toString(l);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(S) {
            var v, M = l.parse(S), U = M.words;
            return U[0] == 1398893684 && U[1] == 1701076831 && (v = o.create(U.slice(2, 4)), U.splice(0, 4), M.sigBytes -= 16), A.create({ ciphertext: M, salt: v });
          }
        }, I = a.SerializableCipher = u.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: u.extend({
            format: N
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(S, v, M, U) {
            U = this.cfg.extend(U);
            var $ = S.createEncryptor(M, U), P = $.finalize(v), w = $.cfg;
            return A.create({
              ciphertext: P,
              key: M,
              iv: w.iv,
              algorithm: S,
              mode: w.mode,
              padding: w.padding,
              blockSize: S.blockSize,
              formatter: U.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(S, v, M, U) {
            U = this.cfg.extend(U), v = this._parse(v, U.format);
            var $ = S.createDecryptor(M, U).finalize(v.ciphertext);
            return $;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(S, v) {
            return typeof S == "string" ? v.parse(S, this) : S;
          }
        }), B = s.kdf = {}, y = B.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(S, v, M, U, $) {
            if (U || (U = o.random(64 / 8)), $)
              var P = d.create({ keySize: v + M, hasher: $ }).compute(S, U);
            else
              var P = d.create({ keySize: v + M }).compute(S, U);
            var w = o.create(P.words.slice(v), M * 4);
            return P.sigBytes = v * 4, A.create({ key: P, iv: w, salt: U });
          }
        }, Y = a.PasswordBasedCipher = I.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: I.cfg.extend({
            kdf: y
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(S, v, M, U) {
            U = this.cfg.extend(U);
            var $ = U.kdf.execute(M, S.keySize, S.ivSize, U.salt, U.hasher);
            U.iv = $.iv;
            var P = I.encrypt.call(this, S, v, $.key, U);
            return P.mixIn($), P;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(S, v, M, U) {
            U = this.cfg.extend(U), v = this._parse(v, U.format);
            var $ = U.kdf.execute(M, S.keySize, S.ivSize, v.salt, U.hasher);
            U.iv = $.iv;
            var P = I.decrypt.call(this, S, v, $.key, U);
            return P;
          }
        });
      }();
    });
  }(Mn)), Mn.exports;
}
var Hn = { exports: {} }, _a;
function hx() {
  return _a || (_a = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.mode.CFB = function() {
        var n = r.lib.BlockCipherMode.extend();
        n.Encryptor = n.extend({
          processBlock: function(a, u) {
            var o = this._cipher, f = o.blockSize;
            s.call(this, a, u, f, o), this._prevBlock = a.slice(u, u + f);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(a, u) {
            var o = this._cipher, f = o.blockSize, c = a.slice(u, u + f);
            s.call(this, a, u, f, o), this._prevBlock = c;
          }
        });
        function s(a, u, o, f) {
          var c, l = this._iv;
          l ? (c = l.slice(0), this._iv = void 0) : c = this._prevBlock, f.encryptBlock(c, 0);
          for (var x = 0; x < o; x++)
            a[u + x] ^= c[x];
        }
        return n;
      }(), r.mode.CFB;
    });
  }(Hn)), Hn.exports;
}
var Un = { exports: {} }, ga;
function Ex() {
  return ga || (ga = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.mode.CTR = function() {
        var n = r.lib.BlockCipherMode.extend(), s = n.Encryptor = n.extend({
          processBlock: function(a, u) {
            var o = this._cipher, f = o.blockSize, c = this._iv, l = this._counter;
            c && (l = this._counter = c.slice(0), this._iv = void 0);
            var x = l.slice(0);
            o.encryptBlock(x, 0), l[f - 1] = l[f - 1] + 1 | 0;
            for (var d = 0; d < f; d++)
              a[u + d] ^= x[d];
          }
        });
        return n.Decryptor = s, n;
      }(), r.mode.CTR;
    });
  }(Un)), Un.exports;
}
var qn = { exports: {} }, Ca;
function xx() {
  return Ca || (Ca = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return r.mode.CTRGladman = function() {
        var n = r.lib.BlockCipherMode.extend();
        function s(o) {
          if ((o >> 24 & 255) === 255) {
            var f = o >> 16 & 255, c = o >> 8 & 255, l = o & 255;
            f === 255 ? (f = 0, c === 255 ? (c = 0, l === 255 ? l = 0 : ++l) : ++c) : ++f, o = 0, o += f << 16, o += c << 8, o += l;
          } else
            o += 1 << 24;
          return o;
        }
        function a(o) {
          return (o[0] = s(o[0])) === 0 && (o[1] = s(o[1])), o;
        }
        var u = n.Encryptor = n.extend({
          processBlock: function(o, f) {
            var c = this._cipher, l = c.blockSize, x = this._iv, d = this._counter;
            x && (d = this._counter = x.slice(0), this._iv = void 0), a(d);
            var p = d.slice(0);
            c.encryptBlock(p, 0);
            for (var h = 0; h < l; h++)
              o[f + h] ^= p[h];
          }
        });
        return n.Decryptor = u, n;
      }(), r.mode.CTRGladman;
    });
  }(qn)), qn.exports;
}
var Yn = { exports: {} }, Da;
function mx() {
  return Da || (Da = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.mode.OFB = function() {
        var n = r.lib.BlockCipherMode.extend(), s = n.Encryptor = n.extend({
          processBlock: function(a, u) {
            var o = this._cipher, f = o.blockSize, c = this._iv, l = this._keystream;
            c && (l = this._keystream = c.slice(0), this._iv = void 0), o.encryptBlock(l, 0);
            for (var x = 0; x < f; x++)
              a[u + x] ^= l[x];
          }
        });
        return n.Decryptor = s, n;
      }(), r.mode.OFB;
    });
  }(Yn)), Yn.exports;
}
var $n = { exports: {} }, Sa;
function px() {
  return Sa || (Sa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.mode.ECB = function() {
        var n = r.lib.BlockCipherMode.extend();
        return n.Encryptor = n.extend({
          processBlock: function(s, a) {
            this._cipher.encryptBlock(s, a);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(s, a) {
            this._cipher.decryptBlock(s, a);
          }
        }), n;
      }(), r.mode.ECB;
    });
  }($n)), $n.exports;
}
var Wn = { exports: {} }, Na;
function bx() {
  return Na || (Na = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.pad.AnsiX923 = {
        pad: function(n, s) {
          var a = n.sigBytes, u = s * 4, o = u - a % u, f = a + o - 1;
          n.clamp(), n.words[f >>> 2] |= o << 24 - f % 4 * 8, n.sigBytes += o;
        },
        unpad: function(n) {
          var s = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= s;
        }
      }, r.pad.Ansix923;
    });
  }(Wn)), Wn.exports;
}
var zn = { exports: {} }, Ia;
function Tx() {
  return Ia || (Ia = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.pad.Iso10126 = {
        pad: function(n, s) {
          var a = s * 4, u = a - n.sigBytes % a;
          n.concat(r.lib.WordArray.random(u - 1)).concat(r.lib.WordArray.create([u << 24], 1));
        },
        unpad: function(n) {
          var s = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= s;
        }
      }, r.pad.Iso10126;
    });
  }(zn)), zn.exports;
}
var Gn = { exports: {} }, va;
function Ax() {
  return va || (va = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.pad.Iso97971 = {
        pad: function(n, s) {
          n.concat(r.lib.WordArray.create([2147483648], 1)), r.pad.ZeroPadding.pad(n, s);
        },
        unpad: function(n) {
          r.pad.ZeroPadding.unpad(n), n.sigBytes--;
        }
      }, r.pad.Iso97971;
    });
  }(Gn)), Gn.exports;
}
var Vn = { exports: {} }, Ba;
function _x() {
  return Ba || (Ba = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.pad.ZeroPadding = {
        pad: function(n, s) {
          var a = s * 4;
          n.clamp(), n.sigBytes += a - (n.sigBytes % a || a);
        },
        unpad: function(n) {
          for (var s = n.words, a = n.sigBytes - 1, a = n.sigBytes - 1; a >= 0; a--)
            if (s[a >>> 2] >>> 24 - a % 4 * 8 & 255) {
              n.sigBytes = a + 1;
              break;
            }
        }
      }, r.pad.ZeroPadding;
    });
  }(Vn)), Vn.exports;
}
var Qn = { exports: {} }, Oa;
function gx() {
  return Oa || (Oa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return r.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, r.pad.NoPadding;
    });
  }(Qn)), Qn.exports;
}
var jn = { exports: {} }, ya;
function Cx() {
  return ya || (ya = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Ce());
    })(re, function(r) {
      return function(n) {
        var s = r, a = s.lib, u = a.CipherParams, o = s.enc, f = o.Hex, c = s.format;
        c.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(l) {
            return l.ciphertext.toString(f);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(l) {
            var x = f.parse(l);
            return u.create({ ciphertext: x });
          }
        };
      }(), r.format.Hex;
    });
  }(jn)), jn.exports;
}
var Kn = { exports: {} }, Ra;
function Dx() {
  return Ra || (Ra = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Bt(), Ot(), Et(), Ce());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.BlockCipher, u = n.algo, o = [], f = [], c = [], l = [], x = [], d = [], p = [], h = [], m = [], E = [];
        (function() {
          for (var A = [], g = 0; g < 256; g++)
            g < 128 ? A[g] = g << 1 : A[g] = g << 1 ^ 283;
          for (var N = 0, I = 0, g = 0; g < 256; g++) {
            var B = I ^ I << 1 ^ I << 2 ^ I << 3 ^ I << 4;
            B = B >>> 8 ^ B & 255 ^ 99, o[N] = B, f[B] = N;
            var y = A[N], Y = A[y], S = A[Y], v = A[B] * 257 ^ B * 16843008;
            c[N] = v << 24 | v >>> 8, l[N] = v << 16 | v >>> 16, x[N] = v << 8 | v >>> 24, d[N] = v;
            var v = S * 16843009 ^ Y * 65537 ^ y * 257 ^ N * 16843008;
            p[B] = v << 24 | v >>> 8, h[B] = v << 16 | v >>> 16, m[B] = v << 8 | v >>> 24, E[B] = v, N ? (N = y ^ A[A[A[S ^ y]]], I ^= A[A[I]]) : N = I = 1;
          }
        })();
        var D = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], b = u.AES = a.extend({
          _doReset: function() {
            var A;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var g = this._keyPriorReset = this._key, N = g.words, I = g.sigBytes / 4, B = this._nRounds = I + 6, y = (B + 1) * 4, Y = this._keySchedule = [], S = 0; S < y; S++)
                S < I ? Y[S] = N[S] : (A = Y[S - 1], S % I ? I > 6 && S % I == 4 && (A = o[A >>> 24] << 24 | o[A >>> 16 & 255] << 16 | o[A >>> 8 & 255] << 8 | o[A & 255]) : (A = A << 8 | A >>> 24, A = o[A >>> 24] << 24 | o[A >>> 16 & 255] << 16 | o[A >>> 8 & 255] << 8 | o[A & 255], A ^= D[S / I | 0] << 24), Y[S] = Y[S - I] ^ A);
              for (var v = this._invKeySchedule = [], M = 0; M < y; M++) {
                var S = y - M;
                if (M % 4)
                  var A = Y[S];
                else
                  var A = Y[S - 4];
                M < 4 || S <= 4 ? v[M] = A : v[M] = p[o[A >>> 24]] ^ h[o[A >>> 16 & 255]] ^ m[o[A >>> 8 & 255]] ^ E[o[A & 255]];
              }
            }
          },
          encryptBlock: function(A, g) {
            this._doCryptBlock(A, g, this._keySchedule, c, l, x, d, o);
          },
          decryptBlock: function(A, g) {
            var N = A[g + 1];
            A[g + 1] = A[g + 3], A[g + 3] = N, this._doCryptBlock(A, g, this._invKeySchedule, p, h, m, E, f);
            var N = A[g + 1];
            A[g + 1] = A[g + 3], A[g + 3] = N;
          },
          _doCryptBlock: function(A, g, N, I, B, y, Y, S) {
            for (var v = this._nRounds, M = A[g] ^ N[0], U = A[g + 1] ^ N[1], $ = A[g + 2] ^ N[2], P = A[g + 3] ^ N[3], w = 4, Q = 1; Q < v; Q++) {
              var z = I[M >>> 24] ^ B[U >>> 16 & 255] ^ y[$ >>> 8 & 255] ^ Y[P & 255] ^ N[w++], j = I[U >>> 24] ^ B[$ >>> 16 & 255] ^ y[P >>> 8 & 255] ^ Y[M & 255] ^ N[w++], K = I[$ >>> 24] ^ B[P >>> 16 & 255] ^ y[M >>> 8 & 255] ^ Y[U & 255] ^ N[w++], R = I[P >>> 24] ^ B[M >>> 16 & 255] ^ y[U >>> 8 & 255] ^ Y[$ & 255] ^ N[w++];
              M = z, U = j, $ = K, P = R;
            }
            var z = (S[M >>> 24] << 24 | S[U >>> 16 & 255] << 16 | S[$ >>> 8 & 255] << 8 | S[P & 255]) ^ N[w++], j = (S[U >>> 24] << 24 | S[$ >>> 16 & 255] << 16 | S[P >>> 8 & 255] << 8 | S[M & 255]) ^ N[w++], K = (S[$ >>> 24] << 24 | S[P >>> 16 & 255] << 16 | S[M >>> 8 & 255] << 8 | S[U & 255]) ^ N[w++], R = (S[P >>> 24] << 24 | S[M >>> 16 & 255] << 16 | S[U >>> 8 & 255] << 8 | S[$ & 255]) ^ N[w++];
            A[g] = z, A[g + 1] = j, A[g + 2] = K, A[g + 3] = R;
          },
          keySize: 256 / 32
        });
        n.AES = a._createHelper(b);
      }(), r.AES;
    });
  }(Kn)), Kn.exports;
}
var Xn = { exports: {} }, La;
function Sx() {
  return La || (La = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Bt(), Ot(), Et(), Ce());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.WordArray, u = s.BlockCipher, o = n.algo, f = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], c = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], l = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], x = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], d = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], p = o.DES = u.extend({
          _doReset: function() {
            for (var D = this._key, b = D.words, A = [], g = 0; g < 56; g++) {
              var N = f[g] - 1;
              A[g] = b[N >>> 5] >>> 31 - N % 32 & 1;
            }
            for (var I = this._subKeys = [], B = 0; B < 16; B++) {
              for (var y = I[B] = [], Y = l[B], g = 0; g < 24; g++)
                y[g / 6 | 0] |= A[(c[g] - 1 + Y) % 28] << 31 - g % 6, y[4 + (g / 6 | 0)] |= A[28 + (c[g + 24] - 1 + Y) % 28] << 31 - g % 6;
              y[0] = y[0] << 1 | y[0] >>> 31;
              for (var g = 1; g < 7; g++)
                y[g] = y[g] >>> (g - 1) * 4 + 3;
              y[7] = y[7] << 5 | y[7] >>> 27;
            }
            for (var S = this._invSubKeys = [], g = 0; g < 16; g++)
              S[g] = I[15 - g];
          },
          encryptBlock: function(D, b) {
            this._doCryptBlock(D, b, this._subKeys);
          },
          decryptBlock: function(D, b) {
            this._doCryptBlock(D, b, this._invSubKeys);
          },
          _doCryptBlock: function(D, b, A) {
            this._lBlock = D[b], this._rBlock = D[b + 1], h.call(this, 4, 252645135), h.call(this, 16, 65535), m.call(this, 2, 858993459), m.call(this, 8, 16711935), h.call(this, 1, 1431655765);
            for (var g = 0; g < 16; g++) {
              for (var N = A[g], I = this._lBlock, B = this._rBlock, y = 0, Y = 0; Y < 8; Y++)
                y |= x[Y][((B ^ N[Y]) & d[Y]) >>> 0];
              this._lBlock = B, this._rBlock = I ^ y;
            }
            var S = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = S, h.call(this, 1, 1431655765), m.call(this, 8, 16711935), m.call(this, 2, 858993459), h.call(this, 16, 65535), h.call(this, 4, 252645135), D[b] = this._lBlock, D[b + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function h(D, b) {
          var A = (this._lBlock >>> D ^ this._rBlock) & b;
          this._rBlock ^= A, this._lBlock ^= A << D;
        }
        function m(D, b) {
          var A = (this._rBlock >>> D ^ this._lBlock) & b;
          this._lBlock ^= A, this._rBlock ^= A << D;
        }
        n.DES = u._createHelper(p);
        var E = o.TripleDES = u.extend({
          _doReset: function() {
            var D = this._key, b = D.words;
            if (b.length !== 2 && b.length !== 4 && b.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var A = b.slice(0, 2), g = b.length < 4 ? b.slice(0, 2) : b.slice(2, 4), N = b.length < 6 ? b.slice(0, 2) : b.slice(4, 6);
            this._des1 = p.createEncryptor(a.create(A)), this._des2 = p.createEncryptor(a.create(g)), this._des3 = p.createEncryptor(a.create(N));
          },
          encryptBlock: function(D, b) {
            this._des1.encryptBlock(D, b), this._des2.decryptBlock(D, b), this._des3.encryptBlock(D, b);
          },
          decryptBlock: function(D, b) {
            this._des3.decryptBlock(D, b), this._des2.encryptBlock(D, b), this._des1.decryptBlock(D, b);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        n.TripleDES = u._createHelper(E);
      }(), r.TripleDES;
    });
  }(Xn)), Xn.exports;
}
var Zn = { exports: {} }, Fa;
function Nx() {
  return Fa || (Fa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Bt(), Ot(), Et(), Ce());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.StreamCipher, u = n.algo, o = u.RC4 = a.extend({
          _doReset: function() {
            for (var l = this._key, x = l.words, d = l.sigBytes, p = this._S = [], h = 0; h < 256; h++)
              p[h] = h;
            for (var h = 0, m = 0; h < 256; h++) {
              var E = h % d, D = x[E >>> 2] >>> 24 - E % 4 * 8 & 255;
              m = (m + p[h] + D) % 256;
              var b = p[h];
              p[h] = p[m], p[m] = b;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(l, x) {
            l[x] ^= f.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function f() {
          for (var l = this._S, x = this._i, d = this._j, p = 0, h = 0; h < 4; h++) {
            x = (x + 1) % 256, d = (d + l[x]) % 256;
            var m = l[x];
            l[x] = l[d], l[d] = m, p |= l[(l[x] + l[d]) % 256] << 24 - h * 8;
          }
          return this._i = x, this._j = d, p;
        }
        n.RC4 = a._createHelper(o);
        var c = u.RC4Drop = o.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: o.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            o._doReset.call(this);
            for (var l = this.cfg.drop; l > 0; l--)
              f.call(this);
          }
        });
        n.RC4Drop = a._createHelper(c);
      }(), r.RC4;
    });
  }(Zn)), Zn.exports;
}
var Jn = { exports: {} }, Pa;
function Ix() {
  return Pa || (Pa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Bt(), Ot(), Et(), Ce());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.StreamCipher, u = n.algo, o = [], f = [], c = [], l = u.Rabbit = a.extend({
          _doReset: function() {
            for (var d = this._key.words, p = this.cfg.iv, h = 0; h < 4; h++)
              d[h] = (d[h] << 8 | d[h] >>> 24) & 16711935 | (d[h] << 24 | d[h] >>> 8) & 4278255360;
            var m = this._X = [
              d[0],
              d[3] << 16 | d[2] >>> 16,
              d[1],
              d[0] << 16 | d[3] >>> 16,
              d[2],
              d[1] << 16 | d[0] >>> 16,
              d[3],
              d[2] << 16 | d[1] >>> 16
            ], E = this._C = [
              d[2] << 16 | d[2] >>> 16,
              d[0] & 4294901760 | d[1] & 65535,
              d[3] << 16 | d[3] >>> 16,
              d[1] & 4294901760 | d[2] & 65535,
              d[0] << 16 | d[0] >>> 16,
              d[2] & 4294901760 | d[3] & 65535,
              d[1] << 16 | d[1] >>> 16,
              d[3] & 4294901760 | d[0] & 65535
            ];
            this._b = 0;
            for (var h = 0; h < 4; h++)
              x.call(this);
            for (var h = 0; h < 8; h++)
              E[h] ^= m[h + 4 & 7];
            if (p) {
              var D = p.words, b = D[0], A = D[1], g = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, N = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, I = g >>> 16 | N & 4294901760, B = N << 16 | g & 65535;
              E[0] ^= g, E[1] ^= I, E[2] ^= N, E[3] ^= B, E[4] ^= g, E[5] ^= I, E[6] ^= N, E[7] ^= B;
              for (var h = 0; h < 4; h++)
                x.call(this);
            }
          },
          _doProcessBlock: function(d, p) {
            var h = this._X;
            x.call(this), o[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, o[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, o[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, o[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var m = 0; m < 4; m++)
              o[m] = (o[m] << 8 | o[m] >>> 24) & 16711935 | (o[m] << 24 | o[m] >>> 8) & 4278255360, d[p + m] ^= o[m];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function x() {
          for (var d = this._X, p = this._C, h = 0; h < 8; h++)
            f[h] = p[h];
          p[0] = p[0] + 1295307597 + this._b | 0, p[1] = p[1] + 3545052371 + (p[0] >>> 0 < f[0] >>> 0 ? 1 : 0) | 0, p[2] = p[2] + 886263092 + (p[1] >>> 0 < f[1] >>> 0 ? 1 : 0) | 0, p[3] = p[3] + 1295307597 + (p[2] >>> 0 < f[2] >>> 0 ? 1 : 0) | 0, p[4] = p[4] + 3545052371 + (p[3] >>> 0 < f[3] >>> 0 ? 1 : 0) | 0, p[5] = p[5] + 886263092 + (p[4] >>> 0 < f[4] >>> 0 ? 1 : 0) | 0, p[6] = p[6] + 1295307597 + (p[5] >>> 0 < f[5] >>> 0 ? 1 : 0) | 0, p[7] = p[7] + 3545052371 + (p[6] >>> 0 < f[6] >>> 0 ? 1 : 0) | 0, this._b = p[7] >>> 0 < f[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var m = d[h] + p[h], E = m & 65535, D = m >>> 16, b = ((E * E >>> 17) + E * D >>> 15) + D * D, A = ((m & 4294901760) * m | 0) + ((m & 65535) * m | 0);
            c[h] = b ^ A;
          }
          d[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, d[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, d[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, d[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, d[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, d[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, d[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, d[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
        }
        n.Rabbit = a._createHelper(l);
      }(), r.Rabbit;
    });
  }(Jn)), Jn.exports;
}
var e0 = { exports: {} }, ka;
function vx() {
  return ka || (ka = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Bt(), Ot(), Et(), Ce());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.StreamCipher, u = n.algo, o = [], f = [], c = [], l = u.RabbitLegacy = a.extend({
          _doReset: function() {
            var d = this._key.words, p = this.cfg.iv, h = this._X = [
              d[0],
              d[3] << 16 | d[2] >>> 16,
              d[1],
              d[0] << 16 | d[3] >>> 16,
              d[2],
              d[1] << 16 | d[0] >>> 16,
              d[3],
              d[2] << 16 | d[1] >>> 16
            ], m = this._C = [
              d[2] << 16 | d[2] >>> 16,
              d[0] & 4294901760 | d[1] & 65535,
              d[3] << 16 | d[3] >>> 16,
              d[1] & 4294901760 | d[2] & 65535,
              d[0] << 16 | d[0] >>> 16,
              d[2] & 4294901760 | d[3] & 65535,
              d[1] << 16 | d[1] >>> 16,
              d[3] & 4294901760 | d[0] & 65535
            ];
            this._b = 0;
            for (var E = 0; E < 4; E++)
              x.call(this);
            for (var E = 0; E < 8; E++)
              m[E] ^= h[E + 4 & 7];
            if (p) {
              var D = p.words, b = D[0], A = D[1], g = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, N = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, I = g >>> 16 | N & 4294901760, B = N << 16 | g & 65535;
              m[0] ^= g, m[1] ^= I, m[2] ^= N, m[3] ^= B, m[4] ^= g, m[5] ^= I, m[6] ^= N, m[7] ^= B;
              for (var E = 0; E < 4; E++)
                x.call(this);
            }
          },
          _doProcessBlock: function(d, p) {
            var h = this._X;
            x.call(this), o[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, o[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, o[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, o[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var m = 0; m < 4; m++)
              o[m] = (o[m] << 8 | o[m] >>> 24) & 16711935 | (o[m] << 24 | o[m] >>> 8) & 4278255360, d[p + m] ^= o[m];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function x() {
          for (var d = this._X, p = this._C, h = 0; h < 8; h++)
            f[h] = p[h];
          p[0] = p[0] + 1295307597 + this._b | 0, p[1] = p[1] + 3545052371 + (p[0] >>> 0 < f[0] >>> 0 ? 1 : 0) | 0, p[2] = p[2] + 886263092 + (p[1] >>> 0 < f[1] >>> 0 ? 1 : 0) | 0, p[3] = p[3] + 1295307597 + (p[2] >>> 0 < f[2] >>> 0 ? 1 : 0) | 0, p[4] = p[4] + 3545052371 + (p[3] >>> 0 < f[3] >>> 0 ? 1 : 0) | 0, p[5] = p[5] + 886263092 + (p[4] >>> 0 < f[4] >>> 0 ? 1 : 0) | 0, p[6] = p[6] + 1295307597 + (p[5] >>> 0 < f[5] >>> 0 ? 1 : 0) | 0, p[7] = p[7] + 3545052371 + (p[6] >>> 0 < f[6] >>> 0 ? 1 : 0) | 0, this._b = p[7] >>> 0 < f[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var m = d[h] + p[h], E = m & 65535, D = m >>> 16, b = ((E * E >>> 17) + E * D >>> 15) + D * D, A = ((m & 4294901760) * m | 0) + ((m & 65535) * m | 0);
            c[h] = b ^ A;
          }
          d[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, d[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, d[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, d[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, d[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, d[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, d[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, d[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
        }
        n.RabbitLegacy = a._createHelper(l);
      }(), r.RabbitLegacy;
    });
  }(e0)), e0.exports;
}
var t0 = { exports: {} }, wa;
function Bx() {
  return wa || (wa = 1, function(e, t) {
    (function(r, n, s) {
      e.exports = n(ue(), Bt(), Ot(), Et(), Ce());
    })(re, function(r) {
      return function() {
        var n = r, s = n.lib, a = s.BlockCipher, u = n.algo;
        const o = 16, f = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], c = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var l = {
          pbox: [],
          sbox: []
        };
        function x(E, D) {
          let b = D >> 24 & 255, A = D >> 16 & 255, g = D >> 8 & 255, N = D & 255, I = E.sbox[0][b] + E.sbox[1][A];
          return I = I ^ E.sbox[2][g], I = I + E.sbox[3][N], I;
        }
        function d(E, D, b) {
          let A = D, g = b, N;
          for (let I = 0; I < o; ++I)
            A = A ^ E.pbox[I], g = x(E, A) ^ g, N = A, A = g, g = N;
          return N = A, A = g, g = N, g = g ^ E.pbox[o], A = A ^ E.pbox[o + 1], { left: A, right: g };
        }
        function p(E, D, b) {
          let A = D, g = b, N;
          for (let I = o + 1; I > 1; --I)
            A = A ^ E.pbox[I], g = x(E, A) ^ g, N = A, A = g, g = N;
          return N = A, A = g, g = N, g = g ^ E.pbox[1], A = A ^ E.pbox[0], { left: A, right: g };
        }
        function h(E, D, b) {
          for (let B = 0; B < 4; B++) {
            E.sbox[B] = [];
            for (let y = 0; y < 256; y++)
              E.sbox[B][y] = c[B][y];
          }
          let A = 0;
          for (let B = 0; B < o + 2; B++)
            E.pbox[B] = f[B] ^ D[A], A++, A >= b && (A = 0);
          let g = 0, N = 0, I = 0;
          for (let B = 0; B < o + 2; B += 2)
            I = d(E, g, N), g = I.left, N = I.right, E.pbox[B] = g, E.pbox[B + 1] = N;
          for (let B = 0; B < 4; B++)
            for (let y = 0; y < 256; y += 2)
              I = d(E, g, N), g = I.left, N = I.right, E.sbox[B][y] = g, E.sbox[B][y + 1] = N;
          return !0;
        }
        var m = u.Blowfish = a.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var E = this._keyPriorReset = this._key, D = E.words, b = E.sigBytes / 4;
              h(l, D, b);
            }
          },
          encryptBlock: function(E, D) {
            var b = d(l, E[D], E[D + 1]);
            E[D] = b.left, E[D + 1] = b.right;
          },
          decryptBlock: function(E, D) {
            var b = p(l, E[D], E[D + 1]);
            E[D] = b.left, E[D + 1] = b.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        n.Blowfish = a._createHelper(m);
      }(), r.Blowfish;
    });
  }(t0)), t0.exports;
}
(function(e, t) {
  (function(r, n, s) {
    e.exports = n(ue(), an(), ax(), ix(), Bt(), ux(), Ot(), Fu(), X0(), ox(), Pu(), cx(), lx(), fx(), Z0(), dx(), Et(), Ce(), hx(), Ex(), xx(), mx(), px(), bx(), Tx(), Ax(), _x(), gx(), Cx(), Dx(), Sx(), Nx(), Ix(), vx(), Bx());
  })(re, function(r) {
    return r;
  });
})(Lu);
var Ox = Lu.exports;
const yx = /* @__PURE__ */ Mt(Ox), Rx = { class: "stock-overlay" }, Lx = { class: "stock-symbol" }, Fx = ["href"], Px = { key: 1 }, kx = { class: "stock-company" }, wx = { class: "stock-price-block" }, Mx = { class: "stock-price" }, Hx = { class: "stock-market-cap gap-[12px] !flex-row justify-between" }, Ux = { class: "inline-flex !text-[16px]" }, qx = { class: "inline-flex !text-[16px]" }, Yx = { class: "stock-market-cap" }, $x = { class: "flex mb-[4px] justify-between items-center text-[16px]" }, Wx = { class: "text-[16px]" }, zx = { class: "text-[16px]" }, Gx = { class: "stock-market-balance mb-[4px] text-[16px]" }, Vx = {
  key: 0,
  class: "stock-market-cap !pt-[12px] pb-[0]"
}, Ma = /* @__PURE__ */ Nt({
  __name: "referenced-stocks-overlay",
  props: {
    market: {},
    symbol: {},
    name: {},
    lastPrice: {},
    netChange: {},
    percentChange: {},
    day_low: {},
    day_high: {},
    volume: {},
    float: {},
    onClickButtonHandler: { type: Function },
    buttonText: {}
  },
  setup(e) {
    function t(a) {
      return a >= 1e9 ? (a / 1e9).toFixed(2) + "B" : a >= 1e6 ? (a / 1e6).toFixed(2) + "M" : a.toString();
    }
    const r = sr(() => (e.lastPrice - e.day_low) / (e.day_high - e.day_low) * 100), n = $e(!1), s = sr(() => window.location.pathname);
    return ft(() => {
      document.getElementById(e.symbol) && (n.value = !0);
    }), (a, u) => (pe(), ve("div", Rx, [
      u[6] || (u[6] = X("svg", {
        class: "overlay-arrow",
        width: "100",
        height: "66",
        viewBox: "0 0 100 66",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        X("path", {
          d: "M50 5L93.3013 62H6.69873L50 5Z",
          fill: "white"
        }),
        X("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M50 0.0406494L99.3477 65H0.652222L50 0.0406494ZM50 5L6.69872 62H93.3013L50 5Z",
          fill: "#C1C7D0"
        }),
        X("path", {
          d: "M0 59H100V66H0V59Z",
          fill: "white"
        })
      ], -1)),
      X("button", {
        class: "stock-icon-close",
        onClick: u[0] || (u[0] = (o) => a.$emit("close"))
      }, u[2] || (u[2] = [
        X("svg", {
          class: "w-[14px] h-[14px]",
          width: "20",
          height: "20",
          viewBox: "0 0 21 22",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          X("path", {
            d: "M1.4043 20.2886L19.7891 1.9038",
            stroke: "black",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }),
          X("path", {
            d: "M1.21094 1.71143L19.5957 20.0962",
            stroke: "black",
            "stroke-width": "2",
            "stroke-linecap": "round"
          })
        ], -1)
      ])),
      X("span", Lx, [
        n.value ? (pe(), ve("a", {
          key: 0,
          href: s.value + "#" + a.symbol
        }, [
          X("b", null, Se(a.symbol), 1)
        ], 8, Fx)) : (pe(), ve("b", Px, Se(a.symbol), 1)),
        ot(" - " + Se(a.market === "NSC" ? "NASDAQ" : "NYSE"), 1)
      ]),
      X("span", kx, Se(a.name), 1),
      X("div", wx, [
        X("span", Mx, "$" + Se(a.lastPrice.toFixed(2)), 1),
        X("span", {
          class: gt([
            "stock-price-change",
            a.netChange > 0 ? "positive" : a.netChange < 0 ? "negative" : ""
          ])
        }, Se(a.netChange > 0 ? "+" : "") + Se(a.netChange.toFixed(2)) + " (" + Se(a.percentChange > 0 ? "+" : "") + Se(a.percentChange.toFixed(2)) + "%) ", 3)
      ]),
      X("span", Hx, [
        X("div", Ux, [
          u[3] || (u[3] = X("b", null, "Volume: ", -1)),
          ot(" " + Se(t(a.volume)), 1)
        ]),
        X("div", qx, [
          u[4] || (u[4] = X("b", null, "Float: ", -1)),
          ot(" " + Se(t(a.float)), 1)
        ])
      ]),
      X("span", Yx, [
        X("div", $x, [
          X("b", Wx, "$" + Se(a.day_low.toFixed(2)), 1),
          u[5] || (u[5] = X("b", null, "Day Low/High", -1)),
          X("b", zx, "$" + Se(a.day_high.toFixed(2)), 1)
        ]),
        X("div", Gx, [
          X("span", {
            class: "stock-market-balance-ball",
            style: Ha({ left: r.value + "%" })
          }, null, 4)
        ])
      ]),
      a.onClickButtonHandler ? (pe(), ve("span", Vx, [
        X("button", {
          onClick: u[1] || (u[1] = //@ts-ignore
          (...o) => a.onClickButtonHandler && a.onClickButtonHandler(...o)),
          class: "bg-blue-300 hover:bg-blue-500 text-white py-[8px] px-[12px] rounded-[8px] text-[18px] font-medium text-center font-semibold"
        }, Se(a.buttonText), 1)
      ])) : bt("", !0)
    ]));
  }
});
function Qx(e) {
  return Ku() ? (Xu(e), !0) : !1;
}
function g0(e) {
  return typeof e == "function" ? e() : Zu(e);
}
const jx = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function Kx(e, t) {
  var r;
  if (typeof e == "number")
    return e + t;
  const n = ((r = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : r[0]) || "", s = e.slice(n.length), a = Number.parseFloat(n) + t;
  return Number.isNaN(a) ? e : a + s;
}
const ku = jx ? window : void 0;
function Xx() {
  const e = $e(!1), t = eo();
  return t && ft(() => {
    e.value = !0;
  }, t), e;
}
function Zx(e) {
  const t = Xx();
  return sr(() => (t.value, !!e()));
}
function Kt(e, t = {}) {
  const { window: r = ku } = t, n = Zx(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let s;
  const a = $e(!1), u = (c) => {
    a.value = c.matches;
  }, o = () => {
    s && ("removeEventListener" in s ? s.removeEventListener("change", u) : s.removeListener(u));
  }, f = Ju(() => {
    n.value && (o(), s = r.matchMedia(g0(e)), "addEventListener" in s ? s.addEventListener("change", u) : s.addListener(u), a.value = s.matches);
  });
  return Qx(() => {
    f(), o(), s = void 0;
  }), a;
}
function Jx(e, t = {}) {
  function r(l, x) {
    let d = g0(e[g0(l)]);
    return x != null && (d = Kx(d, x)), typeof d == "number" && (d = `${d}px`), d;
  }
  const { window: n = ku, strategy: s = "min-width" } = t;
  function a(l) {
    return n ? n.matchMedia(l).matches : !1;
  }
  const u = (l) => Kt(() => `(min-width: ${r(l)})`, t), o = (l) => Kt(() => `(max-width: ${r(l)})`, t), f = Object.keys(e).reduce((l, x) => (Object.defineProperty(l, x, {
    get: () => s === "min-width" ? u(x) : o(x),
    enumerable: !0,
    configurable: !0
  }), l), {});
  function c() {
    const l = Object.keys(e).map((x) => [x, u(x)]);
    return sr(() => l.filter(([, x]) => x.value).map(([x]) => x));
  }
  return Object.assign(f, {
    greaterOrEqual: u,
    smallerOrEqual: o,
    greater(l) {
      return Kt(() => `(min-width: ${r(l, 0.1)})`, t);
    },
    smaller(l) {
      return Kt(() => `(max-width: ${r(l, -0.1)})`, t);
    },
    between(l, x) {
      return Kt(() => `(min-width: ${r(l)}) and (max-width: ${r(x, -0.1)})`, t);
    },
    isGreater(l) {
      return a(`(min-width: ${r(l, 0.1)})`);
    },
    isGreaterOrEqual(l) {
      return a(`(min-width: ${r(l)})`);
    },
    isSmaller(l) {
      return a(`(max-width: ${r(l, -0.1)})`);
    },
    isSmallerOrEqual(l) {
      return a(`(max-width: ${r(l)})`);
    },
    isInBetween(l, x) {
      return a(`(min-width: ${r(l)}) and (max-width: ${r(x, -0.1)})`);
    },
    current: c,
    active() {
      const l = c();
      return sr(() => l.value.length === 0 ? "" : l.value.at(-1));
    }
  });
}
const e2 = {
  key: 0,
  class: "referenced-symbols"
}, t2 = { class: "symbols-list" }, r2 = ["onClick"], n2 = { class: "symbol-link" }, s2 = {
  key: 0,
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#4caf50"
}, a2 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#f44336"
}, i2 = { key: 1 }, N2 = /* @__PURE__ */ Nt({
  __name: "referenced-stocks",
  props: {
    symbols: {},
    onClickButtonHandler: { type: Function },
    buttonText: {}
  },
  setup(e) {
    Me.extend($a), Me.extend(za), Me.locale("en"), Me.tz.setDefault("America/New_York");
    const t = $e([]), r = to(
      Jx({
        lg: 1024
      })
    ), n = $e(null), s = (a) => {
      r.isSmallerOrEqual("lg") && (n.value = a);
    };
    return ft(async () => {
      const a = Me(Date.now()).format("ddd, D MMM YYYY"), o = {
        secretToken: yx.MD5(a).toString()
      }, f = e.symbols.map(async (c) => {
        const l = {
          filter: `SYMBOL IN ('${c}')`,
          prevDay: !1,
          fields: "VOLUME, TRADES, FLOAT, SHORT_INTEREST,SHORT_INTEREST_RATIO, SYMBOL, NAME, LAST, NET_CHG, PC_CHG, MARKET_CAP, HIGH_52W, LOW_52W, LOW, HIGH, DAY_RANGE, MARKET"
        };
        return await me.post("https://app02.stockstotrade.com:8094/v1.1/symbols", l, {
          headers: o
        });
      });
      Promise.all(f).then((c) => {
        c.forEach((l) => {
          l.data[0] && t.value.push(l.data[0]);
        });
      });
    }), (a, u) => t.value && t.value.length > 0 ? (pe(), ve("div", e2, [
      u[3] || (u[3] = X("h2", { class: "referenced-symbols-title" }, "In this article", -1)),
      X("ul", t2, [
        (pe(!0), ve(fs, null, ro(t.value, (o) => (pe(), ve("li", {
          key: o.SYMBOL,
          class: "symbol-item",
          onClick: () => s(o)
        }, [
          X("span", n2, Se(o.SYMBOL), 1),
          X("span", {
            class: gt({
              "symbol-status": !0,
              up: o.PC_CHG > 0,
              down: o.PC_CHG < 0
            })
          }, [
            ot(Se(o.PC_CHG > 0 ? "+" : "") + Se(o.PC_CHG.toFixed(2)) + "% ", 1),
            o.PC_CHG !== 0 ? (pe(), ve(fs, { key: 0 }, [
              r.isGreater("lg") && o.PC_CHG > 0 ? (pe(), ve("svg", s2, u[1] || (u[1] = [
                X("path", {
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }, null, -1),
                X("path", { d: "M7 14l5-5 5 5z" }, null, -1)
              ]))) : r.isGreater("lg") ? (pe(), ve("svg", a2, u[2] || (u[2] = [
                X("path", {
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }, null, -1),
                X("path", { d: "M7 10l5 5 5-5z" }, null, -1)
              ]))) : bt("", !0)
            ], 64)) : bt("", !0)
          ], 2),
          r.isGreater("lg") ? (pe(), r0(Ma, {
            key: 0,
            market: o.MARKET,
            symbol: o.SYMBOL,
            name: o.NAME,
            lastPrice: o.LAST,
            netChange: o.NET_CHG,
            percentChange: o.PC_CHG,
            day_low: o.LOW,
            day_high: o.HIGH,
            volume: o.VOLUME,
            float: o.FLOAT,
            onClickButtonHandler: a.onClickButtonHandler
          }, null, 8, ["market", "symbol", "name", "lastPrice", "netChange", "percentChange", "day_low", "day_high", "volume", "float", "onClickButtonHandler"])) : bt("", !0)
        ], 8, r2))), 128))
      ]),
      r.isSmallerOrEqual("lg") && n.value ? (pe(), r0(Ma, {
        key: 0,
        class: "active",
        market: n.value.MARKET,
        symbol: n.value.SYMBOL,
        name: n.value.NAME,
        lastPrice: n.value.LAST,
        netChange: n.value.NET_CHG,
        percentChange: n.value.PC_CHG,
        day_low: n.value.LOW,
        day_high: n.value.HIGH,
        volume: n.value.VOLUME,
        float: n.value.FLOAT,
        onClose: u[0] || (u[0] = () => n.value = null),
        onClickButtonHandler: a.onClickButtonHandler,
        buttonText: a.buttonText
      }, null, 8, ["market", "symbol", "name", "lastPrice", "netChange", "percentChange", "day_low", "day_high", "volume", "float", "onClickButtonHandler", "buttonText"])) : bt("", !0)
    ])) : (pe(), ve("div", i2));
  }
}), I2 = /* @__PURE__ */ Nt({
  __name: "AdButlerGrid",
  props: {
    adId: { default: "" }
  },
  setup(e) {
    const t = $e(), r = e;
    ft(() => {
      if (window.AdButler)
        n();
      else {
        const s = document.createElement("script");
        s.async = !0, s.type = "text/javascript", s.src = "https://servedbyadbutler.com/app.js", t.value && (t.value.parentElement.prepend(s), n());
      }
    });
    const n = () => {
      const s = document.createElement("script"), a = `
	var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
	var abkw = window.abkw || '';
	var plc${r.adId} = window.plc${r.adId} || 0;
	(function(){
		var divs = document.querySelectorAll(".plc${r.adId}:not([id])");
		console.log({divs});
		var div = divs[divs.length-1];
		div.setAttribute("id", "placement_${r.adId}_"+plc${r.adId});
		AdButler.ads.push({handler: function(opt){ AdButler.register(181458, ${r.adId}, [0,0], 'placement_${r.adId}_'+opt.place, opt); }, opt: { place: plc${r.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' }});
	})();`;
      s.innerHTML = a, t.value && t.value.parentNode.appendChild(s);
    };
    return (s, a) => (pe(), ve("div", null, [
      X("div", {
        class: gt(`plc${s.adId}`),
        ref_key: "adPlacement",
        ref: t
      }, null, 2)
    ]));
  }
}), v2 = /* @__PURE__ */ Nt({
  __name: "AdButlerModal",
  props: {
    adId: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = $e(), n = e, s = t, a = () => {
      s("close", "closing");
    }, u = $e(!0);
    ft(() => {
      if (window.AdButler)
        o();
      else {
        const f = document.createElement("script");
        f.async = !0, f.type = "text/javascript", f.src = "https://servedbyadbutler.com/app.js", r.value && (r.value.parentElement.prepend(f), o());
      }
    });
    const o = () => {
      const f = document.createElement("script"), c = `
      var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
      var abkw = window.abkw || '';
      var plc${n.adId} = window.plc${n.adId} || 0;
      (function () {
          var divs = document.querySelectorAll(".plc${n.adId}:not([id])");
          var div = divs[divs.length - 1];
          div.setAttribute("id", "placement_${n.adId}_" + plc${n.adId});
          AdButler.ads.push({ handler: function (opt) { AdButler.register(181458, ${n.adId}, [0, 0], 'placement_${n.adId}_' + opt.place, opt); }, opt: { place: plc${n.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' } });
      })();
    `;
      f.innerHTML = c, r.value && r.value.parentNode.appendChild(f);
    };
    return C0(r, async (f) => {
      f && await setTimeout(() => {
        const c = document.querySelector(".adblutler-modal-close"), l = document.querySelectorAll(".modal-ad a");
        if (!c) {
          console.log("AdButler Close not found", c), s("close", "closing");
          return;
        }
        u.value = !1;
        const x = document.querySelector(".information-subscribe-button");
        x && x?.addEventListener("click", () => {
          s("close", "closing");
        }), c?.addEventListener("click", () => {
          s("close", "closing");
        }), [...l].forEach((d) => {
          d.setAttribute("target", "_blank");
        });
      }, 500);
    }), (f, c) => (pe(), ve("div", {
      class: "modal-ad-container",
      style: Ha({ display: u.value ? "none" : "block" })
    }, [
      X("div", {
        class: gt(`plc${f.adId} modal-ad`),
        ref_key: "adButlerModal",
        ref: r
      }, null, 2),
      X("div", {
        class: "ad-modal-overlay",
        onClick: a
      })
    ], 4));
  }
}), B2 = /* @__PURE__ */ Nt({
  __name: "AdButlerItem",
  props: {
    isEndOfArticle: {
      type: Boolean,
      default: !1
    },
    adId: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const t = $e();
    ft(() => {
      if (window.AdButler)
        r();
      else {
        const n = document.createElement("script");
        n.async = !0, n.type = "text/javascript", n.src = "https://servedbyadbutler.com/app.js", t.value && (t.value.parentElement.prepend(n), r());
      }
    });
    const r = () => {
      const n = document.createElement("script"), s = `
      var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
      var abkw = window.abkw || '';
      var plc${e.adId} = window.plc${e.adId} || 0;
      (function () {
          var divs = document.querySelectorAll(".plc${e.adId}:not([id])");
          var div = divs[divs.length - 1];
          div.setAttribute("id", "placement_${e.adId}_" + plc${e.adId});
          AdButler.ads.push({ handler: function (opt) { AdButler.register(181458, ${e.adId}, [0, 0], 'placement_${e.adId}_' + opt.place, opt); }, opt: { place: plc${e.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' } });
      })();
    `;
      n.innerHTML = s, t.value && t.value.parentNode.appendChild(n);
    };
    return C0(t, async (n, s) => {
      if (n && e.isEndOfArticle) {
        const a = `.plc${e.adId} .related-post-info div p`;
        let u = 0;
        const o = setInterval(() => {
          const f = document.querySelector(a);
          (f || f && u > 10) && (f.innerHTML = f.innerText, clearInterval(o)), u++;
        }, 500);
      }
    }), (n, s) => {
      const a = no("Divider");
      return pe(), ve("div", null, [
        e.isEndOfArticle ? (pe(), r0(a, { key: 0 })) : bt("", !0),
        X("div", {
          class: gt(`plc${e.adId}`),
          ref_key: "adPlacement",
          ref: t
        }, null, 2)
      ]);
    };
  }
}), u2 = "/images/close_dark_blue.svg", o2 = { class: "ad-buttler-ribbon-outer-wrapper" }, c2 = { class: "xl:container" }, O2 = /* @__PURE__ */ Nt({
  __name: "AdButlerBanner",
  props: {
    adId: {},
    hasSidebar: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = $e(), n = e, s = t, a = () => {
      s("close", "closing");
    };
    ft(() => {
      if (window.AdButler)
        u();
      else {
        const o = document.createElement("script");
        o.async = !0, o.type = "text/javascript", o.src = "https://servedbyadbutler.com/app.js", r.value && (r.value.parentElement.prepend(o), u());
      }
    });
    const u = () => {
      const o = document.createElement("script"), f = `
      var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
      var abkw = window.abkw || '';
      var plc${n.adId} = window.plc${n.adId} || 0;
      (function () {
          var divs = document.querySelectorAll(".plc${n.adId}:not([id])");
          var div = divs[divs.length - 1];
          div.setAttribute("id", "placement_${n.adId}_" + plc${n.adId});
          AdButler.ads.push({ handler: function (opt) { AdButler.register(181458, ${n.adId}, [0, 0], 'placement_${n.adId}_' + opt.place, opt); }, opt: { place: plc${n.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' } });
      })();
    `;
      o.innerHTML = f, r.value && r.value.parentNode.appendChild(o);
    };
    return (o, f) => (pe(), ve("div", o2, [
      X("div", {
        class: gt(["ad-buttler-ribbon-container w-full", {
          "has-sidebar": o.hasSidebar
        }])
      }, [
        X("div", c2, [
          X("div", {
            class: gt(`plc${o.adId} `),
            ref_key: "adButlerBanner",
            ref: r
          }, null, 2)
        ])
      ], 2),
      X("button", {
        onClick: a,
        class: "adbutler-ribbon-button-close"
      }, f[0] || (f[0] = [
        X("img", {
          src: u2,
          alt: "close button ad ribbon",
          class: "w-[20px] h-[20px]"
        }, null, -1)
      ]))
    ]));
  }
});
export {
  O2 as AdButlerBanner,
  I2 as AdButlerGrid,
  B2 as AdButlerItem,
  v2 as AdButlerModal,
  S2 as CookieConsent,
  N2 as ReferencedStocks,
  b2 as calculateReadingTime,
  C1 as checkCookieConsent,
  x2 as dateFormat,
  C2 as extractStockSymbols,
  _2 as filterCategory,
  E2 as formatCommentDate,
  A2 as formatLink,
  g2 as formatNumber,
  g1 as getCookie,
  m2 as isResolution,
  h2 as isWithinTimeRanges,
  T2 as shuffleArray,
  D2 as stockSymbolMatcherRegex,
  p2 as truncateText
};
